// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_entitlement.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { App } from "./app";
import { AppGroup } from "./app_group";
import { GrantReason } from "./app_entitlement_user_binding_reasons";
import { AppUser } from "./app_user";
import { UserRef } from "../../user/v1/user";
import { AppUserRef } from "./app_user";
import { AppUserExpandMask } from "./app_user";
import { AppUserView } from "./app_user";
import { ActorObjectPermissions } from "../../iam/v1/authorization";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { ProvisionPolicy } from "../../policy/v1/policy";
import { Duration } from "../../../../google/protobuf/duration";
import { Empty } from "../../../../google/protobuf/empty";
import { AppEntitlementUserBinding } from "./app_entitlement_user_binding";
import { AppEntitlementUserBindingRef } from "./app_refs";
import { User } from "../../user/v1/user";
import { PolicyRef } from "../../policy/v1/policy";
import { Facets } from "../../search/v1/facet";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Any } from "../../../../google/protobuf/any";
import { AppEntitlementRef } from "./app_refs";
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementUserBindingDestinationsRequest
 */
export interface SearchAppEntitlementUserBindingDestinationsRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string app_user_id = 3
     */
    appUserId: string;
    /**
     * @generated from protobuf field: int32 page_size = 4
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 5
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementUserBindingDestinationsResponse
 */
export interface SearchAppEntitlementUserBindingDestinationsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef list = 1
     */
    list: AppEntitlementRef[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementCorrelation
 */
export interface AppEntitlementCorrelation {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementRef app_entitlement = 1
     */
    appEntitlement?: AppEntitlementRef;
    /**
     * @generated from protobuf field: optional double distance = 2
     */
    distance?: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementCorrelationForAccessProfileRequest
 */
export interface SearchAppEntitlementCorrelationForAccessProfileRequest {
    /**
     * @generated from protobuf field: string access_profile_id = 1
     */
    accessProfileId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 4
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string app_ids = 5
     */
    appIds: string[];
    /**
     * @generated from protobuf field: repeated string resource_type_ids = 6
     */
    resourceTypeIds: string[];
    /**
     * @generated from protobuf field: bool exclude_immutable = 7
     */
    excludeImmutable: boolean;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef excluded_entitlement_refs = 8
     */
    excludedEntitlementRefs: AppEntitlementRef[];
    /**
     * @generated from protobuf oneof: recommendation
     */
    recommendation: {
        oneofKind: "all";
        /**
         * @generated from protobuf field: bool all = 10
         */
        all: boolean;
    } | {
        oneofKind: "additions";
        /**
         * @generated from protobuf field: bool additions = 11
         */
        additions: boolean;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementCorrelationForAccessProfileResponse
 */
export interface SearchAppEntitlementCorrelationForAccessProfileResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementCorrelation list = 1
     */
    list: AppEntitlementCorrelation[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementUserBindingSourcesRequest
 */
export interface SearchAppEntitlementUserBindingSourcesRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string app_user_id = 3
     */
    appUserId: string;
    /**
     * @generated from protobuf field: int32 page_size = 4
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 5
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementUserBindingSourcesResponse
 */
export interface SearchAppEntitlementUserBindingSourcesResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef list = 1
     */
    list: AppEntitlementRef[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.CreateAutomationRequest
 */
export interface CreateAutomationRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementAutomation automation = 3
     */
    automation?: AppEntitlementAutomation;
}
/**
 * @generated from protobuf message c1.api.app.v1.CreateAutomationResponse
 */
export interface CreateAutomationResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementAutomation automation = 1
     */
    automation?: AppEntitlementAutomation;
}
/**
 * @generated from protobuf message c1.api.app.v1.DeleteAutomationRequest
 */
export interface DeleteAutomationRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.DeleteAutomationResponse
 */
export interface DeleteAutomationResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceCountAncestorsRequest
 */
export interface AppEntitlementSearchServiceCountAncestorsRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: uint32 depth = 3
     */
    depth: number;
    /**
     * @generated from protobuf field: bool leaves_only = 4
     */
    leavesOnly: boolean; // only returns nodes at the depth requested for (`depth`).
    /**
     * @generated from protobuf field: bool system_created_proxy_bindings_only = 5
     */
    systemCreatedProxyBindingsOnly: boolean; // only follows proxy bindings created by the c1 system.
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceCountAncestorsResponse
 */
export interface AppEntitlementSearchServiceCountAncestorsResponse {
    /**
     * @generated from protobuf field: int32 count = 1
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchAncestorsRequest
 */
export interface AppEntitlementSearchServiceSearchAncestorsRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: uint32 depth = 3
     */
    depth: number;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 4
     */
    expandMask?: AppEntitlementExpandMask;
    /**
     * @generated from protobuf field: bool leaves_only = 5
     */
    leavesOnly: boolean; // only returns nodes at the depth requested for (`depth`).
    /**
     * @generated from protobuf field: bool system_created_proxy_bindings_only = 6
     */
    systemCreatedProxyBindingsOnly: boolean; // only follows proxy bindings created by the c1 system.
    /**
     * @generated from protobuf field: int32 page_size = 7
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 8
     */
    pageToken: string;
    /**
     * @generated from protobuf field: bool only_ancestors_without_descendants = 9
     */
    onlyAncestorsWithoutDescendants: boolean; // only returns ancestors that have no descendants.
}
/**
 * @generated from protobuf message c1.api.app.v1.AncestralBinding
 */
export interface AncestralBinding {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementView ancestor_entitlement = 1
     */
    ancestorEntitlement?: AppEntitlementView;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementView descendant_entitlements = 2
     */
    descendantEntitlements: AppEntitlementView[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AncestralBindingRef
 */
export interface AncestralBindingRef {
    /**
     * @generated from protobuf field: string ancestor_app_id = 1
     */
    ancestorAppId: string;
    /**
     * @generated from protobuf field: string ancestor_app_entitlement_id = 2
     */
    ancestorAppEntitlementId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchAncestorsResponse
 */
export interface AppEntitlementSearchServiceSearchAncestorsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AncestralBinding list = 1
     */
    list: AncestralBinding[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchCountRequest
 */
export interface AppEntitlementSearchServiceSearchCountRequest {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementSearchServiceSearchRequest filter = 1
     */
    filter?: AppEntitlementSearchServiceSearchRequest;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchCountResponse
 */
export interface AppEntitlementSearchServiceSearchCountResponse {
    /**
     * @generated from protobuf field: int64 count = 1
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchExpiringAccessForUserRequest
 */
export interface AppEntitlementSearchServiceSearchExpiringAccessForUserRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 4
     */
    expandMask?: AppEntitlementExpandMask;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expires_before = 5
     */
    expiresBefore?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementWithUserBinding
 */
export interface AppEntitlementWithUserBinding {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementView entitlement = 1
     */
    entitlement?: AppEntitlementView;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserView app_entitlement_user_binding = 2
     */
    appEntitlementUserBinding?: AppEntitlementUserView;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchExpiringAccessForUserResponse
 */
export interface AppEntitlementSearchServiceSearchExpiringAccessForUserResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementWithUserBinding list = 1
     */
    list: AppEntitlementWithUserBinding[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchGrantsRequest
 */
export interface AppEntitlementSearchServiceSearchGrantsRequest {
    /**
     * The pageSize where 0 <= pageSize <= 100. Values < 10 will be set to 10. A value of 0 returns the default page size (currently 25)
     *
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * The pageToken field.
     *
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * Control the array of expanded values that are filled out in the response to this request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 4
     */
    expandMask?: AppEntitlementExpandMask;
    /**
     * Search for grants contained in any of these apps.
     *
     * @generated from protobuf field: repeated string app_ids = 5
     */
    appIds: string[];
    /**
     * Search for grants that are granted to any of these app user ids.
     *
     * @generated from protobuf field: repeated string app_user_ids = 6
     */
    appUserIds: string[];
    /**
     * Search grants for given resource types.
     *
     * @generated from protobuf field: repeated string resource_type_ids = 7
     */
    resourceTypeIds: string[];
    /**
     * Search for grants within a resource.
     *
     * @generated from protobuf field: repeated string resource_ids = 8
     */
    resourceIds: string[];
    /**
     * Search for grants of an entitlement
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef entitlement_refs = 9
     */
    entitlementRefs: AppEntitlementRef[];
    /**
     * Search for grants of a user
     *
     * @generated from protobuf field: string user_id = 10
     */
    userId: string;
    /**
     * Filter for entitlements with these purposes (e.g., ASSIGNMENT for membership entitlements)
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementPurposeValue purpose = 11
     */
    purpose: AppEntitlementPurposeValue[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchGrantsResponse
 */
export interface AppEntitlementSearchServiceSearchGrantsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementWithUserBinding list = 1
     */
    list: AppEntitlementWithUserBinding[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchExpiringAccessForUserCountRequest
 */
export interface AppEntitlementSearchServiceSearchExpiringAccessForUserCountRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expires_before = 2
     */
    expiresBefore?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchExpiringAccessForUserCountResponse
 */
export interface AppEntitlementSearchServiceSearchExpiringAccessForUserCountResponse {
    /**
     * @generated from protobuf field: int64 count = 1
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.CountGrantsExpiringBeforeRequest
 */
export interface CountGrantsExpiringBeforeRequest {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expires_before = 1
     */
    expiresBefore?: Timestamp;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.CountGrantsExpiringBeforeResponse
 */
export interface CountGrantsExpiringBeforeResponse {
    /**
     * @generated from protobuf field: int64 count = 1
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchGrantsExpiringBeforeRequest
 */
export interface SearchGrantsExpiringBeforeRequest {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expires_before = 1
     */
    expiresBefore?: Timestamp;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 5
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchGrantsExpiringBeforeResponse
 */
export interface SearchGrantsExpiringBeforeResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementWithUserBinding list = 1
     */
    list: AppEntitlementWithUserBinding[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchTermsRequest
 */
export interface AppEntitlementSearchServiceSearchTermsRequest {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementSearchServiceSearchRequest search = 1
     */
    search?: AppEntitlementSearchServiceSearchRequest;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementSearchServiceSearchTermsRequest.TermType term = 2
     */
    term: AppEntitlementSearchServiceSearchTermsRequest_TermType;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: bool include_count = 4
     */
    includeCount: boolean;
}
/**
 * @generated from protobuf enum c1.api.app.v1.AppEntitlementSearchServiceSearchTermsRequest.TermType
 */
export enum AppEntitlementSearchServiceSearchTermsRequest_TermType {
    /**
     * @generated from protobuf enum value: UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: RESOURCE_TYPE = 1;
     */
    RESOURCE_TYPE = 1,
    /**
     * @generated from protobuf enum value: APPS = 2;
     */
    APPS = 2,
    /**
     * @generated from protobuf enum value: RISK_LEVEL = 3;
     */
    RISK_LEVEL = 3,
    /**
     * @generated from protobuf enum value: COMPLIANCE_FRAMEWORK = 4;
     */
    COMPLIANCE_FRAMEWORK = 4
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchTermsResponse
 */
export interface AppEntitlementSearchServiceSearchTermsResponse {
    /**
     * @generated from protobuf field: c1.api.search.v1.Facets facets = 1
     */
    facets?: Facets;
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * Search app entitlements by a variety of filters.
 *
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchRequest
 */
export interface AppEntitlementSearchServiceSearchRequest {
    /**
     * The pageSize where 0 <= pageSize <= 100. Values < 10 will be set to 10. A value of 0 returns the default page size (currently 25)
     *
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * The pageToken field.
     *
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * Query the app entitlements with a fuzzy search on display name and description.
     *
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * Exclude app entitlements from the results that are in these app IDs.
     *
     * @generated from protobuf field: repeated string exclude_app_ids = 4
     */
    excludeAppIds: string[];
    /**
     * Search for app entitlements contained in any of these apps.
     *
     * @generated from protobuf field: repeated string app_ids = 5
     */
    appIds: string[];
    /**
     * Control the array of expanded values that are filled out in the response to this request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 6
     */
    expandMask?: AppEntitlementExpandMask;
    /**
     * Exclude app entitlements from the results that these app users have granted.
     *
     * @generated from protobuf field: repeated string exclude_app_user_ids = 7
     */
    excludeAppUserIds: string[];
    /**
     * Search for app entitlements that are granted to any of these app user ids.
     *
     * @generated from protobuf field: repeated string app_user_ids = 8
     */
    appUserIds: string[];
    /**
     * Search for app entitlements that are for items with resources types that have matching names. Example names are "group", "role", and "app".
     *
     * @generated from protobuf field: repeated string resource_type_ids = 10
     */
    resourceTypeIds: string[];
    /**
     * Search for app entitlements with these risk levels.
     *
     * @generated from protobuf field: repeated string risk_level_ids = 11
     */
    riskLevelIds: string[];
    /**
     * Search for app entitlements that are part of these compliace frameworks.
     *
     * @generated from protobuf field: repeated string compliance_framework_ids = 12
     */
    complianceFrameworkIds: string[];
    /**
     * Search for app entitlements that belongs to these resources.
     *
     * @generated from protobuf field: repeated string resource_ids = 19
     */
    resourceIds: string[];
    /**
     * Restrict results to only those who have expiring app entitlement user bindings.
     *
     * @generated from protobuf field: bool only_get_expiring = 15
     */
    onlyGetExpiring: boolean;
    /**
     * Search for app entitlements that are being reviewed as part of this access review campaign.
     *
     * @generated from protobuf field: string access_review_id = 16
     */
    accessReviewId: string;
    /**
     * Search for app entitlements that have this alias (exact match).
     *
     * @generated from protobuf field: string alias = 17
     */
    alias: string;
    /**
     * Include deleted app entitlements, this includes app entitlements that have a deleted parent object (app, app resource, app resource type)
     *
     * @generated from protobuf field: bool include_deleted = 18
     */
    includeDeleted: boolean;
    /**
     * @generated from protobuf field: bool is_automated = 20
     */
    isAutomated: boolean;
    /**
     * @generated from protobuf field: repeated string resource_trait_ids = 21
     */
    resourceTraitIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef refs = 22
     */
    refs: AppEntitlementRef[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementMembershipType membership_type = 24
     */
    membershipType: AppEntitlementMembershipType[];
    /**
     * @generated from protobuf field: repeated string exclude_resource_type_ids = 25
     */
    excludeResourceTypeIds: string[];
    /**
     * @generated from protobuf field: string source_connector_id = 26
     */
    sourceConnectorId: string;
    /**
     * @generated from protobuf field: string display_name = 27
     */
    displayName: string;
    /**
     * @generated from protobuf field: bool exclude_immutable = 28
     */
    excludeImmutable: boolean;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef excluded_entitlement_refs = 29
     */
    excludedEntitlementRefs: AppEntitlementRef[];
    /**
     * Search for app entitlements that use any of these policies.
     *
     * @generated from protobuf field: repeated c1.api.policy.v1.PolicyRef policy_refs = 30
     */
    policyRefs: PolicyRef[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchResponse
 */
export interface AppEntitlementSearchServiceSearchResponse {
    /**
     * List of app entitlement view objects.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementView list = 1
     */
    list: AppEntitlementView[];
    /**
     * List of related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size. The server returns one page of results and the nextPageToken until all results are retreived. To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
    /**
     * Deprecated
     *
     * @generated from protobuf field: c1.api.search.v1.Facets facets = 4
     */
    facets?: Facets;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementsWithOneOwnerRequest
 */
export interface SearchAppEntitlementsWithOneOwnerRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 3
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementWithOneOwner
 */
export interface AppEntitlementWithOneOwner {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementView entitlement = 1
     */
    entitlement?: AppEntitlementView;
    /**
     * @generated from protobuf field: c1.api.user.v1.User user = 2
     */
    user?: User;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementsWithOneOwnerResponse
 */
export interface SearchAppEntitlementsWithOneOwnerResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementWithOneOwner list = 1
     */
    list: AppEntitlementWithOneOwner[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementsWithDeactivatedOwnerRequest
 */
export interface SearchAppEntitlementsWithDeactivatedOwnerRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 3
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementWithDeactivatedOwner
 */
export interface AppEntitlementWithDeactivatedOwner {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementView entitlement = 1
     */
    entitlement?: AppEntitlementView;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.User entitlement_owners = 3
     */
    entitlementOwners: User[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementsWithDeactivatedOwnerResponse
 */
export interface SearchAppEntitlementsWithDeactivatedOwnerResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementWithDeactivatedOwner list = 1
     */
    list: AppEntitlementWithDeactivatedOwner[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementsForAppUserRequest
 */
export interface SearchAppEntitlementsForAppUserRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 3
     */
    expandMask?: AppEntitlementExpandMask;
    /**
     * @generated from protobuf field: string app_id = 4
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 5
     */
    appUserId: string;
    /**
     * @generated from protobuf field: repeated string resource_type_trait_ids = 6
     */
    resourceTypeTraitIds: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementsWithRevokableForAppUserRequest
 */
export interface SearchAppEntitlementsWithRevokableForAppUserRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string app_user_id = 3
     */
    appUserId: string;
    /**
     * @generated from protobuf field: string app_id = 4
     */
    appId: string;
    /**
     * @generated from protobuf field: string user_id = 5
     */
    userId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 6
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementsWithRevokableForAppUserResponse
 */
export interface SearchAppEntitlementsWithRevokableForAppUserResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementWithRevokable list = 1
     */
    list: AppEntitlementWithRevokable[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementWithRevokable
 */
export interface AppEntitlementWithRevokable {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementView app_entitlement = 1
     */
    appEntitlement?: AppEntitlementView;
    /**
     * @generated from protobuf field: bool is_revokable = 2
     */
    isRevokable: boolean;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchRequestableEntitlementsForUserRequest
 */
export interface SearchRequestableEntitlementsForUserRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string user_id = 3
     */
    userId: string;
    /**
     * @generated from protobuf field: string app_id = 4
     */
    appId: string;
    /**
     * @generated from protobuf field: string query = 8
     */
    query: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 10
     */
    expandMask?: AppEntitlementExpandMask;
    /**
     * @generated from protobuf field: c1.api.app.v1.SearchRequestableEntitlementsForUserSortBy sort_by = 11
     */
    sortBy: SearchRequestableEntitlementsForUserSortBy;
    /**
     * @generated from protobuf field: repeated string exclude_resource_type_ids = 12
     */
    excludeResourceTypeIds: string[];
    /**
     * @generated from protobuf field: repeated string include_resource_type_ids = 14
     */
    includeResourceTypeIds: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchRequestableEntitlementsForUserResponse
 */
export interface SearchRequestableEntitlementsForUserResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementView list = 1
     */
    list: AppEntitlementView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * Note only appUserId or userId can be used, not both at the same time.
 *
 * @generated from protobuf message c1.api.app.v1.RollupEntitlementsWithGrantsRequest
 */
export interface RollupEntitlementsWithGrantsRequest {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef entitlements = 1
     */
    entitlements: AppEntitlementRef[];
    /**
     * @generated from protobuf field: string app_user_id = 2
     */
    appUserId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementUserBindingRef refs = 5
     */
    refs: AppEntitlementUserBindingRef[];
    /**
     * @generated from protobuf field: string user_id = 6
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.RollupEntitlementsWithGrantsResponse
 */
export interface RollupEntitlementsWithGrantsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementUserBinding list = 1
     */
    list: AppEntitlementUserBinding[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * The app entitlement represents one permission in a downstream App (SAAS) that can be granted. For example, GitHub Read vs GitHub Write.
 *
 * @generated from protobuf message c1.api.app.v1.AppEntitlement
 */
export interface AppEntitlement {
    /**
     * The ID of the app that is associated with the app entitlement.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The unique ID for the App Entitlement.
     *
     * @generated from protobuf field: string id = 2
     */
    id: string;
    /**
     * The datetime, in RFC3339 format, of when the AppEntitlement was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the AppEntitlement was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the AppEntitlement was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5
     */
    deletedAt?: Timestamp;
    /**
     * The display name of the app entitlement.
     *
     * @generated from protobuf field: string display_name = 6
     */
    displayName: string;
    /**
     * The description of the app entitlement.
     *
     * @generated from protobuf field: string description = 7
     */
    description: string;
    /**
     * @generated from protobuf oneof: max_grant_duration
     */
    maxGrantDuration: {
        oneofKind: "durationUnset";
        /**
         * If grants for this app entitlement do not have a max duration this field is set with {}.
         *
         * @generated from protobuf field: google.protobuf.Empty duration_unset = 10
         */
        durationUnset: Empty;
    } | {
        oneofKind: "durationGrant";
        /**
         * If grants for this app entitlement have a max duration this field is set with the max duration in seconds.
         *
         * @generated from protobuf field: google.protobuf.Duration duration_grant = 11
         */
        durationGrant: Duration;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: string risk_level_value_id = 13
     */
    riskLevelValueId: string;
    /**
     * The IDs of different compliance frameworks associated with this app entitlement ex (SOX, HIPAA, PCI, etc.)
     *
     * @generated from protobuf field: repeated string compliance_framework_value_ids = 14
     */
    complianceFrameworkValueIds: string[];
    /**
     * The ID of the policy that will be used for grant tickets related to the app entitlement.
     *
     * @generated from protobuf field: string grant_policy_id = 17
     */
    grantPolicyId: string;
    /**
     * The ID of the policy that will be used for revoke tickets related to the app entitlement
     *
     * @generated from protobuf field: string revoke_policy_id = 18
     */
    revokePolicyId: string;
    /**
     * The ID of the policy that will be used for certify tickets related to the app entitlement.
     *
     * @generated from protobuf field: string certify_policy_id = 19
     */
    certifyPolicyId: string;
    /**
     * The ID of the policy that will be used for emergency access grant tasks.
     *
     * @generated from protobuf field: string emergency_grant_policy_id = 27
     */
    emergencyGrantPolicyId: string;
    /**
     * This enables tasks to be created in an emergency and use a selected emergency access policy.
     *
     * @generated from protobuf field: bool emergency_grant_enabled = 28
     */
    emergencyGrantEnabled: boolean;
    /**
     * The amount of grants open for this entitlement
     *
     * @generated from protobuf field: int64 grant_count = 20
     */
    grantCount: number;
    /**
     * The provision policy used by approved grant and revoke tasks.
     *
     * @generated from protobuf field: c1.api.policy.v1.ProvisionPolicy provisioner_policy = 21
     */
    provisionerPolicy?: ProvisionPolicy;
    /**
     * The ID of the app resource type that is associated with the app entitlement
     *
     * @generated from protobuf field: string app_resource_type_id = 22
     */
    appResourceTypeId: string;
    /**
     * The ID of the app resource that is associated with the app entitlement
     *
     * @generated from protobuf field: string app_resource_id = 23
     */
    appResourceId: string;
    /**
     * This field indicates if this is a system builtin entitlement.
     *
     * @generated from protobuf field: bool system_builtin = 24
     */
    systemBuiltin: boolean;
    /**
     * The slug is displayed as an oval next to the name in the frontend of C1, it tells you what permission the entitlement grants. See https://www.conductorone.com/docs/product/admin/entitlements/
     *
     * @generated from protobuf field: string slug = 25
     */
    slug: string;
    /**
     * The alias of the app entitlement used by Cone. Also exact-match queryable.
     *
     * @generated from protobuf field: string alias = 26
     */
    alias: string;
    /**
     * The fields that have been edited by a user.
     *
     * @generated from protobuf field: google.protobuf.FieldMask user_edited_mask = 29
     */
    userEditedMask?: FieldMask;
    /**
     * Flag to indicate if the app entitlement is manually managed.
     *
     * @generated from protobuf field: bool is_manually_managed = 30
     */
    isManuallyManaged: boolean;
    /**
     * Map to tell us which connector the entitlement came from.
     *
     * @generated from protobuf field: map<string, string> source_connector_ids = 31
     */
    sourceConnectorIds: {
        [key: string]: string;
    };
    /**
     * Flag to indicate if the app-level access request settings have been overridden for the entitlement
     *
     * @generated from protobuf field: bool override_access_requests_defaults = 32
     */
    overrideAccessRequestsDefaults: boolean;
    /**
     * Flag to indicate if app-level access request defaults have been applied to the entitlement
     *
     * @generated from protobuf field: bool default_values_applied = 33
     */
    defaultValuesApplied: boolean;
    /**
     * Flag to indicate whether automation (for adding users to entitlement based on rules) has been enabled.
     *
     * @generated from protobuf field: bool is_automation_enabled = 39
     */
    isAutomationEnabled: boolean;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementPurposeValue purpose = 40
     */
    purpose: AppEntitlementPurposeValue;
    /**
     * The deprovision policy used by approved revoke tasks (for access entitlements only).
     *
     * @generated from protobuf field: c1.api.policy.v1.ProvisionPolicy deprovisioner_policy = 41
     */
    deprovisionerPolicy?: ProvisionPolicy;
    /**
     * @generated from protobuf field: string match_baton_id = 42
     */
    matchBatonId: string;
    /**
     * The ID of the request schema associated with this app entitlement.
     *
     * @generated from protobuf field: string request_schema_id = 43
     */
    requestSchemaId: string;
}
/**
 * The app entitlement view contains the serialized app entitlement and paths to objects referenced by the app entitlement.
 *
 * @generated from protobuf message c1.api.app.v1.AppEntitlementView
 */
export interface AppEntitlementView {
    /**
     * The serialized app entitlement.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlement app_entitlement = 1
     */
    appEntitlement?: AppEntitlement;
    /**
     * JSONPATH expression indicating the location of the App object in the  array.
     *
     * @generated from protobuf field: string app_path = 2
     */
    appPath: string;
    /**
     * JSONPATH expression indicating the location of the App Resource object in the  array.
     *
     * @generated from protobuf field: string app_resource_type_path = 3
     */
    appResourceTypePath: string;
    /**
     * JSONPATH expression indicating the location of the App Resource Type object in the expanded array.
     *
     * @generated from protobuf field: string app_resource_path = 4
     */
    appResourcePath: string;
    /**
     * The permissions the current user has on this entitlement's parent resource.
     *
     * @generated from protobuf field: c1.api.iam.v1.ActorObjectPermissions object_permissions = 5
     */
    objectPermissions?: ActorObjectPermissions;
}
/**
 * @generated from protobuf message c1.api.app.v1.CatalogEntry
 */
export interface CatalogEntry {
    /**
     * The serialized app entitlement.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlement app_entitlement = 1
     */
    appEntitlement?: AppEntitlement;
    /**
     * JSONPATH expression indicating the location of the App object in the  array.
     *
     * @generated from protobuf field: string app_path = 2
     */
    appPath: string;
    /**
     * JSONPATH expression indicating the location of the App Resource object in the  array.
     *
     * @generated from protobuf field: string app_resource_type_path = 3
     */
    appResourceTypePath: string;
    /**
     * JSONPATH expression indicating the location of the App Resource Type object in the expanded array.
     *
     * @generated from protobuf field: string app_resource_path = 4
     */
    appResourcePath: string;
    /**
     * Count of grants of this entitlement to members of this catalog
     *
     * @generated from protobuf field: int64 enrolled_members_count = 5
     */
    enrolledMembersCount: number;
    /**
     * Total count of members of this catalog
     *
     * @generated from protobuf field: int64 total_members_count = 6
     */
    totalMembersCount: number;
}
/**
 * The app entitlement expand mask allows the user to get additional information when getting responses containing app entitlement views.
 *
 * @generated from protobuf message c1.api.app.v1.AppEntitlementExpandMask
 */
export interface AppEntitlementExpandMask {
    /**
     * Array of strings to describe which items to expand on the return value. Can be any combination of "*", "app_id", "app_resource_type_id", or "app_resource_id".
     *
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.CreateAppEntitlementRequest
 */
export interface CreateAppEntitlementRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 4
     */
    expandMask?: AppEntitlementExpandMask;
    /**
     * @generated from protobuf field: string app_resource_type_id = 5
     */
    appResourceTypeId: string;
    /**
     * @generated from protobuf field: string app_resource_id = 6
     */
    appResourceId: string;
    /**
     * @generated from protobuf field: string slug = 7
     */
    slug: string;
    /**
     * @generated from protobuf field: repeated string app_entitlement_owner_ids = 8
     */
    appEntitlementOwnerIds: string[];
    /**
     * @generated from protobuf field: bool emergency_grant_enabled = 9
     */
    emergencyGrantEnabled: boolean;
    /**
     * @generated from protobuf field: string emergency_grant_policy_id = 10
     */
    emergencyGrantPolicyId: string;
    /**
     * @generated from protobuf field: string grant_policy_id = 11
     */
    grantPolicyId: string;
    /**
     * @generated from protobuf field: string revoke_policy_id = 12
     */
    revokePolicyId: string;
    /**
     * @generated from protobuf field: string certify_policy_id = 13
     */
    certifyPolicyId: string;
    /**
     * @generated from protobuf field: string risk_level_value_id = 14
     */
    riskLevelValueId: string;
    /**
     * @generated from protobuf field: repeated string compliance_framework_value_ids = 15
     */
    complianceFrameworkValueIds: string[];
    /**
     * @generated from protobuf field: string alias = 16
     */
    alias: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementPurposeValue purpose = 17
     */
    purpose: AppEntitlementPurposeValue;
    /**
     * @generated from protobuf field: c1.api.policy.v1.ProvisionPolicy provision_policy = 18
     */
    provisionPolicy?: ProvisionPolicy;
    /**
     * @generated from protobuf oneof: max_grant_duration
     */
    maxGrantDuration: {
        oneofKind: "durationUnset";
        /**
         * If grants for this app entitlement do not have a max duration this field is set with {}.
         *
         * @generated from protobuf field: google.protobuf.Empty duration_unset = 19
         */
        durationUnset: Empty;
    } | {
        oneofKind: "durationGrant";
        /**
         * If grants for this app entitlement have a max duration this field is set with the max duration in seconds.
         *
         * @generated from protobuf field: google.protobuf.Duration duration_grant = 20
         */
        durationGrant: Duration;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: bool override_access_requests_defaults = 21
     */
    overrideAccessRequestsDefaults: boolean;
    /**
     * If supplied, it's implied that the entitlement is created before sync and needs to be merged with connector entitlement.
     *
     * @generated from protobuf field: string match_baton_id = 22
     */
    matchBatonId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.CreateAppEntitlementResponse
 */
export interface CreateAppEntitlementResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementView app_entitlement_view = 1
     */
    appEntitlementView?: AppEntitlementView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * The UpdateAppEntitlementRequest message contains the app entitlement and the fields to be updated.
 *
 * @generated from protobuf message c1.api.app.v1.UpdateAppEntitlementRequest
 */
export interface UpdateAppEntitlementRequest {
    /**
     * The ID of the app that is associated with the app entitlement.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The fields of this app entitlement being updated by this request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlement entitlement = 2
     */
    entitlement?: AppEntitlement;
    /**
     * A comma sepparated list of fields to update from the entitlement. For example: "certify_policy_id,slug"
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 3
     */
    updateMask?: FieldMask;
    /**
     * The fields of this app entitlement being updated by this request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 4
     */
    expandMask?: AppEntitlementExpandMask;
    /**
     * Flag to indicate that access request defaults, if any are applied to these entitlements, should be overridden.
     *
     * @generated from protobuf field: bool override_access_requests_defaults = 5
     */
    overrideAccessRequestsDefaults: boolean;
}
/**
 * The UpdateProvisionerPolicyAppEntitlementRequest message contains the app entitlement and the fields to be updated.
 *
 * @generated from protobuf message c1.api.app.v1.UpdateProvisionerPolicyAppEntitlementRequest
 */
export interface UpdateProvisionerPolicyAppEntitlementRequest {
    /**
     * The ID of the app that is associated with the app entitlement.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The fields of this app entitlement being updated by this request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlement entitlement = 2
     */
    entitlement?: AppEntitlement;
    /**
     * The fields of this app entitlement being updated by this request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 4
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * The UpdateDeprovisionerPolicyAppEntitlementRequest message contains the app entitlement and the fields to be updated.
 *
 * @generated from protobuf message c1.api.app.v1.UpdateDeprovisionerPolicyAppEntitlementRequest
 */
export interface UpdateDeprovisionerPolicyAppEntitlementRequest {
    /**
     * The ID of the app that is associated with the app entitlement.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The fields of this app entitlement being updated by this request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlement entitlement = 2
     */
    entitlement?: AppEntitlement;
    /**
     * The fields of this app entitlement being updated by this request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 4
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.UpdateAppEntitlementResponse
 */
export interface UpdateAppEntitlementResponse {
    /**
     * A view of the updated app entitlement contains the serialized app entitlement and paths to objects referenced by the app entitlement.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementView app_entitlement_view = 1
     */
    appEntitlementView?: AppEntitlementView;
    /**
     * List of related objects
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.GetAppEntitlementRequest
 */
export interface GetAppEntitlementRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string id = 2
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 3
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * The get app entitlement response returns an entitlement view containing paths in the expanded array for the objects expanded as indicated by the expand mask in the request.
 *
 * @generated from protobuf message c1.api.app.v1.GetAppEntitlementResponse
 */
export interface GetAppEntitlementResponse {
    /**
     * A view of the app entitlement, contains the serialized app entitlement and paths to objects referenced by the app entitlement.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementView app_entitlement_view = 1
     */
    appEntitlementView?: AppEntitlementView;
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.BulkGetAppEntitlementsRequest
 */
export interface BulkGetAppEntitlementsRequest {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 1
     */
    appEntitlementRefs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.app.v1.BulkGetAppEntitlementsResponse
 */
export interface BulkGetAppEntitlementsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlement list = 1
     */
    list: AppEntitlement[];
}
/**
 * @generated from protobuf message c1.api.app.v1.DeleteAppEntitlementRequest
 */
export interface DeleteAppEntitlementRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string id = 2
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.DeleteAppEntitlementResponse
 */
export interface DeleteAppEntitlementResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.DeleteAppEntitlementIfManuallyCreatedRequest
 */
export interface DeleteAppEntitlementIfManuallyCreatedRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string id = 2
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppEntitlementsRequest
 */
export interface ListAppEntitlementsRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 4
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * The ListAppEntitlementsResponse message contains a list of results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.app.v1.ListAppEntitlementsResponse
 */
export interface ListAppEntitlementsResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementView list = 1
     */
    list: AppEntitlementView[];
    /**
     * List of related objects
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size. The server returns one page of results and the nextPageToken until all results are retreived. To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * The AppEntitlementUserView (aka grant view) describes the relationship between an app user and an entitlement. They have more recently been referred to as grants.
 *
 * @generated from protobuf message c1.api.app.v1.AppEntitlementUserView
 */
export interface AppEntitlementUserView {
    /**
     * The app user referenced by this app entitlement user (grant).
     *
     * @generated from protobuf field: c1.api.app.v1.AppUserView app_user = 1
     */
    appUser?: AppUserView;
    /**
     * When the app entitlement user binding (grant) was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp app_entitlement_user_binding_created_at = 2
     */
    appEntitlementUserBindingCreatedAt?: Timestamp;
    /**
     * When the app entitlement user binding (grant) intends to deprovision.
     *
     * @generated from protobuf field: google.protobuf.Timestamp app_entitlement_user_binding_deprovision_at = 3
     */
    appEntitlementUserBindingDeprovisionAt?: Timestamp;
    /**
     * List of sources for the grant, ie. groups, roles, etc.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef grant_sources = 4
     */
    grantSources: AppEntitlementRef[];
    /**
     * The originating ticket ID for the grant (e.g. from a request ticket).
     *
     * @generated from protobuf field: string originating_ticket_id = 5
     */
    originatingTicketId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppEntitlementUsersRequest
 */
export interface ListAppEntitlementUsersRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserExpandMask expand_mask = 5
     */
    expandMask?: AppUserExpandMask;
}
/**
 * The ListAppEntitlementUsersResponse message contains a list of results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.app.v1.ListAppEntitlementUsersResponse
 */
export interface ListAppEntitlementUsersResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementUserView list = 1
     */
    list: AppEntitlementUserView[];
    /**
     * List of related objects
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size. The server returns one page of results and the nextPageToken until all results are retreived. To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementsWithExpiredRequest
 */
export interface SearchAppEntitlementsWithExpiredRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementUserBindingRef refs = 6
     */
    refs: AppEntitlementUserBindingRef[];
    /**
     * @generated from protobuf field: string query = 7
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserRef app_user_refs = 8
     */
    appUserRefs: AppUserRef[];
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserRef user_refs = 9
     */
    userRefs: UserRef[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementWithExpired
 */
export interface AppEntitlementWithExpired {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUser app_user = 1
     */
    appUser?: AppUser;
    /**
     * @generated from protobuf field: c1.api.user.v1.User user = 2
     */
    user?: User;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expired = 3
     */
    expired?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp discovered = 4
     */
    discovered?: Timestamp;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.GrantReason grant_reasons = 5
     */
    grantReasons: GrantReason[];
    /**
     * @generated from protobuf field: string app_entitlement_id = 6
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string app_id = 7
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 8
     */
    appUserId: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef grant_sources = 9
     */
    grantSources: AppEntitlementRef[];
}
/**
 * The SearchAppEntitlementsWithExpiredResponse message contains a list of results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementsWithExpiredResponse
 */
export interface SearchAppEntitlementsWithExpiredResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementWithExpired list = 1
     */
    list: AppEntitlementWithExpired[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * Request to get access profiles for grants.
 *
 * @generated from protobuf message c1.api.app.v1.GetAccessProfilesForGrantsRequest
 */
export interface GetAccessProfilesForGrantsRequest {
    /**
     * The ID of the app containing the entitlement.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The ID of the entitlement.
     *
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * The IDs of the app users who have the grant.
     *
     * @generated from protobuf field: repeated string app_user_ids = 3
     */
    appUserIds: string[];
}
/**
 * An access profile with its membership expiry time.
 *
 * @generated from protobuf message c1.api.app.v1.AccessProfileWithExpiry
 */
export interface AccessProfileWithExpiry {
    /**
     * The ID of the access profile (catalog).
     *
     * @generated from protobuf field: string catalog_id = 1
     */
    catalogId: string;
    /**
     * The display name of the access profile.
     *
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * The expiry time of the user's membership in this access profile.
     * If null, the membership does not expire.
     *
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 3
     */
    expiresAt?: Timestamp;
    /**
     * The unenrollment behavior configured for this access profile.
     *
     * @generated from protobuf field: c1.api.app.v1.AccessProfileUnenrollmentBehavior unenrollment_behavior = 4
     */
    unenrollmentBehavior: AccessProfileUnenrollmentBehavior;
}
/**
 * Access profiles for a specific user.
 *
 * @generated from protobuf message c1.api.app.v1.AccessProfilesForUser
 */
export interface AccessProfilesForUser {
    /**
     * The ID of the app user.
     *
     * @generated from protobuf field: string app_user_id = 1
     */
    appUserId: string;
    /**
     * The list of access profiles for this user.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AccessProfileWithExpiry access_profiles = 2
     */
    accessProfiles: AccessProfileWithExpiry[];
    /**
     * The effective expiry time computed based on unenrollment behaviors.
     * This is computed by simulating access profiles in their expiry order.
     * If null, the grant does not effectively expire (e.g., all profiles have "leave access as is" behavior).
     *
     * @generated from protobuf field: google.protobuf.Timestamp effective_expiry_at = 3
     */
    effectiveExpiryAt?: Timestamp;
}
/**
 * Response containing access profiles for grants.
 *
 * @generated from protobuf message c1.api.app.v1.GetAccessProfilesForGrantsResponse
 */
export interface GetAccessProfilesForGrantsResponse {
    /**
     * Access profiles grouped by user.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AccessProfilesForUser access_profiles_for_users = 1
     */
    accessProfilesForUsers: AccessProfilesForUser[];
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppEntitlementsForAppUserRequest
 */
export interface ListAppEntitlementsForAppUserRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 2
     */
    appUserId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 5
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppEntitlementGroupsRequest
 */
export interface ListAppEntitlementGroupsRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
}
/**
 * The ListAppEntitlementGroupsResponse message contains a list of results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.app.v1.ListAppEntitlementGroupsResponse
 */
export interface ListAppEntitlementGroupsResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppGroup list = 1
     */
    list: AppGroup[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size. The server returns one page of results and the nextPageToken until all results are retreived. To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * Deprecated
     *
     * @generated from protobuf field: string notification_token = 3
     */
    notificationToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppEntitlementsForAppResourceRequest
 */
export interface ListAppEntitlementsForAppResourceRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_resource_type_id = 2
     */
    appResourceTypeId: string;
    /**
     * @generated from protobuf field: string app_resource_id = 3
     */
    appResourceId: string;
    /**
     * @generated from protobuf field: int32 page_size = 4
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 5
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 6
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppWithGrantCount
 */
export interface AppWithGrantCount {
    /**
     * @generated from protobuf field: c1.api.app.v1.App App = 1
     */
    app?: App;
    /**
     * @generated from protobuf field: int64 Count = 2
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.CountStandingHighRiskGrantsRequest
 */
export interface CountStandingHighRiskGrantsRequest {
}
/**
 * @generated from protobuf message c1.api.app.v1.CountStandingHighRiskGrantsResponse
 */
export interface CountStandingHighRiskGrantsResponse {
    /**
     * @generated from protobuf field: int64 total_count = 1
     */
    totalCount: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchStandingHighRiskGrantsForAppsRequest
 */
export interface SearchStandingHighRiskGrantsForAppsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchStandingHighRiskGrantsForAppsResponse
 */
export interface SearchStandingHighRiskGrantsForAppsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppWithGrantCount list = 1
     */
    list: AppWithGrantCount[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementAutomationRef
 */
export interface AppEntitlementAutomationRef {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string id = 2
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementServiceGetAutomationRequest
 */
export interface AppEntitlementServiceGetAutomationRequest {
    /**
     * The ID of the app that is associated with the app entitlement.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The unique ID for the App Entitlement.
     *
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementServiceGetAutomationResponse
 */
export interface AppEntitlementServiceGetAutomationResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementAutomation AppEntitlementAutomation = 1
     */
    appEntitlementAutomation?: AppEntitlementAutomation;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementServicePreviewAutomationCELRequest
 */
export interface AppEntitlementServicePreviewAutomationCELRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string expression = 3
     */
    expression: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse
 */
export interface AppEntitlementServicePreviewAutomationCELResponse {
    /**
     * @generated from protobuf oneof: response
     */
    response: {
        oneofKind: "matched";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse.PreviewAutomationCELResponseMatched matched = 1
         */
        matched: AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseMatched;
    } | {
        oneofKind: "status";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse.PreviewAutomationCELResponseStatus status = 2
         */
        status: AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseStatus;
    } | {
        oneofKind: "failed";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse.PreviewAutomationCELResponseFailed failed = 3
         */
        failed: AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseFailed;
    } | {
        oneofKind: "stopped";
        /**
         * @generated from protobuf field: bool stopped = 4
         */
        stopped: boolean;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse.PreviewAutomationCELResponseMatched
 */
export interface AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseMatched {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.User list = 1
     */
    list: User[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse.PreviewAutomationCELResponseFailed
 */
export interface AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseFailed {
    /**
     * @generated from protobuf field: c1.api.user.v1.User user = 1
     */
    user?: User;
    /**
     * @generated from protobuf field: string error = 2
     */
    error: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse.PreviewAutomationCELResponseStatus
 */
export interface AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseStatus {
    /**
     * @generated from protobuf field: int64 total = 1
     */
    total: number;
    /**
     * @generated from protobuf field: int64 scanned = 2
     */
    scanned: number;
    /**
     * @generated from protobuf field: int64 matched = 3
     */
    matched: number;
    /**
     * @generated from protobuf field: int64 errors = 4
     */
    errors: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementServiceUpdateAutomationRequest
 */
export interface AppEntitlementServiceUpdateAutomationRequest {
    /**
     * The ID of the app that is associated with the app entitlement.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The unique ID for the App Entitlement.
     *
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * The display name of the app entitlement.
     *
     * @generated from protobuf field: string display_name = 3
     */
    displayName: string;
    /**
     * The description of the app entitlement.
     *
     * @generated from protobuf field: string description = 4
     */
    description: string;
    /**
     * @generated from protobuf oneof: conditions
     */
    conditions: {
        oneofKind: "none";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppEntitlementAutomationRuleNone none = 100
         */
        none: AppEntitlementAutomationRuleNone;
    } | {
        oneofKind: "entitlements";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppEntitlementAutomationRuleEntitlement entitlements = 101
         */
        entitlements: AppEntitlementAutomationRuleEntitlement;
    } | {
        oneofKind: "cel";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppEntitlementAutomationRuleCEL cel = 102
         */
        cel: AppEntitlementAutomationRuleCEL;
    } | {
        oneofKind: "basic";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppEntitlementAutomationRuleBasic basic = 103
         */
        basic: AppEntitlementAutomationRuleBasic;
    } | {
        oneofKind: undefined;
    };
    /**
     * The comma-sepparated list of fields to update in the view. "display_name,description"
     * would update display name and description regardless of what values are set on the request object.
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 5
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementServiceUpdateAutomationResponse
 */
export interface AppEntitlementServiceUpdateAutomationResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementAutomation AppEntitlementAutomation = 1
     */
    appEntitlementAutomation?: AppEntitlementAutomation;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementAutomationRuleNone
 */
export interface AppEntitlementAutomationRuleNone {
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementAutomationRuleEntitlement
 */
export interface AppEntitlementAutomationRuleEntitlement {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef entitlement_refs = 1
     */
    entitlementRefs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementAutomationRuleCEL
 */
export interface AppEntitlementAutomationRuleCEL {
    /**
     * @generated from protobuf field: string expression = 1
     */
    expression: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementAutomationRuleBasic
 */
export interface AppEntitlementAutomationRuleBasic {
    /**
     * @generated from protobuf field: string expression = 1
     */
    expression: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementAutomationLastRunStatus
 */
export interface AppEntitlementAutomationLastRunStatus {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_completed_at = 1
     */
    lastCompletedAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementAutomationRunStatus status = 2
     */
    status: AppEntitlementAutomationRunStatus;
    /**
     * @generated from protobuf field: string error_message = 3
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementAutomation
 */
export interface AppEntitlementAutomation {
    /**
     * The ID of the app that is associated with the app entitlement.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The unique ID for the App Entitlement.
     *
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * The datetime, in RFC3339 format, of when the AppEntitlement was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the AppEntitlement was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the AppEntitlement was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5
     */
    deletedAt?: Timestamp;
    /**
     * The display name of the app entitlement.
     *
     * @generated from protobuf field: string display_name = 6
     */
    displayName: string;
    /**
     * The description of the app entitlement.
     *
     * @generated from protobuf field: string description = 7
     */
    description: string;
    /**
     * @generated from protobuf oneof: conditions
     */
    conditions: {
        oneofKind: "none";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppEntitlementAutomationRuleNone none = 100
         */
        none: AppEntitlementAutomationRuleNone;
    } | {
        oneofKind: "entitlements";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppEntitlementAutomationRuleEntitlement entitlements = 101
         */
        entitlements: AppEntitlementAutomationRuleEntitlement;
    } | {
        oneofKind: "cel";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppEntitlementAutomationRuleCEL cel = 102
         */
        cel: AppEntitlementAutomationRuleCEL;
    } | {
        oneofKind: "basic";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppEntitlementAutomationRuleBasic basic = 103
         */
        basic: AppEntitlementAutomationRuleBasic;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementAutomationLastRunStatus last_run_status = 8
     */
    lastRunStatus?: AppEntitlementAutomationLastRunStatus;
}
/**
 * @generated from protobuf message c1.api.app.v1.AddAutomationExclusionRequest
 */
export interface AddAutomationExclusionRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: repeated string user_ids = 3
     */
    userIds: string[];
}
/**
 * Empty response with a status code indicating success.
 *
 * @generated from protobuf message c1.api.app.v1.AddAutomationExclusionResponse
 */
export interface AddAutomationExclusionResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.RemoveAutomationExclusionRequest
 */
export interface RemoveAutomationExclusionRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: repeated string user_ids = 3
     */
    userIds: string[];
}
/**
 * Empty response with a status code indicating success.
 *
 * @generated from protobuf message c1.api.app.v1.RemoveAutomationExclusionResponse
 */
export interface RemoveAutomationExclusionResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAutomationExclusionsRequest
 */
export interface ListAutomationExclusionsRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementUserBindingRef refs = 6
     */
    refs: AppEntitlementUserBindingRef[];
}
/**
 * @generated from protobuf message c1.api.app.v1.UserWithAppEntitlementUserBindingView
 */
export interface UserWithAppEntitlementUserBindingView {
    /**
     * @generated from protobuf field: c1.api.user.v1.User user = 1
     */
    user?: User;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 3
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string app_user_id = 4
     */
    appUserId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAutomationExclusionsResponse
 */
export interface ListAutomationExclusionsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.UserWithAppEntitlementUserBindingView list = 1
     */
    list: UserWithAppEntitlementUserBindingView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AddManuallyManagedUsersRequest
 */
export interface AddManuallyManagedUsersRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: repeated string user_ids = 3
     */
    userIds: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.ManuallyManagedUsersResponse
 */
export interface ManuallyManagedUsersResponse {
    /**
     * @generated from protobuf field: map<string, string> failed_users_error_map = 1
     */
    failedUsersErrorMap: {
        [key: string]: string;
    };
}
/**
 * @generated from protobuf message c1.api.app.v1.RemoveEntitlementMembershipRequest
 */
export interface RemoveEntitlementMembershipRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string app_user_id = 3
     */
    appUserId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.RemoveEntitlementMembershipResponse
 */
export interface RemoveEntitlementMembershipResponse {
    /**
     * The ID of the revoke task created to remove the user from the entitlement, if the entitlement is an access profile (aka. catalog).
     * It's aka. the JML task.
     *
     * @generated from protobuf field: string revoke_task_id = 1
     */
    revokeTaskId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ForceRunDynamicGroupAutomationRequest
 */
export interface ForceRunDynamicGroupAutomationRequest {
    /**
     * @generated from protobuf field: string app_entitlement_id = 1
     */
    appEntitlementId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ForceRunDynamicGroupAutomationResponse
 */
export interface ForceRunDynamicGroupAutomationResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchFilter
 */
export interface AppEntitlementSearchFilter {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 12
     */
    appEntitlementRefs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementUserBindingSearchFilter
 */
export interface AppEntitlementUserBindingSearchFilter {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementUserBindingRef refs = 1
     */
    refs: AppEntitlementUserBindingRef[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserRef app_user_refs = 2
     */
    appUserRefs: AppUserRef[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementUserBindingRef exclude_refs = 3
     */
    excludeRefs: AppEntitlementUserBindingRef[];
}
/**
 * @generated from protobuf enum c1.api.app.v1.AppEntitlementMembershipType
 */
export enum AppEntitlementMembershipType {
    /**
     * @generated from protobuf enum value: APP_ENTITLEMENT_MEMBERSHIP_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: APP_ENTITLEMENT_MEMBERSHIP_TYPE_MEMBER = 1;
     */
    MEMBER = 1,
    /**
     * @generated from protobuf enum value: APP_ENTITLEMENT_MEMBERSHIP_TYPE_OWNER = 2;
     */
    OWNER = 2,
    /**
     * @generated from protobuf enum value: APP_ENTITLEMENT_MEMBERSHIP_TYPE_EXCLUSION = 3;
     */
    EXCLUSION = 3,
    /**
     * @generated from protobuf enum value: APP_ENTITLEMENT_MEMBERSHIP_TYPE_ADMIN = 4;
     */
    ADMIN = 4
}
/**
 * AppEntitlementSortBy defines the various fields that AppEntitlements can be sorted by
 *
 * @generated from protobuf enum c1.api.app.v1.SearchRequestableEntitlementsForUserSortBy
 */
export enum SearchRequestableEntitlementsForUserSortBy {
    /**
     * Default sorting behavior (unspecified)
     *
     * @generated from protobuf enum value: SORT_BY_UNSPECIFIED = 0;
     */
    SORT_BY_UNSPECIFIED = 0,
    /**
     * Sort by resource type display name, resource display name
     *
     * @generated from protobuf enum value: SORT_BY_RESOURCE_TYPE_AND_RESOURCE = 1;
     */
    SORT_BY_RESOURCE_TYPE_AND_RESOURCE = 1
}
/**
 * @generated from protobuf enum c1.api.app.v1.AppEntitlementPurposeValue
 */
export enum AppEntitlementPurposeValue {
    /**
     * @generated from protobuf enum value: APP_ENTITLEMENT_PURPOSE_VALUE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: APP_ENTITLEMENT_PURPOSE_VALUE_ASSIGNMENT = 1;
     */
    ASSIGNMENT = 1,
    /**
     * @generated from protobuf enum value: APP_ENTITLEMENT_PURPOSE_VALUE_PERMISSION = 2;
     */
    PERMISSION = 2,
    /**
     * @generated from protobuf enum value: APP_ENTITLEMENT_PURPOSE_VALUE_OWNERSHIP = 3;
     */
    OWNERSHIP = 3
}
/**
 * Unenrollment behavior for an access profile.
 * This mirrors RequestCatalogUnenrollmentBehavior to avoid cyclic imports.
 *
 * @generated from protobuf enum c1.api.app.v1.AccessProfileUnenrollmentBehavior
 */
export enum AccessProfileUnenrollmentBehavior {
    /**
     * @generated from protobuf enum value: ACCESS_PROFILE_UNENROLLMENT_BEHAVIOR_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Do not create tickets to revoke entitlements when a user is unenrolled from the catalog.
     *
     * @generated from protobuf enum value: ACCESS_PROFILE_UNENROLLMENT_BEHAVIOR_LEAVE_ACCESS_AS_IS = 1;
     */
    LEAVE_ACCESS_AS_IS = 1,
    /**
     * Revoke all entitlements within the catalog when a user is unenrolled from the catalog.
     *
     * @generated from protobuf enum value: ACCESS_PROFILE_UNENROLLMENT_BEHAVIOR_REVOKE_ALL = 2;
     */
    REVOKE_ALL = 2,
    /**
     * Revoke all entitlements within the catalog that were granted without a justification (based on grant reasons) when a user is unenrolled from the catalog.
     *
     * @generated from protobuf enum value: ACCESS_PROFILE_UNENROLLMENT_BEHAVIOR_REVOKE_UNJUSTIFIED = 3;
     */
    REVOKE_UNJUSTIFIED = 3
}
/**
 * @generated from protobuf enum c1.api.app.v1.AppEntitlementAutomationRunStatus
 */
export enum AppEntitlementAutomationRunStatus {
    /**
     * @generated from protobuf enum value: APP_ENTITLEMENT_AUTOMATION_RUN_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: APP_ENTITLEMENT_AUTOMATION_RUN_STATUS_SUCCESS = 1;
     */
    SUCCESS = 1,
    /**
     * @generated from protobuf enum value: APP_ENTITLEMENT_AUTOMATION_RUN_STATUS_FAILED = 2;
     */
    FAILED = 2,
    /**
     * @generated from protobuf enum value: APP_ENTITLEMENT_AUTOMATION_RUN_STATUS_IN_PROGRESS = 3;
     */
    IN_PROGRESS = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementUserBindingDestinationsRequest$Type extends MessageType<SearchAppEntitlementUserBindingDestinationsRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementUserBindingDestinationsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 5, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<SearchAppEntitlementUserBindingDestinationsRequest>): SearchAppEntitlementUserBindingDestinationsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.appUserId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAppEntitlementUserBindingDestinationsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppEntitlementUserBindingDestinationsRequest): SearchAppEntitlementUserBindingDestinationsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* string app_user_id */ 3:
                    message.appUserId = reader.string();
                    break;
                case /* int32 page_size */ 4:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 5:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppEntitlementUserBindingDestinationsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* string app_user_id = 3; */
        if (message.appUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appUserId);
        /* int32 page_size = 4; */
        if (message.pageSize !== 0)
            writer.tag(4, WireType.Varint).int32(message.pageSize);
        /* string page_token = 5; */
        if (message.pageToken !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementUserBindingDestinationsRequest
 */
export const SearchAppEntitlementUserBindingDestinationsRequest = new SearchAppEntitlementUserBindingDestinationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementUserBindingDestinationsResponse$Type extends MessageType<SearchAppEntitlementUserBindingDestinationsResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementUserBindingDestinationsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchAppEntitlementUserBindingDestinationsResponse>): SearchAppEntitlementUserBindingDestinationsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAppEntitlementUserBindingDestinationsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppEntitlementUserBindingDestinationsResponse): SearchAppEntitlementUserBindingDestinationsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementRef list */ 1:
                    message.list.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppEntitlementUserBindingDestinationsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementRef list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementUserBindingDestinationsResponse
 */
export const SearchAppEntitlementUserBindingDestinationsResponse = new SearchAppEntitlementUserBindingDestinationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementCorrelation$Type extends MessageType<AppEntitlementCorrelation> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementCorrelation", [
            { no: 1, name: "app_entitlement", kind: "message", T: () => AppEntitlementRef },
            { no: 2, name: "distance", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementCorrelation>): AppEntitlementCorrelation {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementCorrelation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementCorrelation): AppEntitlementCorrelation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementRef app_entitlement */ 1:
                    message.appEntitlement = AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options, message.appEntitlement);
                    break;
                case /* optional double distance */ 2:
                    message.distance = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementCorrelation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementRef app_entitlement = 1; */
        if (message.appEntitlement)
            AppEntitlementRef.internalBinaryWrite(message.appEntitlement, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* optional double distance = 2; */
        if (message.distance !== undefined)
            writer.tag(2, WireType.Bit64).double(message.distance);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementCorrelation
 */
export const AppEntitlementCorrelation = new AppEntitlementCorrelation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementCorrelationForAccessProfileRequest$Type extends MessageType<SearchAppEntitlementCorrelationForAccessProfileRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementCorrelationForAccessProfileRequest", [
            { no: 1, name: "access_profile_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } },
            { no: 7, name: "exclude_immutable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "excluded_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 10, name: "all", kind: "scalar", oneof: "recommendation", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "additions", kind: "scalar", oneof: "recommendation", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<SearchAppEntitlementCorrelationForAccessProfileRequest>): SearchAppEntitlementCorrelationForAccessProfileRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessProfileId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.appIds = [];
        message.resourceTypeIds = [];
        message.excludeImmutable = false;
        message.excludedEntitlementRefs = [];
        message.recommendation = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<SearchAppEntitlementCorrelationForAccessProfileRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppEntitlementCorrelationForAccessProfileRequest): SearchAppEntitlementCorrelationForAccessProfileRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_profile_id */ 1:
                    message.accessProfileId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 4:
                    message.query = reader.string();
                    break;
                case /* repeated string app_ids */ 5:
                    message.appIds.push(reader.string());
                    break;
                case /* repeated string resource_type_ids */ 6:
                    message.resourceTypeIds.push(reader.string());
                    break;
                case /* bool exclude_immutable */ 7:
                    message.excludeImmutable = reader.bool();
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef excluded_entitlement_refs */ 8:
                    message.excludedEntitlementRefs.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool all */ 10:
                    message.recommendation = {
                        oneofKind: "all",
                        all: reader.bool()
                    };
                    break;
                case /* bool additions */ 11:
                    message.recommendation = {
                        oneofKind: "additions",
                        additions: reader.bool()
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppEntitlementCorrelationForAccessProfileRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_profile_id = 1; */
        if (message.accessProfileId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessProfileId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 4; */
        if (message.query !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.query);
        /* repeated string app_ids = 5; */
        for (let i = 0; i < message.appIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.appIds[i]);
        /* repeated string resource_type_ids = 6; */
        for (let i = 0; i < message.resourceTypeIds.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.resourceTypeIds[i]);
        /* bool exclude_immutable = 7; */
        if (message.excludeImmutable !== false)
            writer.tag(7, WireType.Varint).bool(message.excludeImmutable);
        /* repeated c1.api.app.v1.AppEntitlementRef excluded_entitlement_refs = 8; */
        for (let i = 0; i < message.excludedEntitlementRefs.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.excludedEntitlementRefs[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* bool all = 10; */
        if (message.recommendation.oneofKind === "all")
            writer.tag(10, WireType.Varint).bool(message.recommendation.all);
        /* bool additions = 11; */
        if (message.recommendation.oneofKind === "additions")
            writer.tag(11, WireType.Varint).bool(message.recommendation.additions);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementCorrelationForAccessProfileRequest
 */
export const SearchAppEntitlementCorrelationForAccessProfileRequest = new SearchAppEntitlementCorrelationForAccessProfileRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementCorrelationForAccessProfileResponse$Type extends MessageType<SearchAppEntitlementCorrelationForAccessProfileResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementCorrelationForAccessProfileResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementCorrelation },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchAppEntitlementCorrelationForAccessProfileResponse>): SearchAppEntitlementCorrelationForAccessProfileResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAppEntitlementCorrelationForAccessProfileResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppEntitlementCorrelationForAccessProfileResponse): SearchAppEntitlementCorrelationForAccessProfileResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementCorrelation list */ 1:
                    message.list.push(AppEntitlementCorrelation.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppEntitlementCorrelationForAccessProfileResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementCorrelation list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementCorrelation.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementCorrelationForAccessProfileResponse
 */
export const SearchAppEntitlementCorrelationForAccessProfileResponse = new SearchAppEntitlementCorrelationForAccessProfileResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementUserBindingSourcesRequest$Type extends MessageType<SearchAppEntitlementUserBindingSourcesRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementUserBindingSourcesRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 5, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<SearchAppEntitlementUserBindingSourcesRequest>): SearchAppEntitlementUserBindingSourcesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.appUserId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAppEntitlementUserBindingSourcesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppEntitlementUserBindingSourcesRequest): SearchAppEntitlementUserBindingSourcesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* string app_user_id */ 3:
                    message.appUserId = reader.string();
                    break;
                case /* int32 page_size */ 4:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 5:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppEntitlementUserBindingSourcesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* string app_user_id = 3; */
        if (message.appUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appUserId);
        /* int32 page_size = 4; */
        if (message.pageSize !== 0)
            writer.tag(4, WireType.Varint).int32(message.pageSize);
        /* string page_token = 5; */
        if (message.pageToken !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementUserBindingSourcesRequest
 */
export const SearchAppEntitlementUserBindingSourcesRequest = new SearchAppEntitlementUserBindingSourcesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementUserBindingSourcesResponse$Type extends MessageType<SearchAppEntitlementUserBindingSourcesResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementUserBindingSourcesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchAppEntitlementUserBindingSourcesResponse>): SearchAppEntitlementUserBindingSourcesResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAppEntitlementUserBindingSourcesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppEntitlementUserBindingSourcesResponse): SearchAppEntitlementUserBindingSourcesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementRef list */ 1:
                    message.list.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppEntitlementUserBindingSourcesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementRef list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementUserBindingSourcesResponse
 */
export const SearchAppEntitlementUserBindingSourcesResponse = new SearchAppEntitlementUserBindingSourcesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAutomationRequest$Type extends MessageType<CreateAutomationRequest> {
    constructor() {
        super("c1.api.app.v1.CreateAutomationRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "automation", kind: "message", T: () => AppEntitlementAutomation, options: { "validate.rules": { message: { required: true } } } }
        ]);
    }
    create(value?: PartialMessage<CreateAutomationRequest>): CreateAutomationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        if (value !== undefined)
            reflectionMergePartial<CreateAutomationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAutomationRequest): CreateAutomationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementAutomation automation */ 3:
                    message.automation = AppEntitlementAutomation.internalBinaryRead(reader, reader.uint32(), options, message.automation);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAutomationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* c1.api.app.v1.AppEntitlementAutomation automation = 3; */
        if (message.automation)
            AppEntitlementAutomation.internalBinaryWrite(message.automation, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CreateAutomationRequest
 */
export const CreateAutomationRequest = new CreateAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAutomationResponse$Type extends MessageType<CreateAutomationResponse> {
    constructor() {
        super("c1.api.app.v1.CreateAutomationResponse", [
            { no: 1, name: "automation", kind: "message", T: () => AppEntitlementAutomation }
        ]);
    }
    create(value?: PartialMessage<CreateAutomationResponse>): CreateAutomationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateAutomationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAutomationResponse): CreateAutomationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementAutomation automation */ 1:
                    message.automation = AppEntitlementAutomation.internalBinaryRead(reader, reader.uint32(), options, message.automation);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAutomationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementAutomation automation = 1; */
        if (message.automation)
            AppEntitlementAutomation.internalBinaryWrite(message.automation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CreateAutomationResponse
 */
export const CreateAutomationResponse = new CreateAutomationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAutomationRequest$Type extends MessageType<DeleteAutomationRequest> {
    constructor() {
        super("c1.api.app.v1.DeleteAutomationRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<DeleteAutomationRequest>): DeleteAutomationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        if (value !== undefined)
            reflectionMergePartial<DeleteAutomationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAutomationRequest): DeleteAutomationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAutomationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAutomationRequest
 */
export const DeleteAutomationRequest = new DeleteAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAutomationResponse$Type extends MessageType<DeleteAutomationResponse> {
    constructor() {
        super("c1.api.app.v1.DeleteAutomationResponse", []);
    }
    create(value?: PartialMessage<DeleteAutomationResponse>): DeleteAutomationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteAutomationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAutomationResponse): DeleteAutomationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAutomationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAutomationResponse
 */
export const DeleteAutomationResponse = new DeleteAutomationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceCountAncestorsRequest$Type extends MessageType<AppEntitlementSearchServiceCountAncestorsRequest> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceCountAncestorsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "depth", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "validate.rules": { uint32: { lte: 2, gte: 1, ignoreEmpty: true } } } },
            { no: 4, name: "leaves_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "system_created_proxy_bindings_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementSearchServiceCountAncestorsRequest>): AppEntitlementSearchServiceCountAncestorsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.depth = 0;
        message.leavesOnly = false;
        message.systemCreatedProxyBindingsOnly = false;
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementSearchServiceCountAncestorsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementSearchServiceCountAncestorsRequest): AppEntitlementSearchServiceCountAncestorsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* uint32 depth */ 3:
                    message.depth = reader.uint32();
                    break;
                case /* bool leaves_only */ 4:
                    message.leavesOnly = reader.bool();
                    break;
                case /* bool system_created_proxy_bindings_only */ 5:
                    message.systemCreatedProxyBindingsOnly = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementSearchServiceCountAncestorsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* uint32 depth = 3; */
        if (message.depth !== 0)
            writer.tag(3, WireType.Varint).uint32(message.depth);
        /* bool leaves_only = 4; */
        if (message.leavesOnly !== false)
            writer.tag(4, WireType.Varint).bool(message.leavesOnly);
        /* bool system_created_proxy_bindings_only = 5; */
        if (message.systemCreatedProxyBindingsOnly !== false)
            writer.tag(5, WireType.Varint).bool(message.systemCreatedProxyBindingsOnly);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceCountAncestorsRequest
 */
export const AppEntitlementSearchServiceCountAncestorsRequest = new AppEntitlementSearchServiceCountAncestorsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceCountAncestorsResponse$Type extends MessageType<AppEntitlementSearchServiceCountAncestorsResponse> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceCountAncestorsResponse", [
            { no: 1, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementSearchServiceCountAncestorsResponse>): AppEntitlementSearchServiceCountAncestorsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementSearchServiceCountAncestorsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementSearchServiceCountAncestorsResponse): AppEntitlementSearchServiceCountAncestorsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 count */ 1:
                    message.count = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementSearchServiceCountAncestorsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int32(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceCountAncestorsResponse
 */
export const AppEntitlementSearchServiceCountAncestorsResponse = new AppEntitlementSearchServiceCountAncestorsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceSearchAncestorsRequest$Type extends MessageType<AppEntitlementSearchServiceSearchAncestorsRequest> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceSearchAncestorsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "depth", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "validate.rules": { uint32: { lte: 2, gte: 1, ignoreEmpty: true } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask },
            { no: 5, name: "leaves_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "system_created_proxy_bindings_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 2000, gte: 0 } } } },
            { no: 8, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 9, name: "only_ancestors_without_descendants", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementSearchServiceSearchAncestorsRequest>): AppEntitlementSearchServiceSearchAncestorsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.depth = 0;
        message.leavesOnly = false;
        message.systemCreatedProxyBindingsOnly = false;
        message.pageSize = 0;
        message.pageToken = "";
        message.onlyAncestorsWithoutDescendants = false;
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementSearchServiceSearchAncestorsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementSearchServiceSearchAncestorsRequest): AppEntitlementSearchServiceSearchAncestorsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* uint32 depth */ 3:
                    message.depth = reader.uint32();
                    break;
                case /* c1.api.app.v1.AppEntitlementExpandMask expand_mask */ 4:
                    message.expandMask = AppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* bool leaves_only */ 5:
                    message.leavesOnly = reader.bool();
                    break;
                case /* bool system_created_proxy_bindings_only */ 6:
                    message.systemCreatedProxyBindingsOnly = reader.bool();
                    break;
                case /* int32 page_size */ 7:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 8:
                    message.pageToken = reader.string();
                    break;
                case /* bool only_ancestors_without_descendants */ 9:
                    message.onlyAncestorsWithoutDescendants = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementSearchServiceSearchAncestorsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* uint32 depth = 3; */
        if (message.depth !== 0)
            writer.tag(3, WireType.Varint).uint32(message.depth);
        /* c1.api.app.v1.AppEntitlementExpandMask expand_mask = 4; */
        if (message.expandMask)
            AppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* bool leaves_only = 5; */
        if (message.leavesOnly !== false)
            writer.tag(5, WireType.Varint).bool(message.leavesOnly);
        /* bool system_created_proxy_bindings_only = 6; */
        if (message.systemCreatedProxyBindingsOnly !== false)
            writer.tag(6, WireType.Varint).bool(message.systemCreatedProxyBindingsOnly);
        /* int32 page_size = 7; */
        if (message.pageSize !== 0)
            writer.tag(7, WireType.Varint).int32(message.pageSize);
        /* string page_token = 8; */
        if (message.pageToken !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.pageToken);
        /* bool only_ancestors_without_descendants = 9; */
        if (message.onlyAncestorsWithoutDescendants !== false)
            writer.tag(9, WireType.Varint).bool(message.onlyAncestorsWithoutDescendants);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchAncestorsRequest
 */
export const AppEntitlementSearchServiceSearchAncestorsRequest = new AppEntitlementSearchServiceSearchAncestorsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AncestralBinding$Type extends MessageType<AncestralBinding> {
    constructor() {
        super("c1.api.app.v1.AncestralBinding", [
            { no: 1, name: "ancestor_entitlement", kind: "message", T: () => AppEntitlementView },
            { no: 2, name: "descendant_entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementView }
        ]);
    }
    create(value?: PartialMessage<AncestralBinding>): AncestralBinding {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.descendantEntitlements = [];
        if (value !== undefined)
            reflectionMergePartial<AncestralBinding>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AncestralBinding): AncestralBinding {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementView ancestor_entitlement */ 1:
                    message.ancestorEntitlement = AppEntitlementView.internalBinaryRead(reader, reader.uint32(), options, message.ancestorEntitlement);
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementView descendant_entitlements */ 2:
                    message.descendantEntitlements.push(AppEntitlementView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AncestralBinding, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementView ancestor_entitlement = 1; */
        if (message.ancestorEntitlement)
            AppEntitlementView.internalBinaryWrite(message.ancestorEntitlement, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.AppEntitlementView descendant_entitlements = 2; */
        for (let i = 0; i < message.descendantEntitlements.length; i++)
            AppEntitlementView.internalBinaryWrite(message.descendantEntitlements[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AncestralBinding
 */
export const AncestralBinding = new AncestralBinding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AncestralBindingRef$Type extends MessageType<AncestralBindingRef> {
    constructor() {
        super("c1.api.app.v1.AncestralBindingRef", [
            { no: 1, name: "ancestor_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "ancestor_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AncestralBindingRef>): AncestralBindingRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.ancestorAppId = "";
        message.ancestorAppEntitlementId = "";
        if (value !== undefined)
            reflectionMergePartial<AncestralBindingRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AncestralBindingRef): AncestralBindingRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string ancestor_app_id */ 1:
                    message.ancestorAppId = reader.string();
                    break;
                case /* string ancestor_app_entitlement_id */ 2:
                    message.ancestorAppEntitlementId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AncestralBindingRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string ancestor_app_id = 1; */
        if (message.ancestorAppId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.ancestorAppId);
        /* string ancestor_app_entitlement_id = 2; */
        if (message.ancestorAppEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ancestorAppEntitlementId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AncestralBindingRef
 */
export const AncestralBindingRef = new AncestralBindingRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceSearchAncestorsResponse$Type extends MessageType<AppEntitlementSearchServiceSearchAncestorsResponse> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceSearchAncestorsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AncestralBinding },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementSearchServiceSearchAncestorsResponse>): AppEntitlementSearchServiceSearchAncestorsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementSearchServiceSearchAncestorsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementSearchServiceSearchAncestorsResponse): AppEntitlementSearchServiceSearchAncestorsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AncestralBinding list */ 1:
                    message.list.push(AncestralBinding.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementSearchServiceSearchAncestorsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AncestralBinding list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AncestralBinding.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchAncestorsResponse
 */
export const AppEntitlementSearchServiceSearchAncestorsResponse = new AppEntitlementSearchServiceSearchAncestorsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceSearchCountRequest$Type extends MessageType<AppEntitlementSearchServiceSearchCountRequest> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceSearchCountRequest", [
            { no: 1, name: "filter", kind: "message", T: () => AppEntitlementSearchServiceSearchRequest }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementSearchServiceSearchCountRequest>): AppEntitlementSearchServiceSearchCountRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementSearchServiceSearchCountRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementSearchServiceSearchCountRequest): AppEntitlementSearchServiceSearchCountRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementSearchServiceSearchRequest filter */ 1:
                    message.filter = AppEntitlementSearchServiceSearchRequest.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementSearchServiceSearchCountRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementSearchServiceSearchRequest filter = 1; */
        if (message.filter)
            AppEntitlementSearchServiceSearchRequest.internalBinaryWrite(message.filter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchCountRequest
 */
export const AppEntitlementSearchServiceSearchCountRequest = new AppEntitlementSearchServiceSearchCountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceSearchCountResponse$Type extends MessageType<AppEntitlementSearchServiceSearchCountResponse> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceSearchCountResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementSearchServiceSearchCountResponse>): AppEntitlementSearchServiceSearchCountResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementSearchServiceSearchCountResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementSearchServiceSearchCountResponse): AppEntitlementSearchServiceSearchCountResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 count */ 1:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementSearchServiceSearchCountResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchCountResponse
 */
export const AppEntitlementSearchServiceSearchCountResponse = new AppEntitlementSearchServiceSearchCountResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceSearchExpiringAccessForUserRequest$Type extends MessageType<AppEntitlementSearchServiceSearchExpiringAccessForUserRequest> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceSearchExpiringAccessForUserRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask },
            { no: 5, name: "expires_before", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementSearchServiceSearchExpiringAccessForUserRequest>): AppEntitlementSearchServiceSearchExpiringAccessForUserRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.targetUserId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementSearchServiceSearchExpiringAccessForUserRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementSearchServiceSearchExpiringAccessForUserRequest): AppEntitlementSearchServiceSearchExpiringAccessForUserRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string target_user_id */ 1:
                    message.targetUserId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementExpandMask expand_mask */ 4:
                    message.expandMask = AppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* google.protobuf.Timestamp expires_before */ 5:
                    message.expiresBefore = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresBefore);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementSearchServiceSearchExpiringAccessForUserRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string target_user_id = 1; */
        if (message.targetUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.targetUserId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.app.v1.AppEntitlementExpandMask expand_mask = 4; */
        if (message.expandMask)
            AppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp expires_before = 5; */
        if (message.expiresBefore)
            Timestamp.internalBinaryWrite(message.expiresBefore, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchExpiringAccessForUserRequest
 */
export const AppEntitlementSearchServiceSearchExpiringAccessForUserRequest = new AppEntitlementSearchServiceSearchExpiringAccessForUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementWithUserBinding$Type extends MessageType<AppEntitlementWithUserBinding> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementWithUserBinding", [
            { no: 1, name: "entitlement", kind: "message", T: () => AppEntitlementView },
            { no: 2, name: "app_entitlement_user_binding", kind: "message", T: () => AppEntitlementUserView }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementWithUserBinding>): AppEntitlementWithUserBinding {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementWithUserBinding>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementWithUserBinding): AppEntitlementWithUserBinding {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementView entitlement */ 1:
                    message.entitlement = AppEntitlementView.internalBinaryRead(reader, reader.uint32(), options, message.entitlement);
                    break;
                case /* c1.api.app.v1.AppEntitlementUserView app_entitlement_user_binding */ 2:
                    message.appEntitlementUserBinding = AppEntitlementUserView.internalBinaryRead(reader, reader.uint32(), options, message.appEntitlementUserBinding);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementWithUserBinding, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementView entitlement = 1; */
        if (message.entitlement)
            AppEntitlementView.internalBinaryWrite(message.entitlement, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppEntitlementUserView app_entitlement_user_binding = 2; */
        if (message.appEntitlementUserBinding)
            AppEntitlementUserView.internalBinaryWrite(message.appEntitlementUserBinding, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementWithUserBinding
 */
export const AppEntitlementWithUserBinding = new AppEntitlementWithUserBinding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceSearchExpiringAccessForUserResponse$Type extends MessageType<AppEntitlementSearchServiceSearchExpiringAccessForUserResponse> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceSearchExpiringAccessForUserResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementWithUserBinding },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementSearchServiceSearchExpiringAccessForUserResponse>): AppEntitlementSearchServiceSearchExpiringAccessForUserResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementSearchServiceSearchExpiringAccessForUserResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementSearchServiceSearchExpiringAccessForUserResponse): AppEntitlementSearchServiceSearchExpiringAccessForUserResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementWithUserBinding list */ 1:
                    message.list.push(AppEntitlementWithUserBinding.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementSearchServiceSearchExpiringAccessForUserResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementWithUserBinding list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementWithUserBinding.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchExpiringAccessForUserResponse
 */
export const AppEntitlementSearchServiceSearchExpiringAccessForUserResponse = new AppEntitlementSearchServiceSearchExpiringAccessForUserResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceSearchGrantsRequest$Type extends MessageType<AppEntitlementSearchServiceSearchGrantsRequest> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceSearchGrantsRequest", [
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask },
            { no: 5, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "app_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 7, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } },
            { no: 8, name: "resource_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } },
            { no: 9, name: "entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 10, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "purpose", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.app.v1.AppEntitlementPurposeValue", AppEntitlementPurposeValue, "APP_ENTITLEMENT_PURPOSE_VALUE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementSearchServiceSearchGrantsRequest>): AppEntitlementSearchServiceSearchGrantsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.appIds = [];
        message.appUserIds = [];
        message.resourceTypeIds = [];
        message.resourceIds = [];
        message.entitlementRefs = [];
        message.userId = "";
        message.purpose = [];
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementSearchServiceSearchGrantsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementSearchServiceSearchGrantsRequest): AppEntitlementSearchServiceSearchGrantsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementExpandMask expand_mask */ 4:
                    message.expandMask = AppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated string app_ids */ 5:
                    message.appIds.push(reader.string());
                    break;
                case /* repeated string app_user_ids */ 6:
                    message.appUserIds.push(reader.string());
                    break;
                case /* repeated string resource_type_ids */ 7:
                    message.resourceTypeIds.push(reader.string());
                    break;
                case /* repeated string resource_ids */ 8:
                    message.resourceIds.push(reader.string());
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef entitlement_refs */ 9:
                    message.entitlementRefs.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string user_id */ 10:
                    message.userId = reader.string();
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementPurposeValue purpose */ 11:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.purpose.push(reader.int32());
                    else
                        message.purpose.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementSearchServiceSearchGrantsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.app.v1.AppEntitlementExpandMask expand_mask = 4; */
        if (message.expandMask)
            AppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated string app_ids = 5; */
        for (let i = 0; i < message.appIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.appIds[i]);
        /* repeated string app_user_ids = 6; */
        for (let i = 0; i < message.appUserIds.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.appUserIds[i]);
        /* repeated string resource_type_ids = 7; */
        for (let i = 0; i < message.resourceTypeIds.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.resourceTypeIds[i]);
        /* repeated string resource_ids = 8; */
        for (let i = 0; i < message.resourceIds.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.resourceIds[i]);
        /* repeated c1.api.app.v1.AppEntitlementRef entitlement_refs = 9; */
        for (let i = 0; i < message.entitlementRefs.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.entitlementRefs[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* string user_id = 10; */
        if (message.userId !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.userId);
        /* repeated c1.api.app.v1.AppEntitlementPurposeValue purpose = 11; */
        if (message.purpose.length) {
            writer.tag(11, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.purpose.length; i++)
                writer.int32(message.purpose[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchGrantsRequest
 */
export const AppEntitlementSearchServiceSearchGrantsRequest = new AppEntitlementSearchServiceSearchGrantsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceSearchGrantsResponse$Type extends MessageType<AppEntitlementSearchServiceSearchGrantsResponse> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceSearchGrantsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementWithUserBinding },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementSearchServiceSearchGrantsResponse>): AppEntitlementSearchServiceSearchGrantsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementSearchServiceSearchGrantsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementSearchServiceSearchGrantsResponse): AppEntitlementSearchServiceSearchGrantsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementWithUserBinding list */ 1:
                    message.list.push(AppEntitlementWithUserBinding.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementSearchServiceSearchGrantsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementWithUserBinding list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementWithUserBinding.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchGrantsResponse
 */
export const AppEntitlementSearchServiceSearchGrantsResponse = new AppEntitlementSearchServiceSearchGrantsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceSearchExpiringAccessForUserCountRequest$Type extends MessageType<AppEntitlementSearchServiceSearchExpiringAccessForUserCountRequest> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceSearchExpiringAccessForUserCountRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "expires_before", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementSearchServiceSearchExpiringAccessForUserCountRequest>): AppEntitlementSearchServiceSearchExpiringAccessForUserCountRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.targetUserId = "";
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementSearchServiceSearchExpiringAccessForUserCountRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementSearchServiceSearchExpiringAccessForUserCountRequest): AppEntitlementSearchServiceSearchExpiringAccessForUserCountRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string target_user_id */ 1:
                    message.targetUserId = reader.string();
                    break;
                case /* google.protobuf.Timestamp expires_before */ 2:
                    message.expiresBefore = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresBefore);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementSearchServiceSearchExpiringAccessForUserCountRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string target_user_id = 1; */
        if (message.targetUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.targetUserId);
        /* google.protobuf.Timestamp expires_before = 2; */
        if (message.expiresBefore)
            Timestamp.internalBinaryWrite(message.expiresBefore, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchExpiringAccessForUserCountRequest
 */
export const AppEntitlementSearchServiceSearchExpiringAccessForUserCountRequest = new AppEntitlementSearchServiceSearchExpiringAccessForUserCountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceSearchExpiringAccessForUserCountResponse$Type extends MessageType<AppEntitlementSearchServiceSearchExpiringAccessForUserCountResponse> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceSearchExpiringAccessForUserCountResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementSearchServiceSearchExpiringAccessForUserCountResponse>): AppEntitlementSearchServiceSearchExpiringAccessForUserCountResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementSearchServiceSearchExpiringAccessForUserCountResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementSearchServiceSearchExpiringAccessForUserCountResponse): AppEntitlementSearchServiceSearchExpiringAccessForUserCountResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 count */ 1:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementSearchServiceSearchExpiringAccessForUserCountResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchExpiringAccessForUserCountResponse
 */
export const AppEntitlementSearchServiceSearchExpiringAccessForUserCountResponse = new AppEntitlementSearchServiceSearchExpiringAccessForUserCountResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountGrantsExpiringBeforeRequest$Type extends MessageType<CountGrantsExpiringBeforeRequest> {
    constructor() {
        super("c1.api.app.v1.CountGrantsExpiringBeforeRequest", [
            { no: 1, name: "expires_before", kind: "message", T: () => Timestamp, options: { "validate.rules": { timestamp: { required: true } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<CountGrantsExpiringBeforeRequest>): CountGrantsExpiringBeforeRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<CountGrantsExpiringBeforeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountGrantsExpiringBeforeRequest): CountGrantsExpiringBeforeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp expires_before */ 1:
                    message.expiresBefore = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresBefore);
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountGrantsExpiringBeforeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp expires_before = 1; */
        if (message.expiresBefore)
            Timestamp.internalBinaryWrite(message.expiresBefore, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CountGrantsExpiringBeforeRequest
 */
export const CountGrantsExpiringBeforeRequest = new CountGrantsExpiringBeforeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountGrantsExpiringBeforeResponse$Type extends MessageType<CountGrantsExpiringBeforeResponse> {
    constructor() {
        super("c1.api.app.v1.CountGrantsExpiringBeforeResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<CountGrantsExpiringBeforeResponse>): CountGrantsExpiringBeforeResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<CountGrantsExpiringBeforeResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountGrantsExpiringBeforeResponse): CountGrantsExpiringBeforeResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 count */ 1:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountGrantsExpiringBeforeResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CountGrantsExpiringBeforeResponse
 */
export const CountGrantsExpiringBeforeResponse = new CountGrantsExpiringBeforeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchGrantsExpiringBeforeRequest$Type extends MessageType<SearchGrantsExpiringBeforeRequest> {
    constructor() {
        super("c1.api.app.v1.SearchGrantsExpiringBeforeRequest", [
            { no: 1, name: "expires_before", kind: "message", T: () => Timestamp, options: { "validate.rules": { timestamp: { required: true } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
    create(value?: PartialMessage<SearchGrantsExpiringBeforeRequest>): SearchGrantsExpiringBeforeRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchGrantsExpiringBeforeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchGrantsExpiringBeforeRequest): SearchGrantsExpiringBeforeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp expires_before */ 1:
                    message.expiresBefore = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresBefore);
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementExpandMask expand_mask */ 5:
                    message.expandMask = AppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchGrantsExpiringBeforeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp expires_before = 1; */
        if (message.expiresBefore)
            Timestamp.internalBinaryWrite(message.expiresBefore, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.app.v1.AppEntitlementExpandMask expand_mask = 5; */
        if (message.expandMask)
            AppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchGrantsExpiringBeforeRequest
 */
export const SearchGrantsExpiringBeforeRequest = new SearchGrantsExpiringBeforeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchGrantsExpiringBeforeResponse$Type extends MessageType<SearchGrantsExpiringBeforeResponse> {
    constructor() {
        super("c1.api.app.v1.SearchGrantsExpiringBeforeResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementWithUserBinding },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<SearchGrantsExpiringBeforeResponse>): SearchGrantsExpiringBeforeResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<SearchGrantsExpiringBeforeResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchGrantsExpiringBeforeResponse): SearchGrantsExpiringBeforeResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementWithUserBinding list */ 1:
                    message.list.push(AppEntitlementWithUserBinding.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchGrantsExpiringBeforeResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementWithUserBinding list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementWithUserBinding.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchGrantsExpiringBeforeResponse
 */
export const SearchGrantsExpiringBeforeResponse = new SearchGrantsExpiringBeforeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceSearchTermsRequest$Type extends MessageType<AppEntitlementSearchServiceSearchTermsRequest> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceSearchTermsRequest", [
            { no: 1, name: "search", kind: "message", T: () => AppEntitlementSearchServiceSearchRequest },
            { no: 2, name: "term", kind: "enum", T: () => ["c1.api.app.v1.AppEntitlementSearchServiceSearchTermsRequest.TermType", AppEntitlementSearchServiceSearchTermsRequest_TermType] },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "include_count", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementSearchServiceSearchTermsRequest>): AppEntitlementSearchServiceSearchTermsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.term = 0;
        message.query = "";
        message.includeCount = false;
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementSearchServiceSearchTermsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementSearchServiceSearchTermsRequest): AppEntitlementSearchServiceSearchTermsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementSearchServiceSearchRequest search */ 1:
                    message.search = AppEntitlementSearchServiceSearchRequest.internalBinaryRead(reader, reader.uint32(), options, message.search);
                    break;
                case /* c1.api.app.v1.AppEntitlementSearchServiceSearchTermsRequest.TermType term */ 2:
                    message.term = reader.int32();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* bool include_count */ 4:
                    message.includeCount = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementSearchServiceSearchTermsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementSearchServiceSearchRequest search = 1; */
        if (message.search)
            AppEntitlementSearchServiceSearchRequest.internalBinaryWrite(message.search, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppEntitlementSearchServiceSearchTermsRequest.TermType term = 2; */
        if (message.term !== 0)
            writer.tag(2, WireType.Varint).int32(message.term);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* bool include_count = 4; */
        if (message.includeCount !== false)
            writer.tag(4, WireType.Varint).bool(message.includeCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchTermsRequest
 */
export const AppEntitlementSearchServiceSearchTermsRequest = new AppEntitlementSearchServiceSearchTermsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceSearchTermsResponse$Type extends MessageType<AppEntitlementSearchServiceSearchTermsResponse> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceSearchTermsResponse", [
            { no: 1, name: "facets", kind: "message", T: () => Facets },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementSearchServiceSearchTermsResponse>): AppEntitlementSearchServiceSearchTermsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementSearchServiceSearchTermsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementSearchServiceSearchTermsResponse): AppEntitlementSearchServiceSearchTermsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.search.v1.Facets facets */ 1:
                    message.facets = Facets.internalBinaryRead(reader, reader.uint32(), options, message.facets);
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementSearchServiceSearchTermsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.search.v1.Facets facets = 1; */
        if (message.facets)
            Facets.internalBinaryWrite(message.facets, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchTermsResponse
 */
export const AppEntitlementSearchServiceSearchTermsResponse = new AppEntitlementSearchServiceSearchTermsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceSearchRequest$Type extends MessageType<AppEntitlementSearchServiceSearchRequest> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "exclude_app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask },
            { no: 7, name: "exclude_app_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 8, name: "app_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 10, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } },
            { no: 11, name: "risk_level_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 12, name: "compliance_framework_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 19, name: "resource_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } },
            { no: 15, name: "only_get_expiring", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 17, name: "alias", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "include_deleted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 20, name: "is_automated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 21, name: "resource_trait_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } },
            { no: 22, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef },
            { no: 24, name: "membership_type", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.app.v1.AppEntitlementMembershipType", AppEntitlementMembershipType, "APP_ENTITLEMENT_MEMBERSHIP_TYPE_"] },
            { no: 25, name: "exclude_resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } },
            { no: 26, name: "source_connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 27, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 28, name: "exclude_immutable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 29, name: "excluded_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 30, name: "policy_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PolicyRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementSearchServiceSearchRequest>): AppEntitlementSearchServiceSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.excludeAppIds = [];
        message.appIds = [];
        message.excludeAppUserIds = [];
        message.appUserIds = [];
        message.resourceTypeIds = [];
        message.riskLevelIds = [];
        message.complianceFrameworkIds = [];
        message.resourceIds = [];
        message.onlyGetExpiring = false;
        message.accessReviewId = "";
        message.alias = "";
        message.includeDeleted = false;
        message.isAutomated = false;
        message.resourceTraitIds = [];
        message.refs = [];
        message.membershipType = [];
        message.excludeResourceTypeIds = [];
        message.sourceConnectorId = "";
        message.displayName = "";
        message.excludeImmutable = false;
        message.excludedEntitlementRefs = [];
        message.policyRefs = [];
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementSearchServiceSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementSearchServiceSearchRequest): AppEntitlementSearchServiceSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* repeated string exclude_app_ids */ 4:
                    message.excludeAppIds.push(reader.string());
                    break;
                case /* repeated string app_ids */ 5:
                    message.appIds.push(reader.string());
                    break;
                case /* c1.api.app.v1.AppEntitlementExpandMask expand_mask */ 6:
                    message.expandMask = AppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated string exclude_app_user_ids */ 7:
                    message.excludeAppUserIds.push(reader.string());
                    break;
                case /* repeated string app_user_ids */ 8:
                    message.appUserIds.push(reader.string());
                    break;
                case /* repeated string resource_type_ids */ 10:
                    message.resourceTypeIds.push(reader.string());
                    break;
                case /* repeated string risk_level_ids */ 11:
                    message.riskLevelIds.push(reader.string());
                    break;
                case /* repeated string compliance_framework_ids */ 12:
                    message.complianceFrameworkIds.push(reader.string());
                    break;
                case /* repeated string resource_ids */ 19:
                    message.resourceIds.push(reader.string());
                    break;
                case /* bool only_get_expiring */ 15:
                    message.onlyGetExpiring = reader.bool();
                    break;
                case /* string access_review_id */ 16:
                    message.accessReviewId = reader.string();
                    break;
                case /* string alias */ 17:
                    message.alias = reader.string();
                    break;
                case /* bool include_deleted */ 18:
                    message.includeDeleted = reader.bool();
                    break;
                case /* bool is_automated */ 20:
                    message.isAutomated = reader.bool();
                    break;
                case /* repeated string resource_trait_ids */ 21:
                    message.resourceTraitIds.push(reader.string());
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef refs */ 22:
                    message.refs.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementMembershipType membership_type */ 24:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.membershipType.push(reader.int32());
                    else
                        message.membershipType.push(reader.int32());
                    break;
                case /* repeated string exclude_resource_type_ids */ 25:
                    message.excludeResourceTypeIds.push(reader.string());
                    break;
                case /* string source_connector_id */ 26:
                    message.sourceConnectorId = reader.string();
                    break;
                case /* string display_name */ 27:
                    message.displayName = reader.string();
                    break;
                case /* bool exclude_immutable */ 28:
                    message.excludeImmutable = reader.bool();
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef excluded_entitlement_refs */ 29:
                    message.excludedEntitlementRefs.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.policy.v1.PolicyRef policy_refs */ 30:
                    message.policyRefs.push(PolicyRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementSearchServiceSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* repeated string exclude_app_ids = 4; */
        for (let i = 0; i < message.excludeAppIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.excludeAppIds[i]);
        /* repeated string app_ids = 5; */
        for (let i = 0; i < message.appIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.appIds[i]);
        /* c1.api.app.v1.AppEntitlementExpandMask expand_mask = 6; */
        if (message.expandMask)
            AppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated string exclude_app_user_ids = 7; */
        for (let i = 0; i < message.excludeAppUserIds.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.excludeAppUserIds[i]);
        /* repeated string app_user_ids = 8; */
        for (let i = 0; i < message.appUserIds.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.appUserIds[i]);
        /* repeated string resource_type_ids = 10; */
        for (let i = 0; i < message.resourceTypeIds.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.resourceTypeIds[i]);
        /* repeated string risk_level_ids = 11; */
        for (let i = 0; i < message.riskLevelIds.length; i++)
            writer.tag(11, WireType.LengthDelimited).string(message.riskLevelIds[i]);
        /* repeated string compliance_framework_ids = 12; */
        for (let i = 0; i < message.complianceFrameworkIds.length; i++)
            writer.tag(12, WireType.LengthDelimited).string(message.complianceFrameworkIds[i]);
        /* bool only_get_expiring = 15; */
        if (message.onlyGetExpiring !== false)
            writer.tag(15, WireType.Varint).bool(message.onlyGetExpiring);
        /* string access_review_id = 16; */
        if (message.accessReviewId !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.accessReviewId);
        /* string alias = 17; */
        if (message.alias !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.alias);
        /* bool include_deleted = 18; */
        if (message.includeDeleted !== false)
            writer.tag(18, WireType.Varint).bool(message.includeDeleted);
        /* repeated string resource_ids = 19; */
        for (let i = 0; i < message.resourceIds.length; i++)
            writer.tag(19, WireType.LengthDelimited).string(message.resourceIds[i]);
        /* bool is_automated = 20; */
        if (message.isAutomated !== false)
            writer.tag(20, WireType.Varint).bool(message.isAutomated);
        /* repeated string resource_trait_ids = 21; */
        for (let i = 0; i < message.resourceTraitIds.length; i++)
            writer.tag(21, WireType.LengthDelimited).string(message.resourceTraitIds[i]);
        /* repeated c1.api.app.v1.AppEntitlementRef refs = 22; */
        for (let i = 0; i < message.refs.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.refs[i], writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.AppEntitlementMembershipType membership_type = 24; */
        if (message.membershipType.length) {
            writer.tag(24, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.membershipType.length; i++)
                writer.int32(message.membershipType[i]);
            writer.join();
        }
        /* repeated string exclude_resource_type_ids = 25; */
        for (let i = 0; i < message.excludeResourceTypeIds.length; i++)
            writer.tag(25, WireType.LengthDelimited).string(message.excludeResourceTypeIds[i]);
        /* string source_connector_id = 26; */
        if (message.sourceConnectorId !== "")
            writer.tag(26, WireType.LengthDelimited).string(message.sourceConnectorId);
        /* string display_name = 27; */
        if (message.displayName !== "")
            writer.tag(27, WireType.LengthDelimited).string(message.displayName);
        /* bool exclude_immutable = 28; */
        if (message.excludeImmutable !== false)
            writer.tag(28, WireType.Varint).bool(message.excludeImmutable);
        /* repeated c1.api.app.v1.AppEntitlementRef excluded_entitlement_refs = 29; */
        for (let i = 0; i < message.excludedEntitlementRefs.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.excludedEntitlementRefs[i], writer.tag(29, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.policy.v1.PolicyRef policy_refs = 30; */
        for (let i = 0; i < message.policyRefs.length; i++)
            PolicyRef.internalBinaryWrite(message.policyRefs[i], writer.tag(30, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchRequest
 */
export const AppEntitlementSearchServiceSearchRequest = new AppEntitlementSearchServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceSearchResponse$Type extends MessageType<AppEntitlementSearchServiceSearchResponse> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "facets", kind: "message", T: () => Facets }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementSearchServiceSearchResponse>): AppEntitlementSearchServiceSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementSearchServiceSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementSearchServiceSearchResponse): AppEntitlementSearchServiceSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementView list */ 1:
                    message.list.push(AppEntitlementView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                case /* c1.api.search.v1.Facets facets */ 4:
                    message.facets = Facets.internalBinaryRead(reader, reader.uint32(), options, message.facets);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementSearchServiceSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        /* c1.api.search.v1.Facets facets = 4; */
        if (message.facets)
            Facets.internalBinaryWrite(message.facets, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchResponse
 */
export const AppEntitlementSearchServiceSearchResponse = new AppEntitlementSearchServiceSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementsWithOneOwnerRequest$Type extends MessageType<SearchAppEntitlementsWithOneOwnerRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementsWithOneOwnerRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
    create(value?: PartialMessage<SearchAppEntitlementsWithOneOwnerRequest>): SearchAppEntitlementsWithOneOwnerRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAppEntitlementsWithOneOwnerRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppEntitlementsWithOneOwnerRequest): SearchAppEntitlementsWithOneOwnerRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementExpandMask expand_mask */ 3:
                    message.expandMask = AppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppEntitlementsWithOneOwnerRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.app.v1.AppEntitlementExpandMask expand_mask = 3; */
        if (message.expandMask)
            AppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementsWithOneOwnerRequest
 */
export const SearchAppEntitlementsWithOneOwnerRequest = new SearchAppEntitlementsWithOneOwnerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementWithOneOwner$Type extends MessageType<AppEntitlementWithOneOwner> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementWithOneOwner", [
            { no: 1, name: "entitlement", kind: "message", T: () => AppEntitlementView },
            { no: 2, name: "user", kind: "message", T: () => User }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementWithOneOwner>): AppEntitlementWithOneOwner {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementWithOneOwner>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementWithOneOwner): AppEntitlementWithOneOwner {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementView entitlement */ 1:
                    message.entitlement = AppEntitlementView.internalBinaryRead(reader, reader.uint32(), options, message.entitlement);
                    break;
                case /* c1.api.user.v1.User user */ 2:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementWithOneOwner, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementView entitlement = 1; */
        if (message.entitlement)
            AppEntitlementView.internalBinaryWrite(message.entitlement, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.user.v1.User user = 2; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementWithOneOwner
 */
export const AppEntitlementWithOneOwner = new AppEntitlementWithOneOwner$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementsWithOneOwnerResponse$Type extends MessageType<SearchAppEntitlementsWithOneOwnerResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementsWithOneOwnerResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementWithOneOwner },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchAppEntitlementsWithOneOwnerResponse>): SearchAppEntitlementsWithOneOwnerResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAppEntitlementsWithOneOwnerResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppEntitlementsWithOneOwnerResponse): SearchAppEntitlementsWithOneOwnerResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementWithOneOwner list */ 1:
                    message.list.push(AppEntitlementWithOneOwner.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppEntitlementsWithOneOwnerResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementWithOneOwner list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementWithOneOwner.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementsWithOneOwnerResponse
 */
export const SearchAppEntitlementsWithOneOwnerResponse = new SearchAppEntitlementsWithOneOwnerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementsWithDeactivatedOwnerRequest$Type extends MessageType<SearchAppEntitlementsWithDeactivatedOwnerRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementsWithDeactivatedOwnerRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
    create(value?: PartialMessage<SearchAppEntitlementsWithDeactivatedOwnerRequest>): SearchAppEntitlementsWithDeactivatedOwnerRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAppEntitlementsWithDeactivatedOwnerRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppEntitlementsWithDeactivatedOwnerRequest): SearchAppEntitlementsWithDeactivatedOwnerRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementExpandMask expand_mask */ 3:
                    message.expandMask = AppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppEntitlementsWithDeactivatedOwnerRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.app.v1.AppEntitlementExpandMask expand_mask = 3; */
        if (message.expandMask)
            AppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementsWithDeactivatedOwnerRequest
 */
export const SearchAppEntitlementsWithDeactivatedOwnerRequest = new SearchAppEntitlementsWithDeactivatedOwnerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementWithDeactivatedOwner$Type extends MessageType<AppEntitlementWithDeactivatedOwner> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementWithDeactivatedOwner", [
            { no: 1, name: "entitlement", kind: "message", T: () => AppEntitlementView },
            { no: 3, name: "entitlement_owners", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementWithDeactivatedOwner>): AppEntitlementWithDeactivatedOwner {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.entitlementOwners = [];
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementWithDeactivatedOwner>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementWithDeactivatedOwner): AppEntitlementWithDeactivatedOwner {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementView entitlement */ 1:
                    message.entitlement = AppEntitlementView.internalBinaryRead(reader, reader.uint32(), options, message.entitlement);
                    break;
                case /* repeated c1.api.user.v1.User entitlement_owners */ 3:
                    message.entitlementOwners.push(User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementWithDeactivatedOwner, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementView entitlement = 1; */
        if (message.entitlement)
            AppEntitlementView.internalBinaryWrite(message.entitlement, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.user.v1.User entitlement_owners = 3; */
        for (let i = 0; i < message.entitlementOwners.length; i++)
            User.internalBinaryWrite(message.entitlementOwners[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementWithDeactivatedOwner
 */
export const AppEntitlementWithDeactivatedOwner = new AppEntitlementWithDeactivatedOwner$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementsWithDeactivatedOwnerResponse$Type extends MessageType<SearchAppEntitlementsWithDeactivatedOwnerResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementsWithDeactivatedOwnerResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementWithDeactivatedOwner },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchAppEntitlementsWithDeactivatedOwnerResponse>): SearchAppEntitlementsWithDeactivatedOwnerResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAppEntitlementsWithDeactivatedOwnerResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppEntitlementsWithDeactivatedOwnerResponse): SearchAppEntitlementsWithDeactivatedOwnerResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementWithDeactivatedOwner list */ 1:
                    message.list.push(AppEntitlementWithDeactivatedOwner.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppEntitlementsWithDeactivatedOwnerResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementWithDeactivatedOwner list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementWithDeactivatedOwner.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementsWithDeactivatedOwnerResponse
 */
export const SearchAppEntitlementsWithDeactivatedOwnerResponse = new SearchAppEntitlementsWithDeactivatedOwnerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementsForAppUserRequest$Type extends MessageType<SearchAppEntitlementsForAppUserRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementsForAppUserRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask },
            { no: 4, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 6, name: "resource_type_trait_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<SearchAppEntitlementsForAppUserRequest>): SearchAppEntitlementsForAppUserRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.appId = "";
        message.appUserId = "";
        message.resourceTypeTraitIds = [];
        if (value !== undefined)
            reflectionMergePartial<SearchAppEntitlementsForAppUserRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppEntitlementsForAppUserRequest): SearchAppEntitlementsForAppUserRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementExpandMask expand_mask */ 3:
                    message.expandMask = AppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* string app_id */ 4:
                    message.appId = reader.string();
                    break;
                case /* string app_user_id */ 5:
                    message.appUserId = reader.string();
                    break;
                case /* repeated string resource_type_trait_ids */ 6:
                    message.resourceTypeTraitIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppEntitlementsForAppUserRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.app.v1.AppEntitlementExpandMask expand_mask = 3; */
        if (message.expandMask)
            AppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string app_id = 4; */
        if (message.appId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appId);
        /* string app_user_id = 5; */
        if (message.appUserId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.appUserId);
        /* repeated string resource_type_trait_ids = 6; */
        for (let i = 0; i < message.resourceTypeTraitIds.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.resourceTypeTraitIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementsForAppUserRequest
 */
export const SearchAppEntitlementsForAppUserRequest = new SearchAppEntitlementsForAppUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementsWithRevokableForAppUserRequest$Type extends MessageType<SearchAppEntitlementsWithRevokableForAppUserRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementsWithRevokableForAppUserRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
    create(value?: PartialMessage<SearchAppEntitlementsWithRevokableForAppUserRequest>): SearchAppEntitlementsWithRevokableForAppUserRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.appUserId = "";
        message.appId = "";
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAppEntitlementsWithRevokableForAppUserRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppEntitlementsWithRevokableForAppUserRequest): SearchAppEntitlementsWithRevokableForAppUserRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string app_user_id */ 3:
                    message.appUserId = reader.string();
                    break;
                case /* string app_id */ 4:
                    message.appId = reader.string();
                    break;
                case /* string user_id */ 5:
                    message.userId = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementExpandMask expand_mask */ 6:
                    message.expandMask = AppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppEntitlementsWithRevokableForAppUserRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string app_user_id = 3; */
        if (message.appUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appUserId);
        /* string app_id = 4; */
        if (message.appId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appId);
        /* string user_id = 5; */
        if (message.userId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.userId);
        /* c1.api.app.v1.AppEntitlementExpandMask expand_mask = 6; */
        if (message.expandMask)
            AppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementsWithRevokableForAppUserRequest
 */
export const SearchAppEntitlementsWithRevokableForAppUserRequest = new SearchAppEntitlementsWithRevokableForAppUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementsWithRevokableForAppUserResponse$Type extends MessageType<SearchAppEntitlementsWithRevokableForAppUserResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementsWithRevokableForAppUserResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementWithRevokable },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchAppEntitlementsWithRevokableForAppUserResponse>): SearchAppEntitlementsWithRevokableForAppUserResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAppEntitlementsWithRevokableForAppUserResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppEntitlementsWithRevokableForAppUserResponse): SearchAppEntitlementsWithRevokableForAppUserResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementWithRevokable list */ 1:
                    message.list.push(AppEntitlementWithRevokable.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppEntitlementsWithRevokableForAppUserResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementWithRevokable list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementWithRevokable.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementsWithRevokableForAppUserResponse
 */
export const SearchAppEntitlementsWithRevokableForAppUserResponse = new SearchAppEntitlementsWithRevokableForAppUserResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementWithRevokable$Type extends MessageType<AppEntitlementWithRevokable> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementWithRevokable", [
            { no: 1, name: "app_entitlement", kind: "message", T: () => AppEntitlementView },
            { no: 2, name: "is_revokable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementWithRevokable>): AppEntitlementWithRevokable {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isRevokable = false;
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementWithRevokable>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementWithRevokable): AppEntitlementWithRevokable {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementView app_entitlement */ 1:
                    message.appEntitlement = AppEntitlementView.internalBinaryRead(reader, reader.uint32(), options, message.appEntitlement);
                    break;
                case /* bool is_revokable */ 2:
                    message.isRevokable = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementWithRevokable, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementView app_entitlement = 1; */
        if (message.appEntitlement)
            AppEntitlementView.internalBinaryWrite(message.appEntitlement, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool is_revokable = 2; */
        if (message.isRevokable !== false)
            writer.tag(2, WireType.Varint).bool(message.isRevokable);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementWithRevokable
 */
export const AppEntitlementWithRevokable = new AppEntitlementWithRevokable$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRequestableEntitlementsForUserRequest$Type extends MessageType<SearchRequestableEntitlementsForUserRequest> {
    constructor() {
        super("c1.api.app.v1.SearchRequestableEntitlementsForUserRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 8, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 10, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask },
            { no: 11, name: "sort_by", kind: "enum", T: () => ["c1.api.app.v1.SearchRequestableEntitlementsForUserSortBy", SearchRequestableEntitlementsForUserSortBy] },
            { no: 12, name: "exclude_resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 14, name: "include_resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<SearchRequestableEntitlementsForUserRequest>): SearchRequestableEntitlementsForUserRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.userId = "";
        message.appId = "";
        message.query = "";
        message.sortBy = 0;
        message.excludeResourceTypeIds = [];
        message.includeResourceTypeIds = [];
        if (value !== undefined)
            reflectionMergePartial<SearchRequestableEntitlementsForUserRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchRequestableEntitlementsForUserRequest): SearchRequestableEntitlementsForUserRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string user_id */ 3:
                    message.userId = reader.string();
                    break;
                case /* string app_id */ 4:
                    message.appId = reader.string();
                    break;
                case /* string query */ 8:
                    message.query = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementExpandMask expand_mask */ 10:
                    message.expandMask = AppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* c1.api.app.v1.SearchRequestableEntitlementsForUserSortBy sort_by */ 11:
                    message.sortBy = reader.int32();
                    break;
                case /* repeated string exclude_resource_type_ids */ 12:
                    message.excludeResourceTypeIds.push(reader.string());
                    break;
                case /* repeated string include_resource_type_ids */ 14:
                    message.includeResourceTypeIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchRequestableEntitlementsForUserRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string user_id = 3; */
        if (message.userId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.userId);
        /* string app_id = 4; */
        if (message.appId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appId);
        /* string query = 8; */
        if (message.query !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.query);
        /* c1.api.app.v1.AppEntitlementExpandMask expand_mask = 10; */
        if (message.expandMask)
            AppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.SearchRequestableEntitlementsForUserSortBy sort_by = 11; */
        if (message.sortBy !== 0)
            writer.tag(11, WireType.Varint).int32(message.sortBy);
        /* repeated string exclude_resource_type_ids = 12; */
        for (let i = 0; i < message.excludeResourceTypeIds.length; i++)
            writer.tag(12, WireType.LengthDelimited).string(message.excludeResourceTypeIds[i]);
        /* repeated string include_resource_type_ids = 14; */
        for (let i = 0; i < message.includeResourceTypeIds.length; i++)
            writer.tag(14, WireType.LengthDelimited).string(message.includeResourceTypeIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchRequestableEntitlementsForUserRequest
 */
export const SearchRequestableEntitlementsForUserRequest = new SearchRequestableEntitlementsForUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRequestableEntitlementsForUserResponse$Type extends MessageType<SearchRequestableEntitlementsForUserResponse> {
    constructor() {
        super("c1.api.app.v1.SearchRequestableEntitlementsForUserResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchRequestableEntitlementsForUserResponse>): SearchRequestableEntitlementsForUserResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchRequestableEntitlementsForUserResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchRequestableEntitlementsForUserResponse): SearchRequestableEntitlementsForUserResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementView list */ 1:
                    message.list.push(AppEntitlementView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchRequestableEntitlementsForUserResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchRequestableEntitlementsForUserResponse
 */
export const SearchRequestableEntitlementsForUserResponse = new SearchRequestableEntitlementsForUserResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RollupEntitlementsWithGrantsRequest$Type extends MessageType<RollupEntitlementsWithGrantsRequest> {
    constructor() {
        super("c1.api.app.v1.RollupEntitlementsWithGrantsRequest", [
            { no: 1, name: "entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef },
            { no: 2, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementUserBindingRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 6, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<RollupEntitlementsWithGrantsRequest>): RollupEntitlementsWithGrantsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.entitlements = [];
        message.appUserId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.refs = [];
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial<RollupEntitlementsWithGrantsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RollupEntitlementsWithGrantsRequest): RollupEntitlementsWithGrantsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementRef entitlements */ 1:
                    message.entitlements.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string app_user_id */ 2:
                    message.appUserId = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementUserBindingRef refs */ 5:
                    message.refs.push(AppEntitlementUserBindingRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string user_id */ 6:
                    message.userId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RollupEntitlementsWithGrantsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementRef entitlements = 1; */
        for (let i = 0; i < message.entitlements.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.entitlements[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string app_user_id = 2; */
        if (message.appUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appUserId);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        /* repeated c1.api.app.v1.AppEntitlementUserBindingRef refs = 5; */
        for (let i = 0; i < message.refs.length; i++)
            AppEntitlementUserBindingRef.internalBinaryWrite(message.refs[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string user_id = 6; */
        if (message.userId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.RollupEntitlementsWithGrantsRequest
 */
export const RollupEntitlementsWithGrantsRequest = new RollupEntitlementsWithGrantsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RollupEntitlementsWithGrantsResponse$Type extends MessageType<RollupEntitlementsWithGrantsResponse> {
    constructor() {
        super("c1.api.app.v1.RollupEntitlementsWithGrantsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementUserBinding },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RollupEntitlementsWithGrantsResponse>): RollupEntitlementsWithGrantsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<RollupEntitlementsWithGrantsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RollupEntitlementsWithGrantsResponse): RollupEntitlementsWithGrantsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementUserBinding list */ 1:
                    message.list.push(AppEntitlementUserBinding.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RollupEntitlementsWithGrantsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementUserBinding list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementUserBinding.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.RollupEntitlementsWithGrantsResponse
 */
export const RollupEntitlementsWithGrantsResponse = new RollupEntitlementsWithGrantsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlement$Type extends MessageType<AppEntitlement> {
    constructor() {
        super("c1.api.app.v1.AppEntitlement", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "512" } } } },
            { no: 7, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } },
            { no: 10, name: "duration_unset", kind: "message", oneof: "maxGrantDuration", T: () => Empty },
            { no: 11, name: "duration_grant", kind: "message", oneof: "maxGrantDuration", T: () => Duration },
            { no: 13, name: "risk_level_value_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "compliance_framework_value_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "grant_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 18, name: "revoke_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 19, name: "certify_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 27, name: "emergency_grant_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 28, name: "emergency_grant_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 20, name: "grant_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 21, name: "provisioner_policy", kind: "message", T: () => ProvisionPolicy },
            { no: 22, name: "app_resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "app_resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "system_builtin", kind: "scalar", T: 8 /*ScalarType.BOOL*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 25, name: "slug", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 26, name: "alias", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-z0-9][-a-z0-9_.]{0,61}[a-z0-9]$", ignoreEmpty: true } } } },
            { no: 29, name: "user_edited_mask", kind: "message", T: () => FieldMask },
            { no: 30, name: "is_manually_managed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 31, name: "source_connector_ids", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 32, name: "override_access_requests_defaults", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 33, name: "default_values_applied", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 39, name: "is_automation_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 40, name: "purpose", kind: "enum", T: () => ["c1.api.app.v1.AppEntitlementPurposeValue", AppEntitlementPurposeValue, "APP_ENTITLEMENT_PURPOSE_VALUE_"] },
            { no: 41, name: "deprovisioner_policy", kind: "message", T: () => ProvisionPolicy },
            { no: 42, name: "match_baton_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 43, name: "request_schema_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Custom App Entitlement" } }] }, "policy.v1.msg": { enabled: true, name: "app_entitlement", keyFields: ["id", "app_resource_id", "app_resource_type_id", "app_id"] } });
    }
    create(value?: PartialMessage<AppEntitlement>): AppEntitlement {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.id = "";
        message.displayName = "";
        message.description = "";
        message.maxGrantDuration = { oneofKind: undefined };
        message.riskLevelValueId = "";
        message.complianceFrameworkValueIds = [];
        message.grantPolicyId = "";
        message.revokePolicyId = "";
        message.certifyPolicyId = "";
        message.emergencyGrantPolicyId = "";
        message.emergencyGrantEnabled = false;
        message.grantCount = 0;
        message.appResourceTypeId = "";
        message.appResourceId = "";
        message.systemBuiltin = false;
        message.slug = "";
        message.alias = "";
        message.isManuallyManaged = false;
        message.sourceConnectorIds = {};
        message.overrideAccessRequestsDefaults = false;
        message.defaultValuesApplied = false;
        message.isAutomationEnabled = false;
        message.purpose = 0;
        message.matchBatonId = "";
        message.requestSchemaId = "";
        if (value !== undefined)
            reflectionMergePartial<AppEntitlement>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlement): AppEntitlement {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 5:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* string display_name */ 6:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 7:
                    message.description = reader.string();
                    break;
                case /* google.protobuf.Empty duration_unset */ 10:
                    message.maxGrantDuration = {
                        oneofKind: "durationUnset",
                        durationUnset: Empty.internalBinaryRead(reader, reader.uint32(), options, (message.maxGrantDuration as any).durationUnset)
                    };
                    break;
                case /* google.protobuf.Duration duration_grant */ 11:
                    message.maxGrantDuration = {
                        oneofKind: "durationGrant",
                        durationGrant: Duration.internalBinaryRead(reader, reader.uint32(), options, (message.maxGrantDuration as any).durationGrant)
                    };
                    break;
                case /* string risk_level_value_id */ 13:
                    message.riskLevelValueId = reader.string();
                    break;
                case /* repeated string compliance_framework_value_ids */ 14:
                    message.complianceFrameworkValueIds.push(reader.string());
                    break;
                case /* string grant_policy_id */ 17:
                    message.grantPolicyId = reader.string();
                    break;
                case /* string revoke_policy_id */ 18:
                    message.revokePolicyId = reader.string();
                    break;
                case /* string certify_policy_id */ 19:
                    message.certifyPolicyId = reader.string();
                    break;
                case /* string emergency_grant_policy_id */ 27:
                    message.emergencyGrantPolicyId = reader.string();
                    break;
                case /* bool emergency_grant_enabled */ 28:
                    message.emergencyGrantEnabled = reader.bool();
                    break;
                case /* int64 grant_count */ 20:
                    message.grantCount = reader.int64().toNumber();
                    break;
                case /* c1.api.policy.v1.ProvisionPolicy provisioner_policy */ 21:
                    message.provisionerPolicy = ProvisionPolicy.internalBinaryRead(reader, reader.uint32(), options, message.provisionerPolicy);
                    break;
                case /* string app_resource_type_id */ 22:
                    message.appResourceTypeId = reader.string();
                    break;
                case /* string app_resource_id */ 23:
                    message.appResourceId = reader.string();
                    break;
                case /* bool system_builtin */ 24:
                    message.systemBuiltin = reader.bool();
                    break;
                case /* string slug */ 25:
                    message.slug = reader.string();
                    break;
                case /* string alias */ 26:
                    message.alias = reader.string();
                    break;
                case /* google.protobuf.FieldMask user_edited_mask */ 29:
                    message.userEditedMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.userEditedMask);
                    break;
                case /* bool is_manually_managed */ 30:
                    message.isManuallyManaged = reader.bool();
                    break;
                case /* map<string, string> source_connector_ids */ 31:
                    this.binaryReadMap31(message.sourceConnectorIds, reader, options);
                    break;
                case /* bool override_access_requests_defaults */ 32:
                    message.overrideAccessRequestsDefaults = reader.bool();
                    break;
                case /* bool default_values_applied */ 33:
                    message.defaultValuesApplied = reader.bool();
                    break;
                case /* bool is_automation_enabled */ 39:
                    message.isAutomationEnabled = reader.bool();
                    break;
                case /* c1.api.app.v1.AppEntitlementPurposeValue purpose */ 40:
                    message.purpose = reader.int32();
                    break;
                case /* c1.api.policy.v1.ProvisionPolicy deprovisioner_policy */ 41:
                    message.deprovisionerPolicy = ProvisionPolicy.internalBinaryRead(reader, reader.uint32(), options, message.deprovisionerPolicy);
                    break;
                case /* string match_baton_id */ 42:
                    message.matchBatonId = reader.string();
                    break;
                case /* string request_schema_id */ 43:
                    message.requestSchemaId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap31(map: AppEntitlement["sourceConnectorIds"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof AppEntitlement["sourceConnectorIds"] | undefined, val: AppEntitlement["sourceConnectorIds"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.app.v1.AppEntitlement.source_connector_ids");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: AppEntitlement, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        /* google.protobuf.Timestamp created_at = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 5; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string display_name = 6; */
        if (message.displayName !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.displayName);
        /* string description = 7; */
        if (message.description !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.description);
        /* google.protobuf.Empty duration_unset = 10; */
        if (message.maxGrantDuration.oneofKind === "durationUnset")
            Empty.internalBinaryWrite(message.maxGrantDuration.durationUnset, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration duration_grant = 11; */
        if (message.maxGrantDuration.oneofKind === "durationGrant")
            Duration.internalBinaryWrite(message.maxGrantDuration.durationGrant, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* string risk_level_value_id = 13; */
        if (message.riskLevelValueId !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.riskLevelValueId);
        /* repeated string compliance_framework_value_ids = 14; */
        for (let i = 0; i < message.complianceFrameworkValueIds.length; i++)
            writer.tag(14, WireType.LengthDelimited).string(message.complianceFrameworkValueIds[i]);
        /* string grant_policy_id = 17; */
        if (message.grantPolicyId !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.grantPolicyId);
        /* string revoke_policy_id = 18; */
        if (message.revokePolicyId !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.revokePolicyId);
        /* string certify_policy_id = 19; */
        if (message.certifyPolicyId !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.certifyPolicyId);
        /* int64 grant_count = 20; */
        if (message.grantCount !== 0)
            writer.tag(20, WireType.Varint).int64(message.grantCount);
        /* c1.api.policy.v1.ProvisionPolicy provisioner_policy = 21; */
        if (message.provisionerPolicy)
            ProvisionPolicy.internalBinaryWrite(message.provisionerPolicy, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* string app_resource_type_id = 22; */
        if (message.appResourceTypeId !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.appResourceTypeId);
        /* string app_resource_id = 23; */
        if (message.appResourceId !== "")
            writer.tag(23, WireType.LengthDelimited).string(message.appResourceId);
        /* bool system_builtin = 24; */
        if (message.systemBuiltin !== false)
            writer.tag(24, WireType.Varint).bool(message.systemBuiltin);
        /* string slug = 25; */
        if (message.slug !== "")
            writer.tag(25, WireType.LengthDelimited).string(message.slug);
        /* string alias = 26; */
        if (message.alias !== "")
            writer.tag(26, WireType.LengthDelimited).string(message.alias);
        /* string emergency_grant_policy_id = 27; */
        if (message.emergencyGrantPolicyId !== "")
            writer.tag(27, WireType.LengthDelimited).string(message.emergencyGrantPolicyId);
        /* bool emergency_grant_enabled = 28; */
        if (message.emergencyGrantEnabled !== false)
            writer.tag(28, WireType.Varint).bool(message.emergencyGrantEnabled);
        /* google.protobuf.FieldMask user_edited_mask = 29; */
        if (message.userEditedMask)
            FieldMask.internalBinaryWrite(message.userEditedMask, writer.tag(29, WireType.LengthDelimited).fork(), options).join();
        /* bool is_manually_managed = 30; */
        if (message.isManuallyManaged !== false)
            writer.tag(30, WireType.Varint).bool(message.isManuallyManaged);
        /* map<string, string> source_connector_ids = 31; */
        for (let k of globalThis.Object.keys(message.sourceConnectorIds))
            writer.tag(31, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.sourceConnectorIds[k]).join();
        /* bool override_access_requests_defaults = 32; */
        if (message.overrideAccessRequestsDefaults !== false)
            writer.tag(32, WireType.Varint).bool(message.overrideAccessRequestsDefaults);
        /* bool default_values_applied = 33; */
        if (message.defaultValuesApplied !== false)
            writer.tag(33, WireType.Varint).bool(message.defaultValuesApplied);
        /* bool is_automation_enabled = 39; */
        if (message.isAutomationEnabled !== false)
            writer.tag(39, WireType.Varint).bool(message.isAutomationEnabled);
        /* c1.api.app.v1.AppEntitlementPurposeValue purpose = 40; */
        if (message.purpose !== 0)
            writer.tag(40, WireType.Varint).int32(message.purpose);
        /* c1.api.policy.v1.ProvisionPolicy deprovisioner_policy = 41; */
        if (message.deprovisionerPolicy)
            ProvisionPolicy.internalBinaryWrite(message.deprovisionerPolicy, writer.tag(41, WireType.LengthDelimited).fork(), options).join();
        /* string match_baton_id = 42; */
        if (message.matchBatonId !== "")
            writer.tag(42, WireType.LengthDelimited).string(message.matchBatonId);
        /* string request_schema_id = 43; */
        if (message.requestSchemaId !== "")
            writer.tag(43, WireType.LengthDelimited).string(message.requestSchemaId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlement
 */
export const AppEntitlement = new AppEntitlement$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementView$Type extends MessageType<AppEntitlementView> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementView", [
            { no: 1, name: "app_entitlement", kind: "message", T: () => AppEntitlement },
            { no: 2, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_resource_type_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_resource_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "object_permissions", kind: "message", T: () => ActorObjectPermissions }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementView>): AppEntitlementView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appPath = "";
        message.appResourceTypePath = "";
        message.appResourcePath = "";
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementView): AppEntitlementView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlement app_entitlement */ 1:
                    message.appEntitlement = AppEntitlement.internalBinaryRead(reader, reader.uint32(), options, message.appEntitlement);
                    break;
                case /* string app_path */ 2:
                    message.appPath = reader.string();
                    break;
                case /* string app_resource_type_path */ 3:
                    message.appResourceTypePath = reader.string();
                    break;
                case /* string app_resource_path */ 4:
                    message.appResourcePath = reader.string();
                    break;
                case /* c1.api.iam.v1.ActorObjectPermissions object_permissions */ 5:
                    message.objectPermissions = ActorObjectPermissions.internalBinaryRead(reader, reader.uint32(), options, message.objectPermissions);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlement app_entitlement = 1; */
        if (message.appEntitlement)
            AppEntitlement.internalBinaryWrite(message.appEntitlement, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string app_path = 2; */
        if (message.appPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appPath);
        /* string app_resource_type_path = 3; */
        if (message.appResourceTypePath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appResourceTypePath);
        /* string app_resource_path = 4; */
        if (message.appResourcePath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appResourcePath);
        /* c1.api.iam.v1.ActorObjectPermissions object_permissions = 5; */
        if (message.objectPermissions)
            ActorObjectPermissions.internalBinaryWrite(message.objectPermissions, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementView
 */
export const AppEntitlementView = new AppEntitlementView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CatalogEntry$Type extends MessageType<CatalogEntry> {
    constructor() {
        super("c1.api.app.v1.CatalogEntry", [
            { no: 1, name: "app_entitlement", kind: "message", T: () => AppEntitlement },
            { no: 2, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_resource_type_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_resource_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "enrolled_members_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 6, name: "total_members_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<CatalogEntry>): CatalogEntry {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appPath = "";
        message.appResourceTypePath = "";
        message.appResourcePath = "";
        message.enrolledMembersCount = 0;
        message.totalMembersCount = 0;
        if (value !== undefined)
            reflectionMergePartial<CatalogEntry>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CatalogEntry): CatalogEntry {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlement app_entitlement */ 1:
                    message.appEntitlement = AppEntitlement.internalBinaryRead(reader, reader.uint32(), options, message.appEntitlement);
                    break;
                case /* string app_path */ 2:
                    message.appPath = reader.string();
                    break;
                case /* string app_resource_type_path */ 3:
                    message.appResourceTypePath = reader.string();
                    break;
                case /* string app_resource_path */ 4:
                    message.appResourcePath = reader.string();
                    break;
                case /* int64 enrolled_members_count */ 5:
                    message.enrolledMembersCount = reader.int64().toNumber();
                    break;
                case /* int64 total_members_count */ 6:
                    message.totalMembersCount = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CatalogEntry, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlement app_entitlement = 1; */
        if (message.appEntitlement)
            AppEntitlement.internalBinaryWrite(message.appEntitlement, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string app_path = 2; */
        if (message.appPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appPath);
        /* string app_resource_type_path = 3; */
        if (message.appResourceTypePath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appResourceTypePath);
        /* string app_resource_path = 4; */
        if (message.appResourcePath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appResourcePath);
        /* int64 enrolled_members_count = 5; */
        if (message.enrolledMembersCount !== 0)
            writer.tag(5, WireType.Varint).int64(message.enrolledMembersCount);
        /* int64 total_members_count = 6; */
        if (message.totalMembersCount !== 0)
            writer.tag(6, WireType.Varint).int64(message.totalMembersCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CatalogEntry
 */
export const CatalogEntry = new CatalogEntry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementExpandMask$Type extends MessageType<AppEntitlementExpandMask> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_id", "app_resource_type_id", "app_resource_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementExpandMask>): AppEntitlementExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementExpandMask): AppEntitlementExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementExpandMask
 */
export const AppEntitlementExpandMask = new AppEntitlementExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAppEntitlementRequest$Type extends MessageType<CreateAppEntitlementRequest> {
    constructor() {
        super("c1.api.app.v1.CreateAppEntitlementRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask },
            { no: 5, name: "app_resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 6, name: "app_resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 7, name: "slug", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "512" } } } },
            { no: 8, name: "app_entitlement_owner_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 9, name: "emergency_grant_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "emergency_grant_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 11, name: "grant_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 12, name: "revoke_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 13, name: "certify_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 14, name: "risk_level_value_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 15, name: "compliance_framework_value_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 16, name: "alias", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-z0-9][-a-z0-9_.]{0,61}[a-z0-9]$", ignoreEmpty: true } } } },
            { no: 17, name: "purpose", kind: "enum", T: () => ["c1.api.app.v1.AppEntitlementPurposeValue", AppEntitlementPurposeValue, "APP_ENTITLEMENT_PURPOSE_VALUE_"] },
            { no: 18, name: "provision_policy", kind: "message", T: () => ProvisionPolicy },
            { no: 19, name: "duration_unset", kind: "message", oneof: "maxGrantDuration", T: () => Empty },
            { no: 20, name: "duration_grant", kind: "message", oneof: "maxGrantDuration", T: () => Duration },
            { no: 21, name: "override_access_requests_defaults", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 22, name: "match_baton_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CreateAppEntitlementRequest>): CreateAppEntitlementRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.displayName = "";
        message.description = "";
        message.appResourceTypeId = "";
        message.appResourceId = "";
        message.slug = "";
        message.appEntitlementOwnerIds = [];
        message.emergencyGrantEnabled = false;
        message.emergencyGrantPolicyId = "";
        message.grantPolicyId = "";
        message.revokePolicyId = "";
        message.certifyPolicyId = "";
        message.riskLevelValueId = "";
        message.complianceFrameworkValueIds = [];
        message.alias = "";
        message.purpose = 0;
        message.maxGrantDuration = { oneofKind: undefined };
        message.overrideAccessRequestsDefaults = false;
        message.matchBatonId = "";
        if (value !== undefined)
            reflectionMergePartial<CreateAppEntitlementRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAppEntitlementRequest): CreateAppEntitlementRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementExpandMask expand_mask */ 4:
                    message.expandMask = AppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* string app_resource_type_id */ 5:
                    message.appResourceTypeId = reader.string();
                    break;
                case /* string app_resource_id */ 6:
                    message.appResourceId = reader.string();
                    break;
                case /* string slug */ 7:
                    message.slug = reader.string();
                    break;
                case /* repeated string app_entitlement_owner_ids */ 8:
                    message.appEntitlementOwnerIds.push(reader.string());
                    break;
                case /* bool emergency_grant_enabled */ 9:
                    message.emergencyGrantEnabled = reader.bool();
                    break;
                case /* string emergency_grant_policy_id */ 10:
                    message.emergencyGrantPolicyId = reader.string();
                    break;
                case /* string grant_policy_id */ 11:
                    message.grantPolicyId = reader.string();
                    break;
                case /* string revoke_policy_id */ 12:
                    message.revokePolicyId = reader.string();
                    break;
                case /* string certify_policy_id */ 13:
                    message.certifyPolicyId = reader.string();
                    break;
                case /* string risk_level_value_id */ 14:
                    message.riskLevelValueId = reader.string();
                    break;
                case /* repeated string compliance_framework_value_ids */ 15:
                    message.complianceFrameworkValueIds.push(reader.string());
                    break;
                case /* string alias */ 16:
                    message.alias = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementPurposeValue purpose */ 17:
                    message.purpose = reader.int32();
                    break;
                case /* c1.api.policy.v1.ProvisionPolicy provision_policy */ 18:
                    message.provisionPolicy = ProvisionPolicy.internalBinaryRead(reader, reader.uint32(), options, message.provisionPolicy);
                    break;
                case /* google.protobuf.Empty duration_unset */ 19:
                    message.maxGrantDuration = {
                        oneofKind: "durationUnset",
                        durationUnset: Empty.internalBinaryRead(reader, reader.uint32(), options, (message.maxGrantDuration as any).durationUnset)
                    };
                    break;
                case /* google.protobuf.Duration duration_grant */ 20:
                    message.maxGrantDuration = {
                        oneofKind: "durationGrant",
                        durationGrant: Duration.internalBinaryRead(reader, reader.uint32(), options, (message.maxGrantDuration as any).durationGrant)
                    };
                    break;
                case /* bool override_access_requests_defaults */ 21:
                    message.overrideAccessRequestsDefaults = reader.bool();
                    break;
                case /* string match_baton_id */ 22:
                    message.matchBatonId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAppEntitlementRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* c1.api.app.v1.AppEntitlementExpandMask expand_mask = 4; */
        if (message.expandMask)
            AppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string app_resource_type_id = 5; */
        if (message.appResourceTypeId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.appResourceTypeId);
        /* string app_resource_id = 6; */
        if (message.appResourceId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.appResourceId);
        /* string slug = 7; */
        if (message.slug !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.slug);
        /* repeated string app_entitlement_owner_ids = 8; */
        for (let i = 0; i < message.appEntitlementOwnerIds.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.appEntitlementOwnerIds[i]);
        /* bool emergency_grant_enabled = 9; */
        if (message.emergencyGrantEnabled !== false)
            writer.tag(9, WireType.Varint).bool(message.emergencyGrantEnabled);
        /* string emergency_grant_policy_id = 10; */
        if (message.emergencyGrantPolicyId !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.emergencyGrantPolicyId);
        /* string grant_policy_id = 11; */
        if (message.grantPolicyId !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.grantPolicyId);
        /* string revoke_policy_id = 12; */
        if (message.revokePolicyId !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.revokePolicyId);
        /* string certify_policy_id = 13; */
        if (message.certifyPolicyId !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.certifyPolicyId);
        /* string risk_level_value_id = 14; */
        if (message.riskLevelValueId !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.riskLevelValueId);
        /* repeated string compliance_framework_value_ids = 15; */
        for (let i = 0; i < message.complianceFrameworkValueIds.length; i++)
            writer.tag(15, WireType.LengthDelimited).string(message.complianceFrameworkValueIds[i]);
        /* string alias = 16; */
        if (message.alias !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.alias);
        /* c1.api.app.v1.AppEntitlementPurposeValue purpose = 17; */
        if (message.purpose !== 0)
            writer.tag(17, WireType.Varint).int32(message.purpose);
        /* c1.api.policy.v1.ProvisionPolicy provision_policy = 18; */
        if (message.provisionPolicy)
            ProvisionPolicy.internalBinaryWrite(message.provisionPolicy, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Empty duration_unset = 19; */
        if (message.maxGrantDuration.oneofKind === "durationUnset")
            Empty.internalBinaryWrite(message.maxGrantDuration.durationUnset, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Duration duration_grant = 20; */
        if (message.maxGrantDuration.oneofKind === "durationGrant")
            Duration.internalBinaryWrite(message.maxGrantDuration.durationGrant, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* bool override_access_requests_defaults = 21; */
        if (message.overrideAccessRequestsDefaults !== false)
            writer.tag(21, WireType.Varint).bool(message.overrideAccessRequestsDefaults);
        /* string match_baton_id = 22; */
        if (message.matchBatonId !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.matchBatonId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CreateAppEntitlementRequest
 */
export const CreateAppEntitlementRequest = new CreateAppEntitlementRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAppEntitlementResponse$Type extends MessageType<CreateAppEntitlementResponse> {
    constructor() {
        super("c1.api.app.v1.CreateAppEntitlementResponse", [
            { no: 1, name: "app_entitlement_view", kind: "message", T: () => AppEntitlementView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<CreateAppEntitlementResponse>): CreateAppEntitlementResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<CreateAppEntitlementResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAppEntitlementResponse): CreateAppEntitlementResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementView app_entitlement_view */ 1:
                    message.appEntitlementView = AppEntitlementView.internalBinaryRead(reader, reader.uint32(), options, message.appEntitlementView);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAppEntitlementResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementView app_entitlement_view = 1; */
        if (message.appEntitlementView)
            AppEntitlementView.internalBinaryWrite(message.appEntitlementView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CreateAppEntitlementResponse
 */
export const CreateAppEntitlementResponse = new CreateAppEntitlementResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAppEntitlementRequest$Type extends MessageType<UpdateAppEntitlementRequest> {
    constructor() {
        super("c1.api.app.v1.UpdateAppEntitlementRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "entitlement", kind: "message", T: () => AppEntitlement, options: { "validate.rules": { message: { skip: true } } } },
            { no: 3, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask },
            { no: 5, name: "override_access_requests_defaults", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateAppEntitlementRequest>): UpdateAppEntitlementRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.overrideAccessRequestsDefaults = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateAppEntitlementRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateAppEntitlementRequest): UpdateAppEntitlementRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlement entitlement */ 2:
                    message.entitlement = AppEntitlement.internalBinaryRead(reader, reader.uint32(), options, message.entitlement);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 3:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                case /* c1.api.app.v1.AppEntitlementExpandMask expand_mask */ 4:
                    message.expandMask = AppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* bool override_access_requests_defaults */ 5:
                    message.overrideAccessRequestsDefaults = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateAppEntitlementRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* c1.api.app.v1.AppEntitlement entitlement = 2; */
        if (message.entitlement)
            AppEntitlement.internalBinaryWrite(message.entitlement, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 3; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppEntitlementExpandMask expand_mask = 4; */
        if (message.expandMask)
            AppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* bool override_access_requests_defaults = 5; */
        if (message.overrideAccessRequestsDefaults !== false)
            writer.tag(5, WireType.Varint).bool(message.overrideAccessRequestsDefaults);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UpdateAppEntitlementRequest
 */
export const UpdateAppEntitlementRequest = new UpdateAppEntitlementRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateProvisionerPolicyAppEntitlementRequest$Type extends MessageType<UpdateProvisionerPolicyAppEntitlementRequest> {
    constructor() {
        super("c1.api.app.v1.UpdateProvisionerPolicyAppEntitlementRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "entitlement", kind: "message", T: () => AppEntitlement, options: { "validate.rules": { message: { skip: true } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
    create(value?: PartialMessage<UpdateProvisionerPolicyAppEntitlementRequest>): UpdateProvisionerPolicyAppEntitlementRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateProvisionerPolicyAppEntitlementRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateProvisionerPolicyAppEntitlementRequest): UpdateProvisionerPolicyAppEntitlementRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlement entitlement */ 2:
                    message.entitlement = AppEntitlement.internalBinaryRead(reader, reader.uint32(), options, message.entitlement);
                    break;
                case /* c1.api.app.v1.AppEntitlementExpandMask expand_mask */ 4:
                    message.expandMask = AppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateProvisionerPolicyAppEntitlementRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* c1.api.app.v1.AppEntitlement entitlement = 2; */
        if (message.entitlement)
            AppEntitlement.internalBinaryWrite(message.entitlement, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppEntitlementExpandMask expand_mask = 4; */
        if (message.expandMask)
            AppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UpdateProvisionerPolicyAppEntitlementRequest
 */
export const UpdateProvisionerPolicyAppEntitlementRequest = new UpdateProvisionerPolicyAppEntitlementRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDeprovisionerPolicyAppEntitlementRequest$Type extends MessageType<UpdateDeprovisionerPolicyAppEntitlementRequest> {
    constructor() {
        super("c1.api.app.v1.UpdateDeprovisionerPolicyAppEntitlementRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "entitlement", kind: "message", T: () => AppEntitlement, options: { "validate.rules": { message: { skip: true } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
    create(value?: PartialMessage<UpdateDeprovisionerPolicyAppEntitlementRequest>): UpdateDeprovisionerPolicyAppEntitlementRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateDeprovisionerPolicyAppEntitlementRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateDeprovisionerPolicyAppEntitlementRequest): UpdateDeprovisionerPolicyAppEntitlementRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlement entitlement */ 2:
                    message.entitlement = AppEntitlement.internalBinaryRead(reader, reader.uint32(), options, message.entitlement);
                    break;
                case /* c1.api.app.v1.AppEntitlementExpandMask expand_mask */ 4:
                    message.expandMask = AppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateDeprovisionerPolicyAppEntitlementRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* c1.api.app.v1.AppEntitlement entitlement = 2; */
        if (message.entitlement)
            AppEntitlement.internalBinaryWrite(message.entitlement, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppEntitlementExpandMask expand_mask = 4; */
        if (message.expandMask)
            AppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UpdateDeprovisionerPolicyAppEntitlementRequest
 */
export const UpdateDeprovisionerPolicyAppEntitlementRequest = new UpdateDeprovisionerPolicyAppEntitlementRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAppEntitlementResponse$Type extends MessageType<UpdateAppEntitlementResponse> {
    constructor() {
        super("c1.api.app.v1.UpdateAppEntitlementResponse", [
            { no: 1, name: "app_entitlement_view", kind: "message", T: () => AppEntitlementView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<UpdateAppEntitlementResponse>): UpdateAppEntitlementResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<UpdateAppEntitlementResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateAppEntitlementResponse): UpdateAppEntitlementResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementView app_entitlement_view */ 1:
                    message.appEntitlementView = AppEntitlementView.internalBinaryRead(reader, reader.uint32(), options, message.appEntitlementView);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateAppEntitlementResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementView app_entitlement_view = 1; */
        if (message.appEntitlementView)
            AppEntitlementView.internalBinaryWrite(message.appEntitlementView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UpdateAppEntitlementResponse
 */
export const UpdateAppEntitlementResponse = new UpdateAppEntitlementResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppEntitlementRequest$Type extends MessageType<GetAppEntitlementRequest> {
    constructor() {
        super("c1.api.app.v1.GetAppEntitlementRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
    create(value?: PartialMessage<GetAppEntitlementRequest>): GetAppEntitlementRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<GetAppEntitlementRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAppEntitlementRequest): GetAppEntitlementRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementExpandMask expand_mask */ 3:
                    message.expandMask = AppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAppEntitlementRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        /* c1.api.app.v1.AppEntitlementExpandMask expand_mask = 3; */
        if (message.expandMask)
            AppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAppEntitlementRequest
 */
export const GetAppEntitlementRequest = new GetAppEntitlementRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppEntitlementResponse$Type extends MessageType<GetAppEntitlementResponse> {
    constructor() {
        super("c1.api.app.v1.GetAppEntitlementResponse", [
            { no: 1, name: "app_entitlement_view", kind: "message", T: () => AppEntitlementView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<GetAppEntitlementResponse>): GetAppEntitlementResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<GetAppEntitlementResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAppEntitlementResponse): GetAppEntitlementResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementView app_entitlement_view */ 1:
                    message.appEntitlementView = AppEntitlementView.internalBinaryRead(reader, reader.uint32(), options, message.appEntitlementView);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAppEntitlementResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementView app_entitlement_view = 1; */
        if (message.appEntitlementView)
            AppEntitlementView.internalBinaryWrite(message.appEntitlementView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAppEntitlementResponse
 */
export const GetAppEntitlementResponse = new GetAppEntitlementResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkGetAppEntitlementsRequest$Type extends MessageType<BulkGetAppEntitlementsRequest> {
    constructor() {
        super("c1.api.app.v1.BulkGetAppEntitlementsRequest", [
            { no: 1, name: "app_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "100" } } } }
        ]);
    }
    create(value?: PartialMessage<BulkGetAppEntitlementsRequest>): BulkGetAppEntitlementsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appEntitlementRefs = [];
        if (value !== undefined)
            reflectionMergePartial<BulkGetAppEntitlementsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkGetAppEntitlementsRequest): BulkGetAppEntitlementsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs */ 1:
                    message.appEntitlementRefs.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkGetAppEntitlementsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 1; */
        for (let i = 0; i < message.appEntitlementRefs.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.appEntitlementRefs[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.BulkGetAppEntitlementsRequest
 */
export const BulkGetAppEntitlementsRequest = new BulkGetAppEntitlementsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkGetAppEntitlementsResponse$Type extends MessageType<BulkGetAppEntitlementsResponse> {
    constructor() {
        super("c1.api.app.v1.BulkGetAppEntitlementsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlement }
        ]);
    }
    create(value?: PartialMessage<BulkGetAppEntitlementsResponse>): BulkGetAppEntitlementsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        if (value !== undefined)
            reflectionMergePartial<BulkGetAppEntitlementsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkGetAppEntitlementsResponse): BulkGetAppEntitlementsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlement list */ 1:
                    message.list.push(AppEntitlement.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkGetAppEntitlementsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlement list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlement.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.BulkGetAppEntitlementsResponse
 */
export const BulkGetAppEntitlementsResponse = new BulkGetAppEntitlementsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppEntitlementRequest$Type extends MessageType<DeleteAppEntitlementRequest> {
    constructor() {
        super("c1.api.app.v1.DeleteAppEntitlementRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<DeleteAppEntitlementRequest>): DeleteAppEntitlementRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<DeleteAppEntitlementRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAppEntitlementRequest): DeleteAppEntitlementRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAppEntitlementRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAppEntitlementRequest
 */
export const DeleteAppEntitlementRequest = new DeleteAppEntitlementRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppEntitlementResponse$Type extends MessageType<DeleteAppEntitlementResponse> {
    constructor() {
        super("c1.api.app.v1.DeleteAppEntitlementResponse", []);
    }
    create(value?: PartialMessage<DeleteAppEntitlementResponse>): DeleteAppEntitlementResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteAppEntitlementResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAppEntitlementResponse): DeleteAppEntitlementResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAppEntitlementResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAppEntitlementResponse
 */
export const DeleteAppEntitlementResponse = new DeleteAppEntitlementResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppEntitlementIfManuallyCreatedRequest$Type extends MessageType<DeleteAppEntitlementIfManuallyCreatedRequest> {
    constructor() {
        super("c1.api.app.v1.DeleteAppEntitlementIfManuallyCreatedRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<DeleteAppEntitlementIfManuallyCreatedRequest>): DeleteAppEntitlementIfManuallyCreatedRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<DeleteAppEntitlementIfManuallyCreatedRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteAppEntitlementIfManuallyCreatedRequest): DeleteAppEntitlementIfManuallyCreatedRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteAppEntitlementIfManuallyCreatedRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAppEntitlementIfManuallyCreatedRequest
 */
export const DeleteAppEntitlementIfManuallyCreatedRequest = new DeleteAppEntitlementIfManuallyCreatedRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementsRequest$Type extends MessageType<ListAppEntitlementsRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppEntitlementsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
    create(value?: PartialMessage<ListAppEntitlementsRequest>): ListAppEntitlementsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListAppEntitlementsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppEntitlementsRequest): ListAppEntitlementsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementExpandMask expand_mask */ 4:
                    message.expandMask = AppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppEntitlementsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.app.v1.AppEntitlementExpandMask expand_mask = 4; */
        if (message.expandMask)
            AppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppEntitlementsRequest
 */
export const ListAppEntitlementsRequest = new ListAppEntitlementsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementsResponse$Type extends MessageType<ListAppEntitlementsResponse> {
    constructor() {
        super("c1.api.app.v1.ListAppEntitlementsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListAppEntitlementsResponse>): ListAppEntitlementsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListAppEntitlementsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppEntitlementsResponse): ListAppEntitlementsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementView list */ 1:
                    message.list.push(AppEntitlementView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppEntitlementsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppEntitlementsResponse
 */
export const ListAppEntitlementsResponse = new ListAppEntitlementsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementUserView$Type extends MessageType<AppEntitlementUserView> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementUserView", [
            { no: 1, name: "app_user", kind: "message", T: () => AppUserView },
            { no: 2, name: "app_entitlement_user_binding_created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "app_entitlement_user_binding_deprovision_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "grant_sources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef },
            { no: 5, name: "originating_ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementUserView>): AppEntitlementUserView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.grantSources = [];
        message.originatingTicketId = "";
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementUserView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementUserView): AppEntitlementUserView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppUserView app_user */ 1:
                    message.appUser = AppUserView.internalBinaryRead(reader, reader.uint32(), options, message.appUser);
                    break;
                case /* google.protobuf.Timestamp app_entitlement_user_binding_created_at */ 2:
                    message.appEntitlementUserBindingCreatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.appEntitlementUserBindingCreatedAt);
                    break;
                case /* google.protobuf.Timestamp app_entitlement_user_binding_deprovision_at */ 3:
                    message.appEntitlementUserBindingDeprovisionAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.appEntitlementUserBindingDeprovisionAt);
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef grant_sources */ 4:
                    message.grantSources.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string originating_ticket_id */ 5:
                    message.originatingTicketId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementUserView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppUserView app_user = 1; */
        if (message.appUser)
            AppUserView.internalBinaryWrite(message.appUser, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp app_entitlement_user_binding_created_at = 2; */
        if (message.appEntitlementUserBindingCreatedAt)
            Timestamp.internalBinaryWrite(message.appEntitlementUserBindingCreatedAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp app_entitlement_user_binding_deprovision_at = 3; */
        if (message.appEntitlementUserBindingDeprovisionAt)
            Timestamp.internalBinaryWrite(message.appEntitlementUserBindingDeprovisionAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.AppEntitlementRef grant_sources = 4; */
        for (let i = 0; i < message.grantSources.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.grantSources[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string originating_ticket_id = 5; */
        if (message.originatingTicketId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.originatingTicketId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementUserView
 */
export const AppEntitlementUserView = new AppEntitlementUserView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementUsersRequest$Type extends MessageType<ListAppEntitlementUsersRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppEntitlementUsersRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppUserExpandMask }
        ]);
    }
    create(value?: PartialMessage<ListAppEntitlementUsersRequest>): ListAppEntitlementUsersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListAppEntitlementUsersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppEntitlementUsersRequest): ListAppEntitlementUsersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.app.v1.AppUserExpandMask expand_mask */ 5:
                    message.expandMask = AppUserExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppEntitlementUsersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.app.v1.AppUserExpandMask expand_mask = 5; */
        if (message.expandMask)
            AppUserExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppEntitlementUsersRequest
 */
export const ListAppEntitlementUsersRequest = new ListAppEntitlementUsersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementUsersResponse$Type extends MessageType<ListAppEntitlementUsersResponse> {
    constructor() {
        super("c1.api.app.v1.ListAppEntitlementUsersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementUserView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListAppEntitlementUsersResponse>): ListAppEntitlementUsersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListAppEntitlementUsersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppEntitlementUsersResponse): ListAppEntitlementUsersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementUserView list */ 1:
                    message.list.push(AppEntitlementUserView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppEntitlementUsersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementUserView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementUserView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppEntitlementUsersResponse
 */
export const ListAppEntitlementUsersResponse = new ListAppEntitlementUsersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementsWithExpiredRequest$Type extends MessageType<SearchAppEntitlementsWithExpiredRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementsWithExpiredRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementUserBindingRef },
            { no: 7, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 8, name: "app_user_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 9, name: "user_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "100" } } } }
        ]);
    }
    create(value?: PartialMessage<SearchAppEntitlementsWithExpiredRequest>): SearchAppEntitlementsWithExpiredRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.refs = [];
        message.query = "";
        message.appUserRefs = [];
        message.userRefs = [];
        if (value !== undefined)
            reflectionMergePartial<SearchAppEntitlementsWithExpiredRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppEntitlementsWithExpiredRequest): SearchAppEntitlementsWithExpiredRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementUserBindingRef refs */ 6:
                    message.refs.push(AppEntitlementUserBindingRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string query */ 7:
                    message.query = reader.string();
                    break;
                case /* repeated c1.api.app.v1.AppUserRef app_user_refs */ 8:
                    message.appUserRefs.push(AppUserRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.user.v1.UserRef user_refs */ 9:
                    message.userRefs.push(UserRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppEntitlementsWithExpiredRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        /* repeated c1.api.app.v1.AppEntitlementUserBindingRef refs = 6; */
        for (let i = 0; i < message.refs.length; i++)
            AppEntitlementUserBindingRef.internalBinaryWrite(message.refs[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string query = 7; */
        if (message.query !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.query);
        /* repeated c1.api.app.v1.AppUserRef app_user_refs = 8; */
        for (let i = 0; i < message.appUserRefs.length; i++)
            AppUserRef.internalBinaryWrite(message.appUserRefs[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.user.v1.UserRef user_refs = 9; */
        for (let i = 0; i < message.userRefs.length; i++)
            UserRef.internalBinaryWrite(message.userRefs[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementsWithExpiredRequest
 */
export const SearchAppEntitlementsWithExpiredRequest = new SearchAppEntitlementsWithExpiredRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementWithExpired$Type extends MessageType<AppEntitlementWithExpired> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementWithExpired", [
            { no: 1, name: "app_user", kind: "message", T: () => AppUser },
            { no: 2, name: "user", kind: "message", T: () => User },
            { no: 3, name: "expired", kind: "message", T: () => Timestamp },
            { no: 4, name: "discovered", kind: "message", T: () => Timestamp },
            { no: 5, name: "grant_reasons", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GrantReason },
            { no: 6, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "grant_sources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementWithExpired>): AppEntitlementWithExpired {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.grantReasons = [];
        message.appEntitlementId = "";
        message.appId = "";
        message.appUserId = "";
        message.grantSources = [];
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementWithExpired>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementWithExpired): AppEntitlementWithExpired {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppUser app_user */ 1:
                    message.appUser = AppUser.internalBinaryRead(reader, reader.uint32(), options, message.appUser);
                    break;
                case /* c1.api.user.v1.User user */ 2:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* google.protobuf.Timestamp expired */ 3:
                    message.expired = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expired);
                    break;
                case /* google.protobuf.Timestamp discovered */ 4:
                    message.discovered = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.discovered);
                    break;
                case /* repeated c1.api.app.v1.GrantReason grant_reasons */ 5:
                    message.grantReasons.push(GrantReason.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string app_entitlement_id */ 6:
                    message.appEntitlementId = reader.string();
                    break;
                case /* string app_id */ 7:
                    message.appId = reader.string();
                    break;
                case /* string app_user_id */ 8:
                    message.appUserId = reader.string();
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef grant_sources */ 9:
                    message.grantSources.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementWithExpired, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppUser app_user = 1; */
        if (message.appUser)
            AppUser.internalBinaryWrite(message.appUser, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.user.v1.User user = 2; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp expired = 3; */
        if (message.expired)
            Timestamp.internalBinaryWrite(message.expired, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp discovered = 4; */
        if (message.discovered)
            Timestamp.internalBinaryWrite(message.discovered, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.GrantReason grant_reasons = 5; */
        for (let i = 0; i < message.grantReasons.length; i++)
            GrantReason.internalBinaryWrite(message.grantReasons[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string app_entitlement_id = 6; */
        if (message.appEntitlementId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.appEntitlementId);
        /* string app_id = 7; */
        if (message.appId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.appId);
        /* string app_user_id = 8; */
        if (message.appUserId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.appUserId);
        /* repeated c1.api.app.v1.AppEntitlementRef grant_sources = 9; */
        for (let i = 0; i < message.grantSources.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.grantSources[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementWithExpired
 */
export const AppEntitlementWithExpired = new AppEntitlementWithExpired$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementsWithExpiredResponse$Type extends MessageType<SearchAppEntitlementsWithExpiredResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementsWithExpiredResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementWithExpired },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchAppEntitlementsWithExpiredResponse>): SearchAppEntitlementsWithExpiredResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAppEntitlementsWithExpiredResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppEntitlementsWithExpiredResponse): SearchAppEntitlementsWithExpiredResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementWithExpired list */ 1:
                    message.list.push(AppEntitlementWithExpired.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppEntitlementsWithExpiredResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementWithExpired list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementWithExpired.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementsWithExpiredResponse
 */
export const SearchAppEntitlementsWithExpiredResponse = new SearchAppEntitlementsWithExpiredResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccessProfilesForGrantsRequest$Type extends MessageType<GetAccessProfilesForGrantsRequest> {
    constructor() {
        super("c1.api.app.v1.GetAccessProfilesForGrantsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<GetAccessProfilesForGrantsRequest>): GetAccessProfilesForGrantsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.appUserIds = [];
        if (value !== undefined)
            reflectionMergePartial<GetAccessProfilesForGrantsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccessProfilesForGrantsRequest): GetAccessProfilesForGrantsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* repeated string app_user_ids */ 3:
                    message.appUserIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccessProfilesForGrantsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* repeated string app_user_ids = 3; */
        for (let i = 0; i < message.appUserIds.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.appUserIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAccessProfilesForGrantsRequest
 */
export const GetAccessProfilesForGrantsRequest = new GetAccessProfilesForGrantsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessProfileWithExpiry$Type extends MessageType<AccessProfileWithExpiry> {
    constructor() {
        super("c1.api.app.v1.AccessProfileWithExpiry", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expires_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "unenrollment_behavior", kind: "enum", T: () => ["c1.api.app.v1.AccessProfileUnenrollmentBehavior", AccessProfileUnenrollmentBehavior, "ACCESS_PROFILE_UNENROLLMENT_BEHAVIOR_"] }
        ]);
    }
    create(value?: PartialMessage<AccessProfileWithExpiry>): AccessProfileWithExpiry {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogId = "";
        message.displayName = "";
        message.unenrollmentBehavior = 0;
        if (value !== undefined)
            reflectionMergePartial<AccessProfileWithExpiry>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessProfileWithExpiry): AccessProfileWithExpiry {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string catalog_id */ 1:
                    message.catalogId = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* google.protobuf.Timestamp expires_at */ 3:
                    message.expiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresAt);
                    break;
                case /* c1.api.app.v1.AccessProfileUnenrollmentBehavior unenrollment_behavior */ 4:
                    message.unenrollmentBehavior = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessProfileWithExpiry, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string catalog_id = 1; */
        if (message.catalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.catalogId);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* google.protobuf.Timestamp expires_at = 3; */
        if (message.expiresAt)
            Timestamp.internalBinaryWrite(message.expiresAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AccessProfileUnenrollmentBehavior unenrollment_behavior = 4; */
        if (message.unenrollmentBehavior !== 0)
            writer.tag(4, WireType.Varint).int32(message.unenrollmentBehavior);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AccessProfileWithExpiry
 */
export const AccessProfileWithExpiry = new AccessProfileWithExpiry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessProfilesForUser$Type extends MessageType<AccessProfilesForUser> {
    constructor() {
        super("c1.api.app.v1.AccessProfilesForUser", [
            { no: 1, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "access_profiles", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessProfileWithExpiry },
            { no: 3, name: "effective_expiry_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<AccessProfilesForUser>): AccessProfilesForUser {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appUserId = "";
        message.accessProfiles = [];
        if (value !== undefined)
            reflectionMergePartial<AccessProfilesForUser>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessProfilesForUser): AccessProfilesForUser {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_user_id */ 1:
                    message.appUserId = reader.string();
                    break;
                case /* repeated c1.api.app.v1.AccessProfileWithExpiry access_profiles */ 2:
                    message.accessProfiles.push(AccessProfileWithExpiry.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp effective_expiry_at */ 3:
                    message.effectiveExpiryAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.effectiveExpiryAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessProfilesForUser, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_user_id = 1; */
        if (message.appUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appUserId);
        /* repeated c1.api.app.v1.AccessProfileWithExpiry access_profiles = 2; */
        for (let i = 0; i < message.accessProfiles.length; i++)
            AccessProfileWithExpiry.internalBinaryWrite(message.accessProfiles[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp effective_expiry_at = 3; */
        if (message.effectiveExpiryAt)
            Timestamp.internalBinaryWrite(message.effectiveExpiryAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AccessProfilesForUser
 */
export const AccessProfilesForUser = new AccessProfilesForUser$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccessProfilesForGrantsResponse$Type extends MessageType<GetAccessProfilesForGrantsResponse> {
    constructor() {
        super("c1.api.app.v1.GetAccessProfilesForGrantsResponse", [
            { no: 1, name: "access_profiles_for_users", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessProfilesForUser }
        ]);
    }
    create(value?: PartialMessage<GetAccessProfilesForGrantsResponse>): GetAccessProfilesForGrantsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessProfilesForUsers = [];
        if (value !== undefined)
            reflectionMergePartial<GetAccessProfilesForGrantsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccessProfilesForGrantsResponse): GetAccessProfilesForGrantsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AccessProfilesForUser access_profiles_for_users */ 1:
                    message.accessProfilesForUsers.push(AccessProfilesForUser.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccessProfilesForGrantsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AccessProfilesForUser access_profiles_for_users = 1; */
        for (let i = 0; i < message.accessProfilesForUsers.length; i++)
            AccessProfilesForUser.internalBinaryWrite(message.accessProfilesForUsers[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAccessProfilesForGrantsResponse
 */
export const GetAccessProfilesForGrantsResponse = new GetAccessProfilesForGrantsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementsForAppUserRequest$Type extends MessageType<ListAppEntitlementsForAppUserRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppEntitlementsForAppUserRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
    create(value?: PartialMessage<ListAppEntitlementsForAppUserRequest>): ListAppEntitlementsForAppUserRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appUserId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListAppEntitlementsForAppUserRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppEntitlementsForAppUserRequest): ListAppEntitlementsForAppUserRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_user_id */ 2:
                    message.appUserId = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementExpandMask expand_mask */ 5:
                    message.expandMask = AppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppEntitlementsForAppUserRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_user_id = 2; */
        if (message.appUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appUserId);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.app.v1.AppEntitlementExpandMask expand_mask = 5; */
        if (message.expandMask)
            AppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppEntitlementsForAppUserRequest
 */
export const ListAppEntitlementsForAppUserRequest = new ListAppEntitlementsForAppUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementGroupsRequest$Type extends MessageType<ListAppEntitlementGroupsRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppEntitlementGroupsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<ListAppEntitlementGroupsRequest>): ListAppEntitlementGroupsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListAppEntitlementGroupsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppEntitlementGroupsRequest): ListAppEntitlementGroupsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppEntitlementGroupsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppEntitlementGroupsRequest
 */
export const ListAppEntitlementGroupsRequest = new ListAppEntitlementGroupsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementGroupsResponse$Type extends MessageType<ListAppEntitlementGroupsResponse> {
    constructor() {
        super("c1.api.app.v1.ListAppEntitlementGroupsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppGroup },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "notification_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListAppEntitlementGroupsResponse>): ListAppEntitlementGroupsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.notificationToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListAppEntitlementGroupsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppEntitlementGroupsResponse): ListAppEntitlementGroupsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppGroup list */ 1:
                    message.list.push(AppGroup.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* string notification_token */ 3:
                    message.notificationToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppEntitlementGroupsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppGroup list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppGroup.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* string notification_token = 3; */
        if (message.notificationToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.notificationToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppEntitlementGroupsResponse
 */
export const ListAppEntitlementGroupsResponse = new ListAppEntitlementGroupsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementsForAppResourceRequest$Type extends MessageType<ListAppEntitlementsForAppResourceRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppEntitlementsForAppResourceRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 5, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
    create(value?: PartialMessage<ListAppEntitlementsForAppResourceRequest>): ListAppEntitlementsForAppResourceRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appResourceTypeId = "";
        message.appResourceId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListAppEntitlementsForAppResourceRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppEntitlementsForAppResourceRequest): ListAppEntitlementsForAppResourceRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_resource_type_id */ 2:
                    message.appResourceTypeId = reader.string();
                    break;
                case /* string app_resource_id */ 3:
                    message.appResourceId = reader.string();
                    break;
                case /* int32 page_size */ 4:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 5:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementExpandMask expand_mask */ 6:
                    message.expandMask = AppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppEntitlementsForAppResourceRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_resource_type_id = 2; */
        if (message.appResourceTypeId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appResourceTypeId);
        /* string app_resource_id = 3; */
        if (message.appResourceId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appResourceId);
        /* int32 page_size = 4; */
        if (message.pageSize !== 0)
            writer.tag(4, WireType.Varint).int32(message.pageSize);
        /* string page_token = 5; */
        if (message.pageToken !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.app.v1.AppEntitlementExpandMask expand_mask = 6; */
        if (message.expandMask)
            AppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppEntitlementsForAppResourceRequest
 */
export const ListAppEntitlementsForAppResourceRequest = new ListAppEntitlementsForAppResourceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppWithGrantCount$Type extends MessageType<AppWithGrantCount> {
    constructor() {
        super("c1.api.app.v1.AppWithGrantCount", [
            { no: 1, name: "App", kind: "message", jsonName: "App", T: () => App },
            { no: 2, name: "Count", kind: "scalar", jsonName: "Count", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<AppWithGrantCount>): AppWithGrantCount {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<AppWithGrantCount>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppWithGrantCount): AppWithGrantCount {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.App App */ 1:
                    message.app = App.internalBinaryRead(reader, reader.uint32(), options, message.app);
                    break;
                case /* int64 Count */ 2:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppWithGrantCount, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.App App = 1; */
        if (message.app)
            App.internalBinaryWrite(message.app, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 Count = 2; */
        if (message.count !== 0)
            writer.tag(2, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppWithGrantCount
 */
export const AppWithGrantCount = new AppWithGrantCount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountStandingHighRiskGrantsRequest$Type extends MessageType<CountStandingHighRiskGrantsRequest> {
    constructor() {
        super("c1.api.app.v1.CountStandingHighRiskGrantsRequest", []);
    }
    create(value?: PartialMessage<CountStandingHighRiskGrantsRequest>): CountStandingHighRiskGrantsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CountStandingHighRiskGrantsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountStandingHighRiskGrantsRequest): CountStandingHighRiskGrantsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountStandingHighRiskGrantsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CountStandingHighRiskGrantsRequest
 */
export const CountStandingHighRiskGrantsRequest = new CountStandingHighRiskGrantsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountStandingHighRiskGrantsResponse$Type extends MessageType<CountStandingHighRiskGrantsResponse> {
    constructor() {
        super("c1.api.app.v1.CountStandingHighRiskGrantsResponse", [
            { no: 1, name: "total_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<CountStandingHighRiskGrantsResponse>): CountStandingHighRiskGrantsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial<CountStandingHighRiskGrantsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountStandingHighRiskGrantsResponse): CountStandingHighRiskGrantsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 total_count */ 1:
                    message.totalCount = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountStandingHighRiskGrantsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 total_count = 1; */
        if (message.totalCount !== 0)
            writer.tag(1, WireType.Varint).int64(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CountStandingHighRiskGrantsResponse
 */
export const CountStandingHighRiskGrantsResponse = new CountStandingHighRiskGrantsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchStandingHighRiskGrantsForAppsRequest$Type extends MessageType<SearchStandingHighRiskGrantsForAppsRequest> {
    constructor() {
        super("c1.api.app.v1.SearchStandingHighRiskGrantsForAppsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<SearchStandingHighRiskGrantsForAppsRequest>): SearchStandingHighRiskGrantsForAppsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchStandingHighRiskGrantsForAppsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchStandingHighRiskGrantsForAppsRequest): SearchStandingHighRiskGrantsForAppsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchStandingHighRiskGrantsForAppsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchStandingHighRiskGrantsForAppsRequest
 */
export const SearchStandingHighRiskGrantsForAppsRequest = new SearchStandingHighRiskGrantsForAppsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchStandingHighRiskGrantsForAppsResponse$Type extends MessageType<SearchStandingHighRiskGrantsForAppsResponse> {
    constructor() {
        super("c1.api.app.v1.SearchStandingHighRiskGrantsForAppsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppWithGrantCount },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchStandingHighRiskGrantsForAppsResponse>): SearchStandingHighRiskGrantsForAppsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchStandingHighRiskGrantsForAppsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchStandingHighRiskGrantsForAppsResponse): SearchStandingHighRiskGrantsForAppsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppWithGrantCount list */ 1:
                    message.list.push(AppWithGrantCount.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchStandingHighRiskGrantsForAppsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppWithGrantCount list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppWithGrantCount.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchStandingHighRiskGrantsForAppsResponse
 */
export const SearchStandingHighRiskGrantsForAppsResponse = new SearchStandingHighRiskGrantsForAppsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementAutomationRef$Type extends MessageType<AppEntitlementAutomationRef> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementAutomationRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementAutomationRef>): AppEntitlementAutomationRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementAutomationRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementAutomationRef): AppEntitlementAutomationRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementAutomationRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementAutomationRef
 */
export const AppEntitlementAutomationRef = new AppEntitlementAutomationRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementServiceGetAutomationRequest$Type extends MessageType<AppEntitlementServiceGetAutomationRequest> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementServiceGetAutomationRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementServiceGetAutomationRequest>): AppEntitlementServiceGetAutomationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementServiceGetAutomationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementServiceGetAutomationRequest): AppEntitlementServiceGetAutomationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementServiceGetAutomationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementServiceGetAutomationRequest
 */
export const AppEntitlementServiceGetAutomationRequest = new AppEntitlementServiceGetAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementServiceGetAutomationResponse$Type extends MessageType<AppEntitlementServiceGetAutomationResponse> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementServiceGetAutomationResponse", [
            { no: 1, name: "AppEntitlementAutomation", kind: "message", jsonName: "AppEntitlementAutomation", T: () => AppEntitlementAutomation }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementServiceGetAutomationResponse>): AppEntitlementServiceGetAutomationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementServiceGetAutomationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementServiceGetAutomationResponse): AppEntitlementServiceGetAutomationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementAutomation AppEntitlementAutomation */ 1:
                    message.appEntitlementAutomation = AppEntitlementAutomation.internalBinaryRead(reader, reader.uint32(), options, message.appEntitlementAutomation);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementServiceGetAutomationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementAutomation AppEntitlementAutomation = 1; */
        if (message.appEntitlementAutomation)
            AppEntitlementAutomation.internalBinaryWrite(message.appEntitlementAutomation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementServiceGetAutomationResponse
 */
export const AppEntitlementServiceGetAutomationResponse = new AppEntitlementServiceGetAutomationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementServicePreviewAutomationCELRequest$Type extends MessageType<AppEntitlementServicePreviewAutomationCELRequest> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementServicePreviewAutomationCELRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "expression", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0" } } } }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementServicePreviewAutomationCELRequest>): AppEntitlementServicePreviewAutomationCELRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.expression = "";
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementServicePreviewAutomationCELRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementServicePreviewAutomationCELRequest): AppEntitlementServicePreviewAutomationCELRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* string expression */ 3:
                    message.expression = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementServicePreviewAutomationCELRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* string expression = 3; */
        if (message.expression !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.expression);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementServicePreviewAutomationCELRequest
 */
export const AppEntitlementServicePreviewAutomationCELRequest = new AppEntitlementServicePreviewAutomationCELRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementServicePreviewAutomationCELResponse$Type extends MessageType<AppEntitlementServicePreviewAutomationCELResponse> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse", [
            { no: 1, name: "matched", kind: "message", oneof: "response", T: () => AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseMatched },
            { no: 2, name: "status", kind: "message", oneof: "response", T: () => AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseStatus },
            { no: 3, name: "failed", kind: "message", oneof: "response", T: () => AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseFailed },
            { no: 4, name: "stopped", kind: "scalar", oneof: "response", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementServicePreviewAutomationCELResponse>): AppEntitlementServicePreviewAutomationCELResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.response = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementServicePreviewAutomationCELResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementServicePreviewAutomationCELResponse): AppEntitlementServicePreviewAutomationCELResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse.PreviewAutomationCELResponseMatched matched */ 1:
                    message.response = {
                        oneofKind: "matched",
                        matched: AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseMatched.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).matched)
                    };
                    break;
                case /* c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse.PreviewAutomationCELResponseStatus status */ 2:
                    message.response = {
                        oneofKind: "status",
                        status: AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseStatus.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).status)
                    };
                    break;
                case /* c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse.PreviewAutomationCELResponseFailed failed */ 3:
                    message.response = {
                        oneofKind: "failed",
                        failed: AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseFailed.internalBinaryRead(reader, reader.uint32(), options, (message.response as any).failed)
                    };
                    break;
                case /* bool stopped */ 4:
                    message.response = {
                        oneofKind: "stopped",
                        stopped: reader.bool()
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementServicePreviewAutomationCELResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse.PreviewAutomationCELResponseMatched matched = 1; */
        if (message.response.oneofKind === "matched")
            AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseMatched.internalBinaryWrite(message.response.matched, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse.PreviewAutomationCELResponseStatus status = 2; */
        if (message.response.oneofKind === "status")
            AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseStatus.internalBinaryWrite(message.response.status, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse.PreviewAutomationCELResponseFailed failed = 3; */
        if (message.response.oneofKind === "failed")
            AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseFailed.internalBinaryWrite(message.response.failed, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* bool stopped = 4; */
        if (message.response.oneofKind === "stopped")
            writer.tag(4, WireType.Varint).bool(message.response.stopped);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse
 */
export const AppEntitlementServicePreviewAutomationCELResponse = new AppEntitlementServicePreviewAutomationCELResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseMatched$Type extends MessageType<AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseMatched> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse.PreviewAutomationCELResponseMatched", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseMatched>): AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseMatched {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseMatched>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseMatched): AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseMatched {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.user.v1.User list */ 1:
                    message.list.push(User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseMatched, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.user.v1.User list = 1; */
        for (let i = 0; i < message.list.length; i++)
            User.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse.PreviewAutomationCELResponseMatched
 */
export const AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseMatched = new AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseMatched$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseFailed$Type extends MessageType<AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseFailed> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse.PreviewAutomationCELResponseFailed", [
            { no: 1, name: "user", kind: "message", T: () => User },
            { no: 2, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseFailed>): AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseFailed {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.error = "";
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseFailed>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseFailed): AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseFailed {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.User user */ 1:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* string error */ 2:
                    message.error = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseFailed, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.User user = 1; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string error = 2; */
        if (message.error !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.error);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse.PreviewAutomationCELResponseFailed
 */
export const AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseFailed = new AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseFailed$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseStatus$Type extends MessageType<AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseStatus> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse.PreviewAutomationCELResponseStatus", [
            { no: 1, name: "total", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "scanned", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "matched", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "errors", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseStatus>): AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseStatus {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.total = 0;
        message.scanned = 0;
        message.matched = 0;
        message.errors = 0;
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseStatus): AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 total */ 1:
                    message.total = reader.int64().toNumber();
                    break;
                case /* int64 scanned */ 2:
                    message.scanned = reader.int64().toNumber();
                    break;
                case /* int64 matched */ 3:
                    message.matched = reader.int64().toNumber();
                    break;
                case /* int64 errors */ 4:
                    message.errors = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 total = 1; */
        if (message.total !== 0)
            writer.tag(1, WireType.Varint).int64(message.total);
        /* int64 scanned = 2; */
        if (message.scanned !== 0)
            writer.tag(2, WireType.Varint).int64(message.scanned);
        /* int64 matched = 3; */
        if (message.matched !== 0)
            writer.tag(3, WireType.Varint).int64(message.matched);
        /* int64 errors = 4; */
        if (message.errors !== 0)
            writer.tag(4, WireType.Varint).int64(message.errors);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse.PreviewAutomationCELResponseStatus
 */
export const AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseStatus = new AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementServiceUpdateAutomationRequest$Type extends MessageType<AppEntitlementServiceUpdateAutomationRequest> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementServiceUpdateAutomationRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "512" } } } },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } },
            { no: 100, name: "none", kind: "message", oneof: "conditions", T: () => AppEntitlementAutomationRuleNone },
            { no: 101, name: "entitlements", kind: "message", oneof: "conditions", T: () => AppEntitlementAutomationRuleEntitlement },
            { no: 102, name: "cel", kind: "message", oneof: "conditions", T: () => AppEntitlementAutomationRuleCEL },
            { no: 103, name: "basic", kind: "message", oneof: "conditions", T: () => AppEntitlementAutomationRuleBasic },
            { no: 5, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementServiceUpdateAutomationRequest>): AppEntitlementServiceUpdateAutomationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.displayName = "";
        message.description = "";
        message.conditions = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementServiceUpdateAutomationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementServiceUpdateAutomationRequest): AppEntitlementServiceUpdateAutomationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* string display_name */ 3:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementAutomationRuleNone none */ 100:
                    message.conditions = {
                        oneofKind: "none",
                        none: AppEntitlementAutomationRuleNone.internalBinaryRead(reader, reader.uint32(), options, (message.conditions as any).none)
                    };
                    break;
                case /* c1.api.app.v1.AppEntitlementAutomationRuleEntitlement entitlements */ 101:
                    message.conditions = {
                        oneofKind: "entitlements",
                        entitlements: AppEntitlementAutomationRuleEntitlement.internalBinaryRead(reader, reader.uint32(), options, (message.conditions as any).entitlements)
                    };
                    break;
                case /* c1.api.app.v1.AppEntitlementAutomationRuleCEL cel */ 102:
                    message.conditions = {
                        oneofKind: "cel",
                        cel: AppEntitlementAutomationRuleCEL.internalBinaryRead(reader, reader.uint32(), options, (message.conditions as any).cel)
                    };
                    break;
                case /* c1.api.app.v1.AppEntitlementAutomationRuleBasic basic */ 103:
                    message.conditions = {
                        oneofKind: "basic",
                        basic: AppEntitlementAutomationRuleBasic.internalBinaryRead(reader, reader.uint32(), options, (message.conditions as any).basic)
                    };
                    break;
                case /* google.protobuf.FieldMask update_mask */ 5:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementServiceUpdateAutomationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* string display_name = 3; */
        if (message.displayName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.displayName);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* google.protobuf.FieldMask update_mask = 5; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppEntitlementAutomationRuleNone none = 100; */
        if (message.conditions.oneofKind === "none")
            AppEntitlementAutomationRuleNone.internalBinaryWrite(message.conditions.none, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppEntitlementAutomationRuleEntitlement entitlements = 101; */
        if (message.conditions.oneofKind === "entitlements")
            AppEntitlementAutomationRuleEntitlement.internalBinaryWrite(message.conditions.entitlements, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppEntitlementAutomationRuleCEL cel = 102; */
        if (message.conditions.oneofKind === "cel")
            AppEntitlementAutomationRuleCEL.internalBinaryWrite(message.conditions.cel, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppEntitlementAutomationRuleBasic basic = 103; */
        if (message.conditions.oneofKind === "basic")
            AppEntitlementAutomationRuleBasic.internalBinaryWrite(message.conditions.basic, writer.tag(103, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementServiceUpdateAutomationRequest
 */
export const AppEntitlementServiceUpdateAutomationRequest = new AppEntitlementServiceUpdateAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementServiceUpdateAutomationResponse$Type extends MessageType<AppEntitlementServiceUpdateAutomationResponse> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementServiceUpdateAutomationResponse", [
            { no: 1, name: "AppEntitlementAutomation", kind: "message", jsonName: "AppEntitlementAutomation", T: () => AppEntitlementAutomation }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementServiceUpdateAutomationResponse>): AppEntitlementServiceUpdateAutomationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementServiceUpdateAutomationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementServiceUpdateAutomationResponse): AppEntitlementServiceUpdateAutomationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementAutomation AppEntitlementAutomation */ 1:
                    message.appEntitlementAutomation = AppEntitlementAutomation.internalBinaryRead(reader, reader.uint32(), options, message.appEntitlementAutomation);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementServiceUpdateAutomationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementAutomation AppEntitlementAutomation = 1; */
        if (message.appEntitlementAutomation)
            AppEntitlementAutomation.internalBinaryWrite(message.appEntitlementAutomation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementServiceUpdateAutomationResponse
 */
export const AppEntitlementServiceUpdateAutomationResponse = new AppEntitlementServiceUpdateAutomationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementAutomationRuleNone$Type extends MessageType<AppEntitlementAutomationRuleNone> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementAutomationRuleNone", []);
    }
    create(value?: PartialMessage<AppEntitlementAutomationRuleNone>): AppEntitlementAutomationRuleNone {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementAutomationRuleNone>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementAutomationRuleNone): AppEntitlementAutomationRuleNone {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementAutomationRuleNone, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementAutomationRuleNone
 */
export const AppEntitlementAutomationRuleNone = new AppEntitlementAutomationRuleNone$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementAutomationRuleEntitlement$Type extends MessageType<AppEntitlementAutomationRuleEntitlement> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementAutomationRuleEntitlement", [
            { no: 1, name: "entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "32" } } } }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementAutomationRuleEntitlement>): AppEntitlementAutomationRuleEntitlement {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.entitlementRefs = [];
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementAutomationRuleEntitlement>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementAutomationRuleEntitlement): AppEntitlementAutomationRuleEntitlement {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementRef entitlement_refs */ 1:
                    message.entitlementRefs.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementAutomationRuleEntitlement, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementRef entitlement_refs = 1; */
        for (let i = 0; i < message.entitlementRefs.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.entitlementRefs[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementAutomationRuleEntitlement
 */
export const AppEntitlementAutomationRuleEntitlement = new AppEntitlementAutomationRuleEntitlement$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementAutomationRuleCEL$Type extends MessageType<AppEntitlementAutomationRuleCEL> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementAutomationRuleCEL", [
            { no: 1, name: "expression", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementAutomationRuleCEL>): AppEntitlementAutomationRuleCEL {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expression = "";
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementAutomationRuleCEL>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementAutomationRuleCEL): AppEntitlementAutomationRuleCEL {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string expression */ 1:
                    message.expression = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementAutomationRuleCEL, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string expression = 1; */
        if (message.expression !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.expression);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementAutomationRuleCEL
 */
export const AppEntitlementAutomationRuleCEL = new AppEntitlementAutomationRuleCEL$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementAutomationRuleBasic$Type extends MessageType<AppEntitlementAutomationRuleBasic> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementAutomationRuleBasic", [
            { no: 1, name: "expression", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementAutomationRuleBasic>): AppEntitlementAutomationRuleBasic {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expression = "";
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementAutomationRuleBasic>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementAutomationRuleBasic): AppEntitlementAutomationRuleBasic {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string expression */ 1:
                    message.expression = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementAutomationRuleBasic, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string expression = 1; */
        if (message.expression !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.expression);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementAutomationRuleBasic
 */
export const AppEntitlementAutomationRuleBasic = new AppEntitlementAutomationRuleBasic$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementAutomationLastRunStatus$Type extends MessageType<AppEntitlementAutomationLastRunStatus> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementAutomationLastRunStatus", [
            { no: 1, name: "last_completed_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "status", kind: "enum", T: () => ["c1.api.app.v1.AppEntitlementAutomationRunStatus", AppEntitlementAutomationRunStatus, "APP_ENTITLEMENT_AUTOMATION_RUN_STATUS_"], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementAutomationLastRunStatus>): AppEntitlementAutomationLastRunStatus {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.status = 0;
        message.errorMessage = "";
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementAutomationLastRunStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementAutomationLastRunStatus): AppEntitlementAutomationLastRunStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp last_completed_at */ 1:
                    message.lastCompletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastCompletedAt);
                    break;
                case /* c1.api.app.v1.AppEntitlementAutomationRunStatus status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string error_message */ 3:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementAutomationLastRunStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp last_completed_at = 1; */
        if (message.lastCompletedAt)
            Timestamp.internalBinaryWrite(message.lastCompletedAt, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppEntitlementAutomationRunStatus status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string error_message = 3; */
        if (message.errorMessage !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementAutomationLastRunStatus
 */
export const AppEntitlementAutomationLastRunStatus = new AppEntitlementAutomationLastRunStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementAutomation$Type extends MessageType<AppEntitlementAutomation> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementAutomation", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "512" } } } },
            { no: 7, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } },
            { no: 100, name: "none", kind: "message", oneof: "conditions", T: () => AppEntitlementAutomationRuleNone },
            { no: 101, name: "entitlements", kind: "message", oneof: "conditions", T: () => AppEntitlementAutomationRuleEntitlement },
            { no: 102, name: "cel", kind: "message", oneof: "conditions", T: () => AppEntitlementAutomationRuleCEL },
            { no: 103, name: "basic", kind: "message", oneof: "conditions", T: () => AppEntitlementAutomationRuleBasic },
            { no: 8, name: "last_run_status", kind: "message", T: () => AppEntitlementAutomationLastRunStatus, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "App Entitlement Automation" } }] } });
    }
    create(value?: PartialMessage<AppEntitlementAutomation>): AppEntitlementAutomation {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.displayName = "";
        message.description = "";
        message.conditions = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementAutomation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementAutomation): AppEntitlementAutomation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 5:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* string display_name */ 6:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 7:
                    message.description = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementAutomationRuleNone none */ 100:
                    message.conditions = {
                        oneofKind: "none",
                        none: AppEntitlementAutomationRuleNone.internalBinaryRead(reader, reader.uint32(), options, (message.conditions as any).none)
                    };
                    break;
                case /* c1.api.app.v1.AppEntitlementAutomationRuleEntitlement entitlements */ 101:
                    message.conditions = {
                        oneofKind: "entitlements",
                        entitlements: AppEntitlementAutomationRuleEntitlement.internalBinaryRead(reader, reader.uint32(), options, (message.conditions as any).entitlements)
                    };
                    break;
                case /* c1.api.app.v1.AppEntitlementAutomationRuleCEL cel */ 102:
                    message.conditions = {
                        oneofKind: "cel",
                        cel: AppEntitlementAutomationRuleCEL.internalBinaryRead(reader, reader.uint32(), options, (message.conditions as any).cel)
                    };
                    break;
                case /* c1.api.app.v1.AppEntitlementAutomationRuleBasic basic */ 103:
                    message.conditions = {
                        oneofKind: "basic",
                        basic: AppEntitlementAutomationRuleBasic.internalBinaryRead(reader, reader.uint32(), options, (message.conditions as any).basic)
                    };
                    break;
                case /* c1.api.app.v1.AppEntitlementAutomationLastRunStatus last_run_status */ 8:
                    message.lastRunStatus = AppEntitlementAutomationLastRunStatus.internalBinaryRead(reader, reader.uint32(), options, message.lastRunStatus);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementAutomation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* google.protobuf.Timestamp created_at = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 5; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string display_name = 6; */
        if (message.displayName !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.displayName);
        /* string description = 7; */
        if (message.description !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.description);
        /* c1.api.app.v1.AppEntitlementAutomationLastRunStatus last_run_status = 8; */
        if (message.lastRunStatus)
            AppEntitlementAutomationLastRunStatus.internalBinaryWrite(message.lastRunStatus, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppEntitlementAutomationRuleNone none = 100; */
        if (message.conditions.oneofKind === "none")
            AppEntitlementAutomationRuleNone.internalBinaryWrite(message.conditions.none, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppEntitlementAutomationRuleEntitlement entitlements = 101; */
        if (message.conditions.oneofKind === "entitlements")
            AppEntitlementAutomationRuleEntitlement.internalBinaryWrite(message.conditions.entitlements, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppEntitlementAutomationRuleCEL cel = 102; */
        if (message.conditions.oneofKind === "cel")
            AppEntitlementAutomationRuleCEL.internalBinaryWrite(message.conditions.cel, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppEntitlementAutomationRuleBasic basic = 103; */
        if (message.conditions.oneofKind === "basic")
            AppEntitlementAutomationRuleBasic.internalBinaryWrite(message.conditions.basic, writer.tag(103, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementAutomation
 */
export const AppEntitlementAutomation = new AppEntitlementAutomation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddAutomationExclusionRequest$Type extends MessageType<AddAutomationExclusionRequest> {
    constructor() {
        super("c1.api.app.v1.AddAutomationExclusionRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<AddAutomationExclusionRequest>): AddAutomationExclusionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.userIds = [];
        if (value !== undefined)
            reflectionMergePartial<AddAutomationExclusionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddAutomationExclusionRequest): AddAutomationExclusionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* repeated string user_ids */ 3:
                    message.userIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AddAutomationExclusionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* repeated string user_ids = 3; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.userIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AddAutomationExclusionRequest
 */
export const AddAutomationExclusionRequest = new AddAutomationExclusionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddAutomationExclusionResponse$Type extends MessageType<AddAutomationExclusionResponse> {
    constructor() {
        super("c1.api.app.v1.AddAutomationExclusionResponse", []);
    }
    create(value?: PartialMessage<AddAutomationExclusionResponse>): AddAutomationExclusionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AddAutomationExclusionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddAutomationExclusionResponse): AddAutomationExclusionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AddAutomationExclusionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AddAutomationExclusionResponse
 */
export const AddAutomationExclusionResponse = new AddAutomationExclusionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveAutomationExclusionRequest$Type extends MessageType<RemoveAutomationExclusionRequest> {
    constructor() {
        super("c1.api.app.v1.RemoveAutomationExclusionRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<RemoveAutomationExclusionRequest>): RemoveAutomationExclusionRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.userIds = [];
        if (value !== undefined)
            reflectionMergePartial<RemoveAutomationExclusionRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoveAutomationExclusionRequest): RemoveAutomationExclusionRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* repeated string user_ids */ 3:
                    message.userIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoveAutomationExclusionRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* repeated string user_ids = 3; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.userIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.RemoveAutomationExclusionRequest
 */
export const RemoveAutomationExclusionRequest = new RemoveAutomationExclusionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveAutomationExclusionResponse$Type extends MessageType<RemoveAutomationExclusionResponse> {
    constructor() {
        super("c1.api.app.v1.RemoveAutomationExclusionResponse", []);
    }
    create(value?: PartialMessage<RemoveAutomationExclusionResponse>): RemoveAutomationExclusionResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RemoveAutomationExclusionResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoveAutomationExclusionResponse): RemoveAutomationExclusionResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoveAutomationExclusionResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.RemoveAutomationExclusionResponse
 */
export const RemoveAutomationExclusionResponse = new RemoveAutomationExclusionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAutomationExclusionsRequest$Type extends MessageType<ListAutomationExclusionsRequest> {
    constructor() {
        super("c1.api.app.v1.ListAutomationExclusionsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementUserBindingRef }
        ]);
    }
    create(value?: PartialMessage<ListAutomationExclusionsRequest>): ListAutomationExclusionsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<ListAutomationExclusionsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAutomationExclusionsRequest): ListAutomationExclusionsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementUserBindingRef refs */ 6:
                    message.refs.push(AppEntitlementUserBindingRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAutomationExclusionsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        /* repeated c1.api.app.v1.AppEntitlementUserBindingRef refs = 6; */
        for (let i = 0; i < message.refs.length; i++)
            AppEntitlementUserBindingRef.internalBinaryWrite(message.refs[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAutomationExclusionsRequest
 */
export const ListAutomationExclusionsRequest = new ListAutomationExclusionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserWithAppEntitlementUserBindingView$Type extends MessageType<UserWithAppEntitlementUserBindingView> {
    constructor() {
        super("c1.api.app.v1.UserWithAppEntitlementUserBindingView", [
            { no: 1, name: "user", kind: "message", T: () => User },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<UserWithAppEntitlementUserBindingView>): UserWithAppEntitlementUserBindingView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.appUserId = "";
        if (value !== undefined)
            reflectionMergePartial<UserWithAppEntitlementUserBindingView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserWithAppEntitlementUserBindingView): UserWithAppEntitlementUserBindingView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.user.v1.User user */ 1:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 3:
                    message.appEntitlementId = reader.string();
                    break;
                case /* string app_user_id */ 4:
                    message.appUserId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserWithAppEntitlementUserBindingView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.user.v1.User user = 1; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 3; */
        if (message.appEntitlementId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appEntitlementId);
        /* string app_user_id = 4; */
        if (message.appUserId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UserWithAppEntitlementUserBindingView
 */
export const UserWithAppEntitlementUserBindingView = new UserWithAppEntitlementUserBindingView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAutomationExclusionsResponse$Type extends MessageType<ListAutomationExclusionsResponse> {
    constructor() {
        super("c1.api.app.v1.ListAutomationExclusionsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserWithAppEntitlementUserBindingView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListAutomationExclusionsResponse>): ListAutomationExclusionsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListAutomationExclusionsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAutomationExclusionsResponse): ListAutomationExclusionsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.UserWithAppEntitlementUserBindingView list */ 1:
                    message.list.push(UserWithAppEntitlementUserBindingView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAutomationExclusionsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.UserWithAppEntitlementUserBindingView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            UserWithAppEntitlementUserBindingView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAutomationExclusionsResponse
 */
export const ListAutomationExclusionsResponse = new ListAutomationExclusionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddManuallyManagedUsersRequest$Type extends MessageType<AddManuallyManagedUsersRequest> {
    constructor() {
        super("c1.api.app.v1.AddManuallyManagedUsersRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "10", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<AddManuallyManagedUsersRequest>): AddManuallyManagedUsersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.userIds = [];
        if (value !== undefined)
            reflectionMergePartial<AddManuallyManagedUsersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AddManuallyManagedUsersRequest): AddManuallyManagedUsersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* repeated string user_ids */ 3:
                    message.userIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AddManuallyManagedUsersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* repeated string user_ids = 3; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.userIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AddManuallyManagedUsersRequest
 */
export const AddManuallyManagedUsersRequest = new AddManuallyManagedUsersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ManuallyManagedUsersResponse$Type extends MessageType<ManuallyManagedUsersResponse> {
    constructor() {
        super("c1.api.app.v1.ManuallyManagedUsersResponse", [
            { no: 1, name: "failed_users_error_map", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } }
        ]);
    }
    create(value?: PartialMessage<ManuallyManagedUsersResponse>): ManuallyManagedUsersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.failedUsersErrorMap = {};
        if (value !== undefined)
            reflectionMergePartial<ManuallyManagedUsersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ManuallyManagedUsersResponse): ManuallyManagedUsersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* map<string, string> failed_users_error_map */ 1:
                    this.binaryReadMap1(message.failedUsersErrorMap, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap1(map: ManuallyManagedUsersResponse["failedUsersErrorMap"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ManuallyManagedUsersResponse["failedUsersErrorMap"] | undefined, val: ManuallyManagedUsersResponse["failedUsersErrorMap"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.api.app.v1.ManuallyManagedUsersResponse.failed_users_error_map");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: ManuallyManagedUsersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* map<string, string> failed_users_error_map = 1; */
        for (let k of globalThis.Object.keys(message.failedUsersErrorMap))
            writer.tag(1, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.failedUsersErrorMap[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ManuallyManagedUsersResponse
 */
export const ManuallyManagedUsersResponse = new ManuallyManagedUsersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveEntitlementMembershipRequest$Type extends MessageType<RemoveEntitlementMembershipRequest> {
    constructor() {
        super("c1.api.app.v1.RemoveEntitlementMembershipRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<RemoveEntitlementMembershipRequest>): RemoveEntitlementMembershipRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.appUserId = "";
        if (value !== undefined)
            reflectionMergePartial<RemoveEntitlementMembershipRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoveEntitlementMembershipRequest): RemoveEntitlementMembershipRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* string app_user_id */ 3:
                    message.appUserId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoveEntitlementMembershipRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* string app_user_id = 3; */
        if (message.appUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.RemoveEntitlementMembershipRequest
 */
export const RemoveEntitlementMembershipRequest = new RemoveEntitlementMembershipRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveEntitlementMembershipResponse$Type extends MessageType<RemoveEntitlementMembershipResponse> {
    constructor() {
        super("c1.api.app.v1.RemoveEntitlementMembershipResponse", [
            { no: 1, name: "revoke_task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RemoveEntitlementMembershipResponse>): RemoveEntitlementMembershipResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.revokeTaskId = "";
        if (value !== undefined)
            reflectionMergePartial<RemoveEntitlementMembershipResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoveEntitlementMembershipResponse): RemoveEntitlementMembershipResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string revoke_task_id */ 1:
                    message.revokeTaskId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoveEntitlementMembershipResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string revoke_task_id = 1; */
        if (message.revokeTaskId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.revokeTaskId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.RemoveEntitlementMembershipResponse
 */
export const RemoveEntitlementMembershipResponse = new RemoveEntitlementMembershipResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ForceRunDynamicGroupAutomationRequest$Type extends MessageType<ForceRunDynamicGroupAutomationRequest> {
    constructor() {
        super("c1.api.app.v1.ForceRunDynamicGroupAutomationRequest", [
            { no: 1, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ForceRunDynamicGroupAutomationRequest>): ForceRunDynamicGroupAutomationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appEntitlementId = "";
        if (value !== undefined)
            reflectionMergePartial<ForceRunDynamicGroupAutomationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ForceRunDynamicGroupAutomationRequest): ForceRunDynamicGroupAutomationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_entitlement_id */ 1:
                    message.appEntitlementId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ForceRunDynamicGroupAutomationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_entitlement_id = 1; */
        if (message.appEntitlementId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appEntitlementId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ForceRunDynamicGroupAutomationRequest
 */
export const ForceRunDynamicGroupAutomationRequest = new ForceRunDynamicGroupAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ForceRunDynamicGroupAutomationResponse$Type extends MessageType<ForceRunDynamicGroupAutomationResponse> {
    constructor() {
        super("c1.api.app.v1.ForceRunDynamicGroupAutomationResponse", []);
    }
    create(value?: PartialMessage<ForceRunDynamicGroupAutomationResponse>): ForceRunDynamicGroupAutomationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ForceRunDynamicGroupAutomationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ForceRunDynamicGroupAutomationResponse): ForceRunDynamicGroupAutomationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ForceRunDynamicGroupAutomationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ForceRunDynamicGroupAutomationResponse
 */
export const ForceRunDynamicGroupAutomationResponse = new ForceRunDynamicGroupAutomationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchFilter$Type extends MessageType<AppEntitlementSearchFilter> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchFilter", [
            { no: 12, name: "app_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "500" } } } }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementSearchFilter>): AppEntitlementSearchFilter {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appEntitlementRefs = [];
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementSearchFilter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementSearchFilter): AppEntitlementSearchFilter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs */ 12:
                    message.appEntitlementRefs.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementSearchFilter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 12; */
        for (let i = 0; i < message.appEntitlementRefs.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.appEntitlementRefs[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchFilter
 */
export const AppEntitlementSearchFilter = new AppEntitlementSearchFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementUserBindingSearchFilter$Type extends MessageType<AppEntitlementUserBindingSearchFilter> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementUserBindingSearchFilter", [
            { no: 1, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementUserBindingRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "500" } } } },
            { no: 2, name: "app_user_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 3, name: "exclude_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementUserBindingRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "500" } } } }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementUserBindingSearchFilter>): AppEntitlementUserBindingSearchFilter {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.refs = [];
        message.appUserRefs = [];
        message.excludeRefs = [];
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementUserBindingSearchFilter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementUserBindingSearchFilter): AppEntitlementUserBindingSearchFilter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementUserBindingRef refs */ 1:
                    message.refs.push(AppEntitlementUserBindingRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.app.v1.AppUserRef app_user_refs */ 2:
                    message.appUserRefs.push(AppUserRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementUserBindingRef exclude_refs */ 3:
                    message.excludeRefs.push(AppEntitlementUserBindingRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementUserBindingSearchFilter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementUserBindingRef refs = 1; */
        for (let i = 0; i < message.refs.length; i++)
            AppEntitlementUserBindingRef.internalBinaryWrite(message.refs[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.AppUserRef app_user_refs = 2; */
        for (let i = 0; i < message.appUserRefs.length; i++)
            AppUserRef.internalBinaryWrite(message.appUserRefs[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.AppEntitlementUserBindingRef exclude_refs = 3; */
        for (let i = 0; i < message.excludeRefs.length; i++)
            AppEntitlementUserBindingRef.internalBinaryWrite(message.excludeRefs[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementUserBindingSearchFilter
 */
export const AppEntitlementUserBindingSearchFilter = new AppEntitlementUserBindingSearchFilter$Type();
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppEntitlements
 */
export const AppEntitlements = new ServiceType("c1.api.app.v1.AppEntitlements", [
    { name: "Create", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/entitlements", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Custom App Entitlement" }], group: "App Entitlement" }] } }, I: CreateAppEntitlementRequest, O: CreateAppEntitlementResponse },
    { name: "Get", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/entitlements/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Custom App Entitlement", optionalExclusion: "OPTIONAL_EXCLUSION_RESOURCE_ONLY" }], group: "App Entitlement" }] } }, I: GetAppEntitlementRequest, O: GetAppEntitlementResponse },
    { name: "BulkGet", options: { "authz.method": { role: "VIEWER" } }, I: BulkGetAppEntitlementsRequest, O: BulkGetAppEntitlementsResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/entitlements", query: { page_size: "page_size", page_token: "page_token" }, group: "App Entitlement" }] } }, I: ListAppEntitlementsRequest, O: ListAppEntitlementsResponse },
    { name: "ListUsers", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/entitlements/{app_entitlement_id}/users", query: { page_size: "page_size", page_token: "page_token" }, terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "AppEntitlementUsers", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "App Entitlement", pagination: { type: "TERRAFORM_ENTITY_PAGINATION_TYPE_CURSOR", inputs: [{ name: "pageToken", type: "TERRAFORM_ENTITY_PAGINATION_INPUT_TYPE_CURSOR" }], outputs: { nextCursor: "$.nextPageToken" } } }] } }, I: ListAppEntitlementUsersRequest, O: ListAppEntitlementUsersResponse },
    { name: "ListForAppUser", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/entitlements/users/{app_user_id}", query: { page_size: "page_size", page_token: "page_token" }, group: "App Entitlement" }] } }, I: ListAppEntitlementsForAppUserRequest, O: ListAppEntitlementsResponse },
    { name: "ListForAppResource", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/entitlements/resource_types/{app_resource_type_id}/resources/{app_resource_id}", query: { page_size: "page_size", page_token: "page_token" }, group: "App Entitlement" }] } }, I: ListAppEntitlementsForAppResourceRequest, O: ListAppEntitlementsResponse },
    { name: "UpdateProvisionerPolicy", options: { "authz.method": { role: "VIEWER" } }, I: UpdateProvisionerPolicyAppEntitlementRequest, O: UpdateAppEntitlementResponse },
    { name: "UpdateDeprovisionerPolicy", options: { "authz.method": { role: "VIEWER" } }, I: UpdateDeprovisionerPolicyAppEntitlementRequest, O: UpdateAppEntitlementResponse },
    { name: "Update", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/entitlements/{entitlement.id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "Custom App Entitlement" }], group: "App Entitlement" }] } }, I: UpdateAppEntitlementRequest, O: UpdateAppEntitlementResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/apps/{app_id}/entitlements/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Custom App Entitlement" }], group: "App Entitlement" }] } }, I: DeleteAppEntitlementRequest, O: DeleteAppEntitlementResponse },
    { name: "DeleteIfManuallyCreated", options: { "authz.method": { role: "EDITOR" } }, I: DeleteAppEntitlementIfManuallyCreatedRequest, O: Empty },
    { name: "CreateAutomation", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/entitlements/{app_entitlement_id}/automation/create", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "App Entitlement Automation" }], group: "App Entitlement Automation" }] } }, I: CreateAutomationRequest, O: CreateAutomationResponse },
    { name: "DeleteAutomation", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/apps/{app_id}/entitlements/{app_entitlement_id}/automation", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "App Entitlement Automation" }], group: "App Entitlement Automation" }] } }, I: DeleteAutomationRequest, O: DeleteAutomationResponse },
    { name: "GetAutomation", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/entitlements/{app_entitlement_id}/automation", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "App Entitlement Automation" }], group: "App Entitlement Automation" }] } }, I: AppEntitlementServiceGetAutomationRequest, O: AppEntitlementServiceGetAutomationResponse },
    { name: "PreviewAutomationCEL", serverStreaming: true, options: { "authz.method": { role: "VIEWER" } }, I: AppEntitlementServicePreviewAutomationCELRequest, O: AppEntitlementServicePreviewAutomationCELResponse },
    { name: "UpdateAutomation", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/entitlements/{app_entitlement_id}/automation/update", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "App Entitlement Automation" }], group: "App Entitlement Automation" }] } }, I: AppEntitlementServiceUpdateAutomationRequest, O: AppEntitlementServiceUpdateAutomationResponse },
    { name: "AddAutomationExclusion", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/entitlements/{app_entitlement_id}/automation/exclusions", group: "App Entitlement Automation Exclusion" }] } }, I: AddAutomationExclusionRequest, O: AddAutomationExclusionResponse },
    { name: "RemoveAutomationExclusion", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/apps/{app_id}/entitlements/{app_entitlement_id}/automation/exclusions", group: "App Entitlement Automation Exclusion" }] } }, I: RemoveAutomationExclusionRequest, O: RemoveAutomationExclusionResponse },
    { name: "ListAutomationExclusions", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/entitlements/{app_entitlement_id}/automation/exclusions", group: "App Entitlement Automation Exclusion" }] } }, I: ListAutomationExclusionsRequest, O: ListAutomationExclusionsResponse },
    { name: "AddManuallyManagedMembers", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/entitlements/{app_entitlement_id}/add-manual-user", group: "App Entitlement" }] } }, I: AddManuallyManagedUsersRequest, O: ManuallyManagedUsersResponse },
    { name: "RemoveEntitlementMembership", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/apps/{app_id}/entitlements/{app_entitlement_id}/remove-membership", group: "App Entitlement" }] } }, I: RemoveEntitlementMembershipRequest, O: RemoveEntitlementMembershipResponse },
    { name: "ForceRunDynamicGroupAutomation", options: { "authz.method": { role: "EDITOR" } }, I: ForceRunDynamicGroupAutomationRequest, O: ForceRunDynamicGroupAutomationResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppEntitlementSearchService
 */
export const AppEntitlementSearchService = new ServiceType("c1.api.app.v1.AppEntitlementSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/entitlements", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "App Entitlement", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }, { type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "App Entitlements", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "App Entitlement", pagination: { type: "TERRAFORM_ENTITY_PAGINATION_TYPE_CURSOR", inputs: [{ name: "pageToken", in: "TERRAFORM_ENTITY_PAGINATION_INPUT_IN_REQUEST_BODY", type: "TERRAFORM_ENTITY_PAGINATION_INPUT_TYPE_CURSOR" }], outputs: { nextCursor: "$.nextPageToken" } } }] } }, I: AppEntitlementSearchServiceSearchRequest, O: AppEntitlementSearchServiceSearchResponse },
    { name: "SearchAppEntitlementsWithExpired", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/entitlements/{app_entitlement_id}/grants", query: { page_size: "page_size", page_token: "page_token" }, group: "App Entitlement" }] } }, I: SearchAppEntitlementsWithExpiredRequest, O: SearchAppEntitlementsWithExpiredResponse },
    { name: "GetAccessProfilesForGrants", options: { "authz.method": { role: "VIEWER" } }, I: GetAccessProfilesForGrantsRequest, O: GetAccessProfilesForGrantsResponse },
    { name: "GetSearchTerms", options: { "authz.method": { role: "VIEWER" } }, I: AppEntitlementSearchServiceSearchTermsRequest, O: AppEntitlementSearchServiceSearchTermsResponse },
    { name: "SearchCount", options: { "authz.method": { role: "VIEWER" } }, I: AppEntitlementSearchServiceSearchCountRequest, O: AppEntitlementSearchServiceSearchCountResponse },
    { name: "SearchExpiringAccessForUser", options: { "authz.method": { role: "VIEWER" } }, I: AppEntitlementSearchServiceSearchExpiringAccessForUserRequest, O: AppEntitlementSearchServiceSearchExpiringAccessForUserResponse },
    { name: "SearchGrants", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/grants", group: "App Entitlement" }] } }, I: AppEntitlementSearchServiceSearchGrantsRequest, O: AppEntitlementSearchServiceSearchGrantsResponse },
    { name: "SearchExpiringAccessForUserCount", options: { "authz.method": { role: "VIEWER" } }, I: AppEntitlementSearchServiceSearchExpiringAccessForUserCountRequest, O: AppEntitlementSearchServiceSearchExpiringAccessForUserCountResponse },
    { name: "CountStandingHighRiskGrants", options: { "authz.method": { role: "EDITOR" } }, I: CountStandingHighRiskGrantsRequest, O: CountStandingHighRiskGrantsResponse },
    { name: "SearchStandingHighRiskGrantsForApps", options: { "authz.method": { role: "EDITOR" } }, I: SearchStandingHighRiskGrantsForAppsRequest, O: SearchStandingHighRiskGrantsForAppsResponse },
    { name: "SearchAncestors", options: { "authz.method": { role: "VIEWER" } }, I: AppEntitlementSearchServiceSearchAncestorsRequest, O: AppEntitlementSearchServiceSearchAncestorsResponse },
    { name: "CountAncestors", options: { "authz.method": { role: "VIEWER" } }, I: AppEntitlementSearchServiceCountAncestorsRequest, O: AppEntitlementSearchServiceCountAncestorsResponse },
    { name: "SearchAppEntitlementsWithOneOwner", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppEntitlementsWithOneOwnerRequest, O: SearchAppEntitlementsWithOneOwnerResponse },
    { name: "SearchAppEntitlementsWithDeactivatedOwner", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppEntitlementsWithDeactivatedOwnerRequest, O: SearchAppEntitlementsWithDeactivatedOwnerResponse },
    { name: "SearchAppEntitlementsWithRevokableForAppUser", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppEntitlementsWithRevokableForAppUserRequest, O: SearchAppEntitlementsWithRevokableForAppUserResponse },
    { name: "SearchAppEntitlementsForAppUser", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/search/apps/{app_id}/entitlements/users/{app_user_id}", query: { page_size: "page_size", page_token: "page_token" }, group: "App Entitlement" }] } }, I: SearchAppEntitlementsForAppUserRequest, O: ListAppEntitlementsResponse },
    { name: "SearchRequestableEntitlementsForUser", options: { "authz.method": { role: "VIEWER" } }, I: SearchRequestableEntitlementsForUserRequest, O: SearchRequestableEntitlementsForUserResponse },
    { name: "RollupEntitlementsWithGrants", options: { "authz.method": { role: "VIEWER" } }, I: RollupEntitlementsWithGrantsRequest, O: RollupEntitlementsWithGrantsResponse },
    { name: "SearchAppEntitlementUserBindingDestinations", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppEntitlementUserBindingDestinationsRequest, O: SearchAppEntitlementUserBindingDestinationsResponse },
    { name: "SearchAppEntitlementUserBindingSources", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppEntitlementUserBindingSourcesRequest, O: SearchAppEntitlementUserBindingSourcesResponse },
    { name: "SearchAppEntitlementCorrelationForAccessProfile", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppEntitlementCorrelationForAccessProfileRequest, O: SearchAppEntitlementCorrelationForAccessProfileResponse },
    { name: "CountGrantsExpiringBefore", options: { "authz.method": { role: "VIEWER" } }, I: CountGrantsExpiringBeforeRequest, O: CountGrantsExpiringBeforeResponse },
    { name: "SearchGrantsExpiringBefore", options: { "authz.method": { role: "VIEWER" } }, I: SearchGrantsExpiringBeforeRequest, O: SearchGrantsExpiringBeforeResponse }
]);
